import React, {
    useState,
    createContext,
    useContext,
    useEffect,
    useRef,
    useCallback,
    useMemo
} from "react";

import LoadingSpinnerImage from "../TaskManagerApp/LoadingSpinnerImage.js";
import MultipleFileUpload from "./MultipleFileUpload.js";
import EntityAssociation from "./EntityAssociation.js";
import RelatedReviews from "./RelatedReviews.js";
import DatePicker from 'react-datepicker';
import { EventEmitter } from "events";
import MedboardPdf from '../MedboardPdf/MedboardPdf.jsx';
import AIChat from '../AIChat/AIChat.js';
import * as FieldTypes from '../Shared/FieldTypes/FieldTypes.js'
import "../TaskManagerApp/App.css";
import "./App.css";
import { datePopperConfig } from "../Shared/datePopperConfig.js";
import RIMSFilter from "../Shared/RIMSFilter.js";
import { ENTITYTYPES }  from '../Shared/EntityTypeIds.js';
import MultiItemAIChatPane from '../Shared/MultiItemAIChatPane.js';


const FileManagerAppContext = createContext();
let debounceTimer = null;
let windowHeight = document.body.scrollHeight;
if (windowHeight == 0) {

    // Does it have a window.parent? (possibly an iframe)
    if (window.parent != null && window.parent != undefined) {
        //console.log("Going to use height from iframe: " + window.parent.scrollHeight);
        windowHeight = window.parent.scrollHeight;
    }
    else {
        //console.log("Going to use default height: 700");
        windowHeight = 700; // default fixed height if cant calculate height automatically
    }
}


const FileManagerApp = () => {

    const [useDummy, setUseDummy] = useState(false);
    const [isSlimVersion, setIsSlimVersion] = useState(window.isSlimVersion);
    const [currentUserId, setCurrentUserId] = useState(window.currentUserId);
    const [userRole, setUserRole] = useState(window.userRole);

    const [currentReference, setCurrentReference] = useState(null);
    const [fileView, setFileView] = useState("table");
    const [menu, setMenu] = useState([]);
    const [selectedMainMenuOption, setSelectedMainMenuOption] = useState("all");
    const [users, setUsers] = useState([]);
    const [references, setReferences] = useState([]);
    const [isLoadingReferences, setIsLoadingReferences] = useState(false);

    const isFirstLoadingReferences = useRef(true);

    const [entityTypeId, setEntityTypeId] = useState(ENTITYTYPES.ReferenceManager);
    const [currentReferencesPage, setCurrentReferencesPage] = useState(1);
    const [hasMoreData, setHasMoreData] = useState(true);
    const [defaultObjectListSortByField, setDefaultObjectListSortByField] = useState("CreatedOn");
    const [defaultObjectListSortByType, setDefaultObjectListSortByType] = useState("ASCENDING");
    const [visibleAddObjectPopup, setVisibleAddObjectPopup] = useState(false);
    const [fileSearchText, setFileSearchText] = useState("");
    const [currentEntityType, setCurrentEntityType] = useState(null);
    const [currentEntityId, setCurrentEntityId] = useState(null);
    const [currentGroupId, setCurrentGroupId] = useState(null);
    const [currentFavorites, setCurrentFavorites] = useState(false);
    const [currentRecent, setCurrentRecent] = useState(false);
    const [currentTrash, setCurrentTrash] = useState(false);
    const [currentDuplicates, setCurrentDuplicates] = useState(false);
    const [countsForMainMenuOptions, setCountsForMainMenuOptions] = useState(null);
    const [objectListSortByField, setObjectListSortByField] = useState(defaultObjectListSortByField);
    const [objectListSortByType, setObjectListSortByType] = useState(defaultObjectListSortByType);
    const [isLoadingReferenceDetails, setIsLoadingReferenceDetails] = useState(false);
    const [errorLoadingReferenceDetails, setErrorLoadingReferenceDetails] = useState(false);
    const [errorCurrentReferenceTitle, setErrorCurrentReferenceTitle] = useState(false);
    const [errorCurrentReferenceAuthors, setErrorCurrentReferenceAuthors] = useState(false);
    const [errorCurrentReferenceJournal, setErrorCurrentReferenceJournal] = useState(false);
    const [errorCurrentReferenceVolumeNumber, setErrorCurrentReferenceVolumeNumber] = useState(false);
    const [errorCurrentReferenceIssueNumber, setErrorCurrentReferenceIssueNumber] = useState(false);
    const [errorCurrentReferencePages, setErrorCurrentReferencePages] = useState(false);
    const [errorCurrentReferenceISSN, setErrorCurrentReferenceISSN] = useState(false);
    const [errorCurrentReferenceSource, setErrorCurrentReferenceSource] = useState(false);
    const [errorCurrentReferenceDoi, setErrorCurrentReferenceDoi] = useState(false);
    const [errorCurrentReferenceUrl, setErrorCurrentReferenceUrl] = useState(false);
    const [errorCurrentReferenceYear, setErrorCurrentReferenceYear] = useState(false);
    const [errorCurrentReferencePublicationType, setErrorCurrentReferencePublicationType] = useState(false);
    const [errorCurrentReferencePublicationDate, setErrorCurrentReferencePublicationDate] = useState(false);
    const [errorCurrentReferenceKeywords, setErrorCurrentReferenceKeywords] = useState(false);
    const [errorCurrentReferenceLanguage, setErrorCurrentReferenceLanguage] = useState(false);
    const [visibleReferenceDetailsTab, setVisibleReferenceDetailsTab] = useState("information");
    const [linkedObjectsList, setLinkedObjectsList] = useState([]);
    const [clearEntitySearchResults, setClearEntitySearchResults] = useState(0);
    const [isShowingDeleteConfirmation, setIsShowingDeleteConfirmation] = useState(false);
    const [isPaneOpen, setIsPaneOpen] = useState(false);
    const [visibleAddFilePopup, setVisibleAddFilePopup] = useState(false);
    const [objectSearchText, setObjectSearchText] = useState("");
    const [addObjectEntityTypesList, setAddObjectEntityTypesList] = useState([]);
    const [fileHasMoreComments, setFileHasMoreComments] = useState(true);
    const [comments, setComments] = useState([]);
    const [commentsPage, setCommentsPage] = useState(0);
    const [showAddGroupForm, setShowAddGroupForm] = useState(false);
    const [newGroupName, setNewGroupName] = useState("");
    const [groups, setGroups] = useState([]);
    const [showEditGroup, setShowEditGroup] = useState(false);
    const [editingGroupName, setEditingGroupName] = useState("");
    const [editingParentGroupId, setEditingParentGroupId] = useState(null);
    const [showErrorRemovingGroup, setShowErrorRemovingGroup] = useState(false);
    const [isRemovingGroup, setIsRemovingGroup] = useState(false);
    const [isRemovingGroupId, setRemovingGroupId] = useState(null);
    const [isSavingReference, setIsSavingReference] = useState(false);
    const [isShowingSaveMessage, setIsShowingSaveMessage] = useState(false);
    const [selectedReferences, setSelectedReferences] = useState([]);
    const [showAddSelectedReferencesToGroupPopup, setShowAddSelectedReferencesToGroupPopup] = useState(false);
    const [showDeleteSelectedReferencesPopup, setShowDeleteSelectedReferencesPopup] = useState(false);
    const [showExportSelectedReferencesPopup, setShowExportSelectedReferencesPopup] = useState(false);
    const [allReferencesSelected, setAllReferencesSelected] = useState(false);
    const [isAddingGroup, setIsAddingGroup] = useState(false);
    const [showErrorAddingGroup, setShowErrorAddingGroup] = useState(false);
    const [isDeletingSingleReference, setIsDeletingSingleReference] = useState(false);
    const [errorDeleting, setErrorDeleting] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [isExporting, setIsExporting] = useState(false);
    const [errorExporting, setErrorExporting] = useState(false);
    const [successExporting, setSuccessExporting] = useState(false);
    const [selectedTags, setSelectedTags] = useState([]);
    const [isChangingFavoriteStatus, setIsChangingFavoriteStatus] = useState(false);
    const [showDeleteFileConfirmation, setShowDeleteFileConfirmation] = useState(false);
    const [showEditGroupPopup, setShowEditGroupPopup] = useState(false);
    const [showCreateGroupPopup, setShowCreateGroupPopup] = useState(false);
    const [isEditingGroupId, setIsEditingGroupId] = useState(false);
    const [selectedParentGroupId, setSelectedParentGroupId] = useState(null);
    const [alreadyReturnedAll, setAlreadyReturnedAll] = useState(false);
    const [showLoadingInsteadOfSelectAllCheckbox, setShowLoadingInsteadOfSelectAllCheckbox] = useState(false);
    const [successDeleting, setSuccessDeleting] = useState(false);
    const [isShowingRecoverMessage, setIsShowingRecoverMessage] = useState(false);
    const [isRecoveringReference, setIsRecoveringReference] = useState(false);
    const [whereAmI, setWhereAmI] = useState("All References");
    const [isFoldersContextMenuVisible, setIsFoldersContextMenuVisible] = useState(false);
    const [selectedParentGroupIdFromContextMenu, setSelectedParentGroupIdFromContextMenu] = useState(null);
    const [showItemContextMenu, setShowItemContextMenu] = useState(false);
    const [tagFilterUpdateTrigger, setTagFilterUpdateTrigger] = useState(0);
    const [isMultiItemAIChatPaneOpen, setIsMultiItemAIChatPaneOpen] = useState(false);
    const [currentRIMSFilters, setCurrentRIMSFilters] = useState(null);
    const [reachedAllowance, setReachedAllowance] = useState(window.reachedAllowance ? window.reachedAllowance : false);
    const [showRefreshLastLoadData, setShowRefreshLastLoadData] = useState(false);



    const folderContextMenuRef = useRef(null);
    const folderContextMenuIconRefs = useRef({});

    let preLoadItemId = window.preloadReferenceId;

    let preLoadItemUrlParamName = "referenceId";

    const entityType = "reference-manager";

    const [isEditingField, setIsEditingField] = useState({
        title: false,
        abstract: false,
        authors: false,
        journal: false,
        volume: false,
        issue: false,
        pages: false,
        issn: false,
        source: false,
        doi: false,
        url: false,
        year: false,
        publicationtype: false,
        publicationdate: false,
        language: false,
        keywords: false,
    });



    useEffect(() => {

        let localCurrentEntityType = null;
        let localCurrentEntityId = null;
        let emptyFileSearchText = "";


        setFileSearchText(emptyFileSearchText);


        if ((localCurrentEntityType == null && window.currentEntityType != "") || (localCurrentEntityId == null && window.currentEntityId != "")) {
            localCurrentEntityType = window.currentEntityType;
            localCurrentEntityId = window.currentEntityId;

            setCurrentEntityType(localCurrentEntityType);
            setCurrentEntityId(localCurrentEntityId);

            //getEntity(localCurrentEntityType, localCurrentEntityId).then((data) => setWhereAmI(data.EntityName));
        }

        // LOAD USERS

        loadUsers();

        // LOAD ENTITIES

        loadEntities();


        // Is there any preloaded item that we need to show immediately? (direct link to view an item)
        if (preLoadItemId) {
            setTimeout(() => {
                loadReferenceDetails(preLoadItemId);
            }, 500);
        }


        // LOAD REFERENCES

        loadReferences({
            localSearch: emptyFileSearchText,
            localSortType: defaultObjectListSortByType,
            localSortBy: defaultObjectListSortByField,
            localEntityType: localCurrentEntityType,
            localEntityId: localCurrentEntityId,
            localGroupId: currentGroupId,
            localFavorites: currentFavorites,
            localRecent: currentRecent,
            localDuplicates: currentDuplicates,
        });


        // LOADS COUNTS FOR MAIN MENU

        loadCountsForMainMenu();

        // LOAD GROUPS

        loadGroups();


    }, []);


    



    // Each time the selectedTags changes we update the list

    const hasMountedSelectedTags = useRef(false);

    useEffect(() => {

        // is it the first load? Dont update this time then
        if (!hasMountedSelectedTags.current) {
            hasMountedSelectedTags.current = true;
            return;
        }


        let currentFilters = {

            localGroupId: currentGroupId,
            localSortBy: defaultObjectListSortByField,
            localSortType: defaultObjectListSortByType,
            localTrash: currentTrash,
            localRecent: currentRecent,
            localFavorites: currentFavorites,
            localDuplicates: currentDuplicates,
        }

        
        loadReferences(currentFilters);


    }, [selectedTags]);






    const currentRequestID = useRef(0);

    //#loadreferences
    const loadReferences = ({
        localEntityType = currentEntityType,
        localEntityId = currentEntityId,
        localSearch = objectSearchText,
        localSortType = objectListSortByType,
        localSortBy = objectListSortByField,
        localGroupId = null,
        localTrash = false,
        localFavorites = false,
        localRecent = false,
        localDuplicates = false,
        nextPage = false,
        returnAll = false,
        selectAll = false,
        localRimsFilters = currentRIMSFilters,

    } = {}) => {

        if (isLoadingReferences) {
            return false;
        }


        if (returnAll) {
            if (alreadyReturnedAll) {
                if(selectAll)
                    selectAllReferences(references);
                return false;
            }
            if(selectAll)
                setShowLoadingInsteadOfSelectAllCheckbox(true);

            setAlreadyReturnedAll(true);
        }
        else
            setAlreadyReturnedAll(false);


        const requestID = ++currentRequestID.current;

        setIsLoadingReferences(true);
        setShowRefreshLastLoadData(false);
        setHasMoreData(true);

        // Updates trash filter (and if true don't use group filter)
        setCurrentTrash(localTrash);

        if (localTrash == true) {
            localGroupId = null;
        }

        // Updates favorites filter
        setCurrentFavorites(localFavorites);


        // updates current GroupId for next calls (next page for example)
        setCurrentGroupId(localGroupId);


        // updates current recent for next calls (next page for example)
        setCurrentRecent(localRecent);


        setCurrentDuplicates(localDuplicates);

        // Updates current sortby and sorttype

        setObjectListSortByType(localSortType);
        setObjectListSortByField(localSortBy);

        // Clear selections if reloading the list entirely
        if (!nextPage) {
            setAllReferencesSelected(false);
            setSelectedReferences([]);
        }


        let local_references = references;
        let local_references_page = currentReferencesPage;

        if (nextPage == false) {
            local_references = [];
            local_references_page = 1;
            setReferences(local_references);
            setSelectedReferences([]);

        } else {
            local_references_page++;
        }


        if (localEntityType == null) localEntityType = "";
        if (localEntityId == null) localEntityId = "";

        // TAGS

        let tagIds = selectedTags.map((tag) => tag.Id).join(",");



        let loadReferencesURL =
            `/umbraco/api/ReferenceManager/References?` +
            `search=${encodeURIComponent(localSearch)}&` +
            `groupId=${encodeURIComponent(localGroupId)}&` +
            `sortBy=${encodeURIComponent(localSortBy)}&` +
            `sortType=${encodeURIComponent(localSortType)}&` +
            `page=${encodeURIComponent(local_references_page)}&` +
            `favorites=${encodeURIComponent(localFavorites)}&` +
            `recent=${encodeURIComponent(localRecent)}&` +
            `trash=${encodeURIComponent(localTrash)}&` +
            `duplicates=${encodeURIComponent(localDuplicates)}&` +
            `tagIds=${encodeURIComponent(tagIds)}&` + 
            `returnAll=${encodeURIComponent(returnAll)}&`;

        if (localRimsFilters) {
            loadReferencesURL += `filter[products]=${encodeURIComponent(localRimsFilters.products?.map(item => item.Id).join(",")) ?? ""}&`;
            loadReferencesURL += `filter[productFamilies]=${encodeURIComponent(localRimsFilters.productFamilies?.map(item => item.Id).join(",")) ?? ""}&`;
            loadReferencesURL += `filter[countries]=${encodeURIComponent(localRimsFilters.countries?.map(item => item.Id).join(",")) ?? ""}&`;
            loadReferencesURL += `filter[certificates]=${encodeURIComponent(localRimsFilters.certificates?.map(item => item.Id).join(",")) ?? ""}&`;
            loadReferencesURL += `filter[operators]=${encodeURIComponent(localRimsFilters.operators?.map(item => item.Id).join(",")) ?? ""}&`;
        }



        let requestOptions = {};

        if (useDummy) {
            loadReferencesURL = `http://localhost:3000/Files?` +
                `entityType=${encodeURIComponent(localEntityType)}&` +
                `entityId=${encodeURIComponent(localEntityId)}&` +
                `search=${encodeURIComponent(localSearch)}&` +
                `sortBy=${encodeURIComponent(localSortBy)}&` +
                `sortType=${encodeURIComponent(localSortType)}&` +
                `page=${encodeURIComponent(local_references_page)}&`;
            requestOptions = {};
        }

        fetch(loadReferencesURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    //setHasMoreData(false);
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {

                // If the number of items is 0 it means there is no more data to retrieve (only for main files, not for requests of subfiles [which have parentTaskId])
                if (data.length == 0) setHasMoreData(false);

                // If it's a "get all remaining pages" then there are no more pages after this
                if (returnAll) setHasMoreData(false);

                // Was it a fetch more request? Then append to files.
                let res = [];
                if (nextPage)
                    res = [...local_references, ...data];
                else
                    res = data;

                setReferences(res);
                setCurrentReferencesPage(local_references_page);

                // Was it a "check all" action on the list?
                if (selectAll) {
                    selectAllReferences(res);
                    setShowLoadingInsteadOfSelectAllCheckbox(false);
                }

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                setShowRefreshLastLoadData(true);
                setHasMoreData(false);
            })
            .finally(() => {
                setIsLoadingReferences(false);
            });
    };



    const loadCountsForMainMenu = () => {

        let loadCountsURL = `/umbraco/api/ReferenceManager/Counts`;

        let requestOptions = {};

        fetch(loadCountsURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {

                if(typeof data == "object" && data.AllReferencesCount)
                    setCountsForMainMenuOptions(data);

            })
            .catch((error) => {

            })
            .finally(() => {

            });


    }




    const loadGroups = () => {

        let loadGroupsURL = `/umbraco/api/ReferenceManager/Groups/?referenceId=`;

        let requestOptions = {};

        fetch(loadGroupsURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {

                // Add expanded flag
                data.map(item => item.Expanded = false);

                setGroups(data);
            })
            .catch((error) => {

            })
            .finally(() => {

            });

    };




    /* Opens the side pane and loads the task details */
    const loadReferenceDetails = (referenceId, e = null) => {

        if (e)
            e.stopPropagation();


        // Change URL to reflect details view
        if (preLoadItemUrlParamName) {
            const url = new URL(window.location);
            url.searchParams.set(preLoadItemUrlParamName, referenceId); // add or update
            window.history.pushState({}, "", url);
        }


        // Clear errors
        setErrorLoadingReferenceDetails(false);


        // Clear search results inside EntityAssociation component (trigger internal useEffect from outside)
        setClearEntitySearchResults(clearEntitySearchResults + 1);


        // Hide delete confirmation if visible
        setIsShowingDeleteConfirmation(false);


        // Hide file delete confirmation if visible
        setShowDeleteFileConfirmation(false);


        // Close all opened popups
        closeAllPopups();


        // Open side pane
        if (!isPaneOpen) togglePane();

        setIsLoadingReferenceDetails(true);

        let loadTaskURL =
            `/umbraco/api/ReferenceManager/Reference?` +
            `id=${encodeURIComponent(referenceId)}&`;

        if (useDummy) {
            loadTaskURL = `http://localhost:3000/File?` + `fileId=${encodeURIComponent(referenceId)}&`;
        }

        fetch(loadTaskURL)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401) {
                        closePane();
                        document.dispatchEvent(new Event("api:unauthorized"));
                    }

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {

                if (data.Id) {
                    let currentReference = data;

                    // This is for the edit doi that can't be edited after having a saved value
                    currentReference.SavedDoi = currentReference.Doi;

                    // Load file details
                    setCurrentReference(currentReference);

                    // Load related entities list
                    if (currentReference.LinkedEntities != null)
                        setLinkedObjectsList(currentReference.LinkedEntities);

                    // Reset details tab back to information
                    setVisibleReferenceDetailsTab("information");
                }

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                setErrorLoadingReferenceDetails(true);
                setCurrentReference(null);
            })
            .finally(() => {
                setIsLoadingReferenceDetails(false);
            });


    };


    /* Toggles the side pane */
    const togglePane = () => {
        setIsPaneOpen(!isPaneOpen);
    };


    const closePane = () => {
        setIsPaneOpen(false);
        setCurrentReference(null);

        if (preLoadItemUrlParamName) {
            const url = new URL(window.location);
            url.searchParams.delete(preLoadItemUrlParamName);
            window.history.pushState({}, "", url);
        }
    };

    const toggleMultiItemAIChatPane = () => {
        setIsMultiItemAIChatPaneOpen(!isMultiItemAIChatPaneOpen);
    }

    const closeMultiItemAIChatPane = () => {
        setIsMultiItemAIChatPaneOpen(false);
    };


    const closeFoldersContextMenu = () => {
        setIsFoldersContextMenuVisible(false);
    }



    const changeObjectListOrderField = (field) => {
        let newOrderByType = "ASCENDING";

        if (field == objectListSortByField) {
            if (objectListSortByType == "ASCENDING") newOrderByType = "DESCENDING";
                setObjectListSortByType(newOrderByType);
        } else {
            setObjectListSortByType("ASCENDING");
            setObjectListSortByField(field);
        }

        loadReferences({
            localSortType: newOrderByType,
            localSortBy: field,
            localTrash: currentTrash,
            localGroupId: currentGroupId,
            localFavorites: currentFavorites,
            localRecent: currentRecent,
            localDuplicates: currentDuplicates,
        });
    };


    const loadEntities = () => {

        // For now, the entities are retrieved by getting the menu and checking which items are "IsSearchable"
        let loadEntitiesURL = "/umbraco/api/TaskManagerApi/Menu?entityType=&entityId=";

        fetch(loadEntitiesURL)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {

                // Set the Entity types that can be used in the create/edit task
                if (addObjectEntityTypesList.length == 0) {
                    let listOfEntities = [];
                    data.Nodes.map((item) => {
                        if (item.IsSearchable) {
                            listOfEntities.push(item);
                        }
                    });

                    setAddObjectEntityTypesList(listOfEntities);
                }
            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
            })
            .finally(() => {
            });

    }



    const readableDate = (inputDate, showYear = false, showTime = false) => {
        //const options = { year: 'numeric', month: 'short', day: 'numeric' };
        //return new Date(inputDate).toLocaleDateString(undefined, options);
        const date = new Date(inputDate);
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]; // To always be in English, not locale dependant
        const month = monthNames[date.getMonth()];
        const day = date.getDate();
        const year = date.getFullYear();
        const time = date.toTimeString().split(' ')[0]; 

        return `${day} ${month}` + (showYear ? ` ${year}` : ``) + (showTime ? ` ${time}` : ``);
    }


    const readableDateUTC = (inputDate, showYear = false, showTime = false) => {
        //const options = { year: 'numeric', month: 'short', day: 'numeric' };
        //return new Date(inputDate).toLocaleDateString(undefined, options);
        const date = new Date(inputDate);
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]; // To always be in English, not locale dependant
        const month = monthNames[date.getMonth()];
        const day = date.getUTCDate();
        const year = date.getUTCFullYear();
        const time = date.toTimeString().split(' ')[0]; 

        return `${day} ${month}` + (showYear ? ` ${year}` : ``) + (showTime ? ` ${time}` : ``);
    }


    /* Returns the user object with the requested id */
    const getUserById = (id) => {

        return users.find((item) => item.Id == id);
    };


    const loadUsers = () => {
        let loadUsersURL = "/umbraco/api/TaskManagerApi/Users";

        if (useDummy)
            loadUsersURL = "http://localhost:3000/Users";

        fetch(loadUsersURL)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {

                // Attribute random color do user circle
                data = data.map((item) => {
                    return {
                        ...item,
                        ["IsItMe"]: item.Id == currentUserId ? true : false
                    };
                });

                setUsers(data);
            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
            });
    };


    const showAddFilePopup = (status) => {

        closeAllPopups();

        if (status === false) {
            setVisibleAddFilePopup(false);
        } else {
            // Clean fields

            // Show add task popup
            setVisibleAddFilePopup(true);
        }
    };


    const doTextSearchObject = ({ localSearch }) => {
        let debouncingTime = 500;
        clearTimeout(debounceTimer);

        debounceTimer = setTimeout(() => {
            loadReferences({ localSearch: localSearch, localTrash: currentTrash, localGroupId: currentGroupId, localFavorites: currentFavorites, localRecent: currentRecent, localDuplicates: currentDuplicates, });
        }, debouncingTime);
    };


    // Method to be called by upload or any other place just to reload items on the list

    const refreshList = () => {
        loadReferences({ localSearch: objectSearchText, localTrash: currentTrash, localGroupId: currentGroupId, localFavorites: currentFavorites, localRecent: currentRecent, localDuplicates: currentDuplicates, });
    }




    /*
     * This method is just static names for entity types that aren't initially fetched when getting the menu like for example "systematic-review-item"
     * */
    const getStaticEntityTypeName = (entityType) => {

        let entityName = "";

        switch (entityType) {
            case "systematic-review-item": entityName = "Systematic Review Item"; break;
            case "product": entityName = "Product Portfolio"; break;
            case "countryregistration": entityName = "Country Registrations"; break;
            case "compliance": entityName = "Compliance Portfolio"; break;
            default: entityName = "";
        }

        return entityName;

    }

    const getEntity = async (EntityType, EntityId) => {

        return new Promise((resolve, reject) => {

            let getEntityURL =
                `/umbraco/api/TaskManagerApi/Entity?` +
                `entityType=${encodeURIComponent(EntityType)}&` +
                `entityId=${encodeURIComponent(EntityId)}&`;

            fetch(getEntityURL)
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 401)
                            document.dispatchEvent(new Event("api:unauthorized"));

                        throw new Error("Network response was not ok");
                    }
                    return response.json();
                })
                .then((data) => {

                    let newLinkedObject = {};

                    if (data.Name != undefined) {
                        newLinkedObject = {
                            EntityName: data.Name,
                            EntityType: data.EntityType,
                            EntityId: data.EntityId,
                            EntityUrl: data.Url,
                            Icon: ""
                        };

                        resolve(newLinkedObject);
                    }

                })
                .catch((error) => {
                    // Handle any errors that occurred during the fetch
                    console.log("error: " + error);
                })
                .finally(() => {
                    resolve(null);
                });

        });


    }



    /*
     * Adds a custom group
     */

    const addGroup = () => {

        if (newGroupName == "")
            return;

        let newGroup = { Name: newGroupName };

        let addGroupURL = "/umbraco/api/ReferenceManager/Group/";

        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(newGroup)
        };


        setIsAddingGroup(true);
        setShowErrorAddingGroup(false);


        fetch(addGroupURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                if (data.Id) {

                    // Add group
                    setGroups([...groups, data]);

                    // clear group name in form
                    setNewGroupName("");

                    // Hide form, show groups list
                    setShowAddGroupForm(false);
                }
                else {
                    setShowErrorAddingGroup(true);
                }
            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setIsAddingGroup(false);
            });






    }


    const clearGroupsEditRemoveAndErrors = () => {

        showEditingGroupName(null);
        setRemovingGroupId(null);
        setShowErrorRemovingGroup(false);
    }






    const showEditingGroupName = (id) => {

        if (id != null) {
            const currentGroupName = groups.find(g => g.Id == id).Name;

            setEditingGroupName(currentGroupName);
        }

    };


    /*
        When in the task view/edit pane, when you click a field this will set edit mode on for that field
    */
    const enableReferenceFormFieldEdit = (field, e) => {
        e.stopPropagation();

        // Set editable field to true and all others to false
        let newObj = Object.keys(isEditingField).reduce((acc, key) => {
            acc[key] = key === field;
            return acc;
        }, {});

        setIsEditingField(newObj);
    };

    /*
        Disable all editable fields in the view/edit form
    */
    const disableAllReferenceFormFieldsEdit = () => {
        let newObj = { ...isEditingField };
        for (let prop in newObj) {
            newObj[prop] = false;
        }
        setIsEditingField(newObj);
    };


    // This method validates if the form field if filled, sets the error message to
    // true for that field and returns false meaning the field is not valid

    const validFormField = (field, errorFunc) => {
        if (field == "") {
            errorFunc(true);
            return false;
        }
        errorFunc(false);
        return true;
    };

    


    const recoverCurrentReference = () => {

        let recoverReferenceURL = "/umbraco/api/ReferenceManager/RecoverReference/?ReferenceId=" + currentReference.Id;

        let requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
        };

        setIsShowingRecoverMessage(false);
        setIsRecoveringReference(true);

        fetch(recoverReferenceURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {

                if (data == true) {

                    setCurrentReference({ ...currentReference, Trash: 0 });

                    // If it recovered means the user is seeing the trash as main list so remove from that list
                    setReferences(references.filter(r => r.Id != currentReference.Id));


                    // Update trashed count in menu
                    loadCountsForMainMenu();

                    setIsShowingRecoverMessage(true);
                }
            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setIsRecoveringReference(false);
            });

    }




    const saveCurrentReference = () => {
        // Validations

        let isValidForm = true;

        setErrorCurrentReferenceTitle(false);
        setErrorCurrentReferenceAuthors(false);
        setErrorCurrentReferenceSource(false);
        setErrorCurrentReferenceYear(false);

        if (!validFormField(currentReference.Title, setErrorCurrentReferenceTitle)) isValidForm = false;
        if (!validFormField(currentReference.Authors, setErrorCurrentReferenceAuthors)) isValidForm = false;
        if (!validFormField(currentReference.Source, setErrorCurrentReferenceSource)) isValidForm = false;
        if (!validFormField(currentReference.Year, setErrorCurrentReferenceYear)) isValidForm = false;
        

        if (!isValidForm) return false;

        setIsSavingReference(true);
        setIsShowingSaveMessage(false);
        disableAllReferenceFormFieldsEdit();

        currentReference.LinkedEntities = linkedObjectsList;
        currentReference.SavedDoi = currentReference.Doi;

        setCurrentReference(currentReference);


        let updateReferenceURL = "/umbraco/api/ReferenceManager/Reference";

        let requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(currentReference)
        };

        if (useDummy) {
            updateReferenceURL = "https://dummyjson.com/products/search?q=dummy";
            requestOptions = {};
        }

        fetch(updateReferenceURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                // Update the task in the existing tasks array
                const updatedReferencesArray = references.map((reference) =>
                    reference.Id === currentReference.Id ? currentReference : reference
                );
                setReferences(updatedReferencesArray);
                setIsShowingSaveMessage(true);
            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setIsSavingReference(false);
            });
    };



    
    const deleteReferences = (id = null) => {

        // The list of referenceIds to delete is either the id from currentReference (single) or the list of selected references from the list (csv)
        let referenceIds = id != null ? id : selectedReferences.join(",");

        let deleteReferencesURL = "/umbraco/api/ReferenceManager/References/?referenceIds=" + referenceIds;

        if (id) {
            setIsDeletingSingleReference(true);
        }
        else {
            setSuccessDeleting(false);
            setIsDeleting(true);
            setErrorDeleting(false);
        }

        let requestOptions = {
            method: "DELETE",
            headers: { "Content-Type": "application/json" },
        };

        fetch(deleteReferencesURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    setErrorDeleting(true);
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                if (data && data.Status == 1 && data.Message == "Success") {

                    // Single ref delete? (coming from currentReference)
                    if (id) {
                        if (currentReference.Trash == 0)
                            setCurrentReference({ ...currentReference, Trash: 1 });
                        else if (currentReference.Deleted == 0)
                            setCurrentReference({ ...currentReference, Trash: 0, Deleted: 1 });
                    }

                    // Either refresh the list (when in duplicates) or just remove the selected ones that were deleted
                    if (selectedMainMenuOption == "duplicates") {
                        refreshList();
                    }
                    else {
                        // Single ref delete? (coming from currentReference)
                        if (id)
                            setReferences(references.filter(r => id != r.Id));
                        else
                            setReferences(references.filter(r => !selectedReferences.includes(r.Id)));
                    }

                    // Update trashed count in menu
                    loadCountsForMainMenu();


                    setSelectedReferences([]);
                    setSuccessDeleting(true);
                    setIsShowingDeleteConfirmation(false);
                }
                else {
                    setErrorDeleting(true);
                }
            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {

                if (id) {
                    setIsDeletingSingleReference(false);
                    setShowItemContextMenu(false);
                }
                else {
                    setIsDeleting(false);
                }

            });


    }





    // When a user clicks outside of any element in the main area
    const handleOutsideClick = (event) => {


        

        if (
            (folderContextMenuRef.current && !folderContextMenuRef.current.contains(event.target)) ||
            !Object.values(folderContextMenuIconRefs.current).some((iconRef) => iconRef.contains(event.target))
        ) {
            // Close task details pane
            closePane();
            closeFoldersContextMenu();
        }

    };


    // Originally: finalWindowHeight = windowHeight + "px"
    // Try this
    let finalWindowHeight = "calc(100vh - 74px)";



    const closeAllPopups = () => {

        setVisibleAddFilePopup(false);
        setShowAddSelectedReferencesToGroupPopup(false);
        setShowDeleteSelectedReferencesPopup(false);
        setShowExportSelectedReferencesPopup(false);

    }


    

    const exportReferences = (type) => {
        

        let referenceIds = selectedReferences.join(",");

        let exportReferencesURL = "/umbraco/api/ReferenceManager/Export/?exportType=" + type + "&referenceIds=" + referenceIds;

        setIsExporting(true);
        setErrorExporting(false);
        setSuccessExporting(false);

        let requestOptions = {
            method: "GET",
        };

        if (type == "excel") {
            requestOptions["headers"] = { 'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' };
        }
        
        if (type === "word") {
            requestOptions["headers"] = { 'Content-Type': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' };
        }


        fetch(exportReferencesURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    setErrorDeleting(true);
                    throw new Error("Network response was not ok");
                }
                return response;
            })
            .then((data) => {

                data.blob().then((blob) => {
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    if (type == "excel") a.download = 'MedboardReferencesExport.xlsx';
                    if (type == "ris") a.download = 'MedboardReferencesExport.ris';
                    if (type == "word") a.download = 'MedboardReferencesExport.docx';
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(url);

                });


            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setIsExporting(false);
            });
            
    }



    const navigateTo = ({ menu, groupId = null }) => {

        if (isLoadingReferences)
            return;


        let defaultFilters = {

            localGroupId: null,
            localSortBy: defaultObjectListSortByField,
            localSortType: defaultObjectListSortByType,
            localTrash: false,
            localRecent: false,
            localFavorites: false,
            localDuplicates: false,
        }

        let whereAmILabel = "";

        setSelectedMainMenuOption(menu);

        if (menu == "all") {
            whereAmILabel = "All References";
        }


        if (menu == "recentlyadded") {
            whereAmILabel = "Recently Added (last 30 days)";
            defaultFilters = { ...defaultFilters, localSortBy: "CreatedOn" };
            defaultFilters = { ...defaultFilters, localSortType: "DESCENDING" };
            defaultFilters = { ...defaultFilters, localRecent: true };
        }


        if (menu == "trash") {
            whereAmILabel = "Trash";
            defaultFilters = { ...defaultFilters, localTrash: true };
            defaultFilters = { ...defaultFilters, localSortBy: "UpdatedOn" };
            defaultFilters = { ...defaultFilters, localSortType: "DESCENDING" };
        }


        if (menu == "favorites") {
            whereAmILabel = "Favorites";
            defaultFilters = { ...defaultFilters, localFavorites: true };
            defaultFilters = { ...defaultFilters, localTrash: false };
            defaultFilters = { ...defaultFilters, localSortBy: "UpdatedOn" };
            defaultFilters = { ...defaultFilters, localSortType: "DESCENDING" };
        }

        if (menu == "duplicates") {
            whereAmILabel = "Duplicates";
            defaultFilters = { ...defaultFilters, localDuplicates: true };
            defaultFilters = { ...defaultFilters, localSortBy: "" }; // it will order by mbri by default to group duplicates
            defaultFilters = { ...defaultFilters, localSortType: "DESCENDING" };
        }


        if (menu == "group") {

            if (groupId != null) {
                let groupName = groups.find((i) => i.Id == groupId).Name;
                whereAmILabel = "Folder: " + groupName;
                defaultFilters = { ...defaultFilters, localGroupId: groupId };
            }
        }

        let res = loadReferences(defaultFilters);

        if (res != false)
            setWhereAmI(whereAmILabel);
            
    }
    
    

    const changeFavoriteStatus = () => {
        
        if (isChangingFavoriteStatus)
            return false;

        let referenceId = currentReference.Id;

        let favoriteReferenceURL = "/umbraco/api/ReferenceManager/Favorites/?referenceId=" + referenceId;

        let requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
        };

        setIsChangingFavoriteStatus(true);

        fetch(favoriteReferenceURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {

                let newFavoriteStatus;
                if (currentReference.Favorite == 1)
                    newFavoriteStatus = 0;
                else
                    newFavoriteStatus = 1;

                // Update counts
                loadCountsForMainMenu();

                setCurrentReference({ ...currentReference, Favorite: newFavoriteStatus });

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
            })
            .finally(() => {
                setIsChangingFavoriteStatus(false);
            });

    }


    const deleteCurrentReferenceFile = () => {

        let referenceId = currentReference.Id;

        let deleteFileURL = "/umbraco/api/ReferenceManager/Upload/?referenceId=" + referenceId;

        let requestOptions = {
            method: "DELETE",
            headers: { "Content-Type": "application/json" },
        };

        fetch(deleteFileURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response;
            })
            .then((data) => {

                // Update reference in list
                setReferences(list =>
                    list.map(item =>
                        item.Id == currentReference.Id ? { ...item, HasPDF: 0 } : item
                    )
                );


                // Update current reference
                setCurrentReference({ ...currentReference, HasPDF: 0 });
                setShowDeleteFileConfirmation(false);
            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
            })
            .finally(() => {
            });

    }







    const drawGroupsDropdown = ({ ignoreIds = [], value = selectedParentGroupId, onChangeFunc = setSelectedParentGroupId, defaultOptionText = "" } = {}) => {

        return (
            <select value={value} onChange={(e) => { onChangeFunc(e.target.value); }} >
                <option value="null">{defaultOptionText}</option>
                {drawGroupsDropdownOptions(null, 0, ignoreIds)}
            </select>

        );
        
    }


    const drawGroupsDropdownOptions = (parent, level, ignoreIds) => {

        const drawName = (groupName) => {

            let name = "";

            for (let i = 0; i < level; i++)
                name += "\u00A0\u00A0\u00A0\u00A0";


            //if(level > 0)
            //    name += "> ";

            name += groupName;

            return name;

        }

        if (ignoreIds == null)
            ignoreIds = [];

        let childGroups = groups.filter(group => !ignoreIds.find(g => g == group.Id)).filter(group => group.ParentId == parent).sort((a, b) => a.Name.localeCompare(b.Name, undefined, { sensitivity: 'base' }));

        if (childGroups.length == 0)
            return;

        return (
                childGroups.map((group, index) => {

                    return (<React.Fragment key={index}><option value={group.Id}>{drawName(group.Name)}</option>{drawGroupsDropdownOptions(group.Id, level + 1, ignoreIds)}</React.Fragment>);

                })

        );
        
    }





    const closeGroupRelatedPopups = () => {

        setShowCreateGroupPopup(false);
        setShowEditGroupPopup(false);

    }




    const addToGroupItemCount = (groupId, valueToAdd) => {

        setGroups(groups.map(group => {

            if (group.Id == groupId)
                group.Count += valueToAdd;
            return group;
        }));
    }

    const deleteFromGroupItemCount = (groupId, valueToAdd) => {

        setGroups(groups.map(group => {

            if (group.Id == groupId)
                group.Count -= valueToAdd;
            return group;
        }));
    }




    const selectAllReferences = (currentReferences) => {

        setAllReferencesSelected(true);
        setSelectedReferences(currentReferences.map(r => r.Id));

    }


    const callbackUpdateTriggerTagFilter = () => {

        setTagFilterUpdateTrigger(tagFilterUpdateTrigger+1);

    }


    const rimsSearchCallback = (filters) => {

        setCurrentRIMSFilters(filters);

        let currentFilters = {

            localGroupId: currentGroupId,
            localSortBy: defaultObjectListSortByField,
            localSortType: defaultObjectListSortByType,
            localTrash: currentTrash,
            localRecent: currentRecent,
            localFavorites: currentFavorites,
            localDuplicates: currentDuplicates,
            localRimsFilters: filters,
        }
        
        loadReferences(currentFilters);

    }




    let globalContext = {};
    // variables
    globalContext.useDummy = useDummy;
    globalContext.isSlimVersion = isSlimVersion;
    globalContext.fileView = fileView;
    globalContext.menu = menu;
    globalContext.entityTypeId = entityTypeId;
    globalContext.selectedMainMenuOption = selectedMainMenuOption;
    globalContext.references = references;
    globalContext.isLoadingReferences = isLoadingReferences;
    globalContext.currentReferencesPage = currentReferencesPage;
    globalContext.hasMoreData = hasMoreData;
    globalContext.defaultObjectListSortByField = defaultObjectListSortByField;
    globalContext.defaultObjectListSortByType = defaultObjectListSortByType;
    globalContext.visibleAddObjectPopup = visibleAddObjectPopup;
    globalContext.fileSearchText = fileSearchText;
    globalContext.currentEntityType = currentEntityType;
    globalContext.currentEntityId = currentEntityId;
    globalContext.currentTrash = currentTrash;
    globalContext.currentGroupId = currentGroupId;
    globalContext.currentFavorites = currentFavorites;
    globalContext.currentRecent = currentRecent;
    globalContext.currentDuplicates = currentDuplicates;
    globalContext.defaultObjectListSortByField = defaultObjectListSortByField;
    globalContext.defaultObjectListSortByType = defaultObjectListSortByType;
    globalContext.objectListSortByField = objectListSortByField;
    globalContext.objectListSortByType = objectListSortByType;
    globalContext.isLoadingReferenceDetails = isLoadingReferenceDetails;
    globalContext.visibleReferenceDetailsTab = visibleReferenceDetailsTab;
    globalContext.currentReference = currentReference;
    globalContext.linkedObjectsList = linkedObjectsList;
    globalContext.isShowingDeleteConfirmation = isShowingDeleteConfirmation;
    globalContext.isPaneOpen = isPaneOpen;
    globalContext.isEditingField = isEditingField;
    globalContext.currentUserId = currentUserId;
    globalContext.objectSearchText = objectSearchText;
    globalContext.addObjectEntityTypesList = addObjectEntityTypesList;
    globalContext.fileHasMoreComments = fileHasMoreComments;
    globalContext.comments = comments;
    globalContext.commentsPage = commentsPage;
    globalContext.showAddGroupForm = showAddGroupForm;
    globalContext.newGroupName = newGroupName;
    globalContext.groups = groups;
    globalContext.showEditGroup = showEditGroup;
    globalContext.isRemovingGroup = isRemovingGroup;
    globalContext.isRemovingGroupId = isRemovingGroupId;
    globalContext.errorCurrentReferenceTitle = errorCurrentReferenceTitle;
    globalContext.errorCurrentReferenceAuthors = errorCurrentReferenceAuthors;
    globalContext.errorCurrentReferenceJournal = errorCurrentReferenceJournal;
    globalContext.errorCurrentReferenceVolumeNumber = errorCurrentReferenceVolumeNumber;
    globalContext.errorCurrentReferenceIssueNumber = errorCurrentReferenceIssueNumber;
    globalContext.errorCurrentReferencePages = errorCurrentReferencePages;
    globalContext.errorCurrentReferenceISSN = errorCurrentReferenceISSN;
    globalContext.errorCurrentReferenceSource = errorCurrentReferenceSource;
    globalContext.errorCurrentReferenceDoi = errorCurrentReferenceDoi;
    globalContext.errorCurrentReferenceUrl = errorCurrentReferenceUrl;
    globalContext.errorCurrentReferenceYear = errorCurrentReferenceYear;
    globalContext.errorCurrentReferencePublicationType = errorCurrentReferencePublicationType;
    globalContext.errorCurrentReferencePublicationDate = errorCurrentReferencePublicationDate;
    globalContext.errorCurrentReferenceKeywords = errorCurrentReferenceKeywords;
    globalContext.errorCurrentReferenceLanguage = errorCurrentReferenceLanguage;
    globalContext.errorLoadingReferenceDetails = errorLoadingReferenceDetails;
    globalContext.isShowingSaveMessage = isShowingSaveMessage;
    globalContext.isSavingReference = isSavingReference;
    globalContext.selectedReferences = selectedReferences;
    globalContext.showAddSelectedReferencesToGroupPopup = showAddSelectedReferencesToGroupPopup;
    globalContext.showDeleteSelectedReferencesPopup = showDeleteSelectedReferencesPopup;
    globalContext.showExportSelectedReferencesPopup = showExportSelectedReferencesPopup;
    globalContext.allReferencesSelected = allReferencesSelected;
    globalContext.showErrorRemovingGroup = showErrorRemovingGroup;
    globalContext.isAddingGroup = isAddingGroup;
    globalContext.showErrorAddingGroup = showErrorAddingGroup;
    globalContext.isDeletingSingleReference = isDeletingSingleReference;
    globalContext.isShowingRecoverMessage = isShowingRecoverMessage;
    globalContext.isRecoveringReference = isRecoveringReference;
    globalContext.errorDeleting = errorDeleting;
    globalContext.isDeleting = isDeleting;
    globalContext.successDeleting = successDeleting;
    globalContext.isExporting = isExporting;
    globalContext.errorExporting = errorExporting;
    globalContext.successExporting = successExporting;
    globalContext.selectedTags = selectedTags;
    globalContext.showDeleteFileConfirmation = showDeleteFileConfirmation;
    globalContext.whereAmI = whereAmI;
    globalContext.editingParentGroupId = editingParentGroupId;
    globalContext.showEditGroupPopup = showEditGroupPopup;
    globalContext.isEditingGroupId = isEditingGroupId;
    globalContext.selectedParentGroupId = selectedParentGroupId;
    globalContext.showCreateGroupPopup = showCreateGroupPopup;
    globalContext.isFoldersContextMenuVisible = isFoldersContextMenuVisible;
    globalContext.selectedParentGroupIdFromContextMenu = selectedParentGroupIdFromContextMenu;
    globalContext.countsForMainMenuOptions = countsForMainMenuOptions;
    globalContext.showLoadingInsteadOfSelectAllCheckbox = showLoadingInsteadOfSelectAllCheckbox;
    globalContext.userRole = userRole;
    globalContext.isMultiItemAIChatPaneOpen = isMultiItemAIChatPaneOpen;
    globalContext.reachedAllowance = reachedAllowance;
    globalContext.showRefreshLastLoadData = showRefreshLastLoadData;

    

    // methods
    globalContext.setUseDummy = setUseDummy;
    globalContext.setIsSlimVersion = setIsSlimVersion;
    globalContext.setFileView = setFileView;
    globalContext.setMenu = setMenu;
    globalContext.setSelectedMainMenuOption = setSelectedMainMenuOption;
    globalContext.setReferences = setReferences;
    globalContext.setIsLoadingReferences = setIsLoadingReferences;
    globalContext.setCurrentFilesPage = setCurrentReferencesPage;
    globalContext.setHasMoreData = setHasMoreData;
    globalContext.setDefaultObjectListSortByField = setDefaultObjectListSortByField;
    globalContext.setDefaultObjectListSortByType = setDefaultObjectListSortByType;
    globalContext.setVisibleAddObjectPopup = setVisibleAddObjectPopup;
    globalContext.setFileSearchText = setFileSearchText;
    globalContext.setCurrentEntityType = setCurrentEntityType;
    globalContext.setCurrentEntityId = setCurrentEntityId;
    globalContext.setDefaultObjectListSortByField = setDefaultObjectListSortByField;
    globalContext.setDefaultObjectListSortByType = setDefaultObjectListSortByType;
    globalContext.setObjectListSortByField = setObjectListSortByField;
    globalContext.setObjectListSortByType = setObjectListSortByType;
    globalContext.objectListSortByField = objectListSortByField;
    globalContext.objectListSortByType = objectListSortByType;
    globalContext.setIsLoadingReferenceDetails = setIsLoadingReferenceDetails;
    globalContext.setVisibleReferenceDetailsTab = setVisibleReferenceDetailsTab;
    globalContext.setCurrentReference = setCurrentReference;
    globalContext.setLinkedObjectsList = setLinkedObjectsList;
    globalContext.setIsShowingDeleteConfirmation = setIsShowingDeleteConfirmation;
    globalContext.setObjectSearchText = setObjectSearchText;
    globalContext.setFileHasMoreComments = setFileHasMoreComments;
    globalContext.setComments = setComments;
    globalContext.setCommentsPage = setCommentsPage;
    globalContext.setShowAddGroupForm = setShowAddGroupForm;
    globalContext.setNewGroupName = setNewGroupName;
    globalContext.setGroups = setGroups;
    globalContext.setRemovingGroupId = setRemovingGroupId;
    globalContext.setIsRemovingGroup = setIsRemovingGroup;
    globalContext.showEditingGroupName = showEditingGroupName;
    globalContext.setEditingGroupName = setEditingGroupName;
    globalContext.disableAllReferenceFormFieldsEdit = disableAllReferenceFormFieldsEdit;
    globalContext.enableReferenceFormFieldEdit = enableReferenceFormFieldEdit;
    globalContext.setErrorCurrentReferenceTitle = setErrorCurrentReferenceTitle;
    globalContext.setErrorCurrentReferenceAuthors = setErrorCurrentReferenceAuthors;
    globalContext.setErrorCurrentReferenceJournal = setErrorCurrentReferenceJournal; 
    globalContext.setErrorCurrentReferenceVolumeNumber = setErrorCurrentReferenceVolumeNumber;
    globalContext.setErrorCurrentReferenceIssueNumber = setErrorCurrentReferenceIssueNumber;
    globalContext.setErrorCurrentReferencePages = setErrorCurrentReferencePages;
    globalContext.setErrorCurrentReferenceISSN = setErrorCurrentReferenceISSN;
    globalContext.setErrorCurrentReferenceSource = setErrorCurrentReferenceSource;
    globalContext.setErrorCurrentReferenceDoi = setErrorCurrentReferenceDoi;
    globalContext.setErrorCurrentReferenceUrl = setErrorCurrentReferenceUrl;
    globalContext.setErrorCurrentReferenceYear = setErrorCurrentReferenceYear;
    globalContext.setErrorCurrentReferencePublicationType = setErrorCurrentReferencePublicationType;
    globalContext.setErrorCurrentReferencePublicationDate = setErrorCurrentReferencePublicationDate;
    globalContext.setErrorCurrentReferenceKeywords = setErrorCurrentReferenceKeywords;
    globalContext.setErrorCurrentReferenceLanguage = setErrorCurrentReferenceLanguage;
    globalContext.setErrorLoadingReferenceDetails = setErrorLoadingReferenceDetails;
    globalContext.validFormField = validFormField;
    globalContext.saveCurrentReference = saveCurrentReference;
    globalContext.recoverCurrentReference = recoverCurrentReference;
    globalContext.setIsShowingSaveMessage = setIsShowingSaveMessage;
    globalContext.setIsSavingReference = setIsSavingReference;
    globalContext.setSelectedReferences = setSelectedReferences;
    globalContext.setShowAddSelectedReferencesToGroupPopup = setShowAddSelectedReferencesToGroupPopup;
    globalContext.setShowDeleteSelectedReferencesPopup = setShowDeleteSelectedReferencesPopup;
    globalContext.setAllReferencesSelected = setAllReferencesSelected;
    globalContext.clearGroupsEditRemoveAndErrors = clearGroupsEditRemoveAndErrors;
    globalContext.setIsAddingGroup = setIsAddingGroup;
    globalContext.setShowErrorAddingGroup = setShowErrorAddingGroup;
    globalContext.setIsDeletingSingleReference = setIsDeletingSingleReference;
    globalContext.setErrorDeleting = setErrorDeleting;
    globalContext.setIsDeleting = setIsDeleting;
    globalContext.setSuccessDeleting = setSuccessDeleting;
    globalContext.setIsShowingRecoverMessage = setIsShowingRecoverMessage;
    globalContext.setIsRecoveringReference = setIsRecoveringReference;
    globalContext.setShowExportSelectedReferencesPopup = setShowExportSelectedReferencesPopup;
    globalContext.setIsExporting = setIsExporting;
    globalContext.setErrorExporting = setErrorExporting;
    globalContext.setSuccessExporting = setSuccessExporting;
    globalContext.setSelectedTags = setSelectedTags;
    globalContext.setWhereAmI = setWhereAmI;
    globalContext.setShowDeleteFileConfirmation = setShowDeleteFileConfirmation;
    globalContext.setEditingParentGroupId = setEditingParentGroupId;
    globalContext.setShowEditGroupPopup = setShowEditGroupPopup;
    globalContext.setIsEditingGroupId = setIsEditingGroupId;
    globalContext.setSelectedParentGroupId = setSelectedParentGroupId;
    globalContext.setShowCreateGroupPopup = setShowCreateGroupPopup;
    globalContext.setIsFoldersContextMenuVisible = setIsFoldersContextMenuVisible;
    globalContext.setSelectedParentGroupIdFromContextMenu = setSelectedParentGroupIdFromContextMenu;
    globalContext.setShowLoadingInsteadOfSelectAllCheckbox = setShowLoadingInsteadOfSelectAllCheckbox;
    globalContext.showItemContextMenu = showItemContextMenu;
    globalContext.setShowRefreshLastLoadData = setShowRefreshLastLoadData;




    // methods not from state
    globalContext.loadReferences = loadReferences;
    globalContext.loadReferenceDetails = loadReferenceDetails;
    globalContext.getUserById = getUserById;
    globalContext.readableDate = readableDate;
    globalContext.readableDateUTC = readableDateUTC;
    globalContext.showAddFilePopup = showAddFilePopup;
    globalContext.closePane = closePane;
    globalContext.changeObjectListOrderField = changeObjectListOrderField;
    globalContext.doTextSearchObject = doTextSearchObject;
    globalContext.getStaticEntityTypeName = getStaticEntityTypeName;
    globalContext.getEntity = getEntity;
    globalContext.addGroup = addGroup;
    globalContext.getUserById = getUserById;
    globalContext.closeAllPopups = closeAllPopups;
    globalContext.deleteReferences = deleteReferences;
    globalContext.exportReferences = exportReferences;
    globalContext.navigateTo = navigateTo;
    globalContext.changeFavoriteStatus = changeFavoriteStatus;
    globalContext.deleteCurrentReferenceFile = deleteCurrentReferenceFile;
    globalContext.isFirstLoadingReferences = isFirstLoadingReferences;
    globalContext.refreshList = refreshList;
    globalContext.drawGroupsDropdown = drawGroupsDropdown;
    globalContext.closeGroupRelatedPopups = closeGroupRelatedPopups;
    globalContext.loadGroups = loadGroups;
    globalContext.addToGroupItemCount = addToGroupItemCount;
    globalContext.deleteFromGroupItemCount = deleteFromGroupItemCount;
    globalContext.setShowItemContextMenu = setShowItemContextMenu;
    globalContext.callbackUpdateTriggerTagFilter = callbackUpdateTriggerTagFilter;
    globalContext.rimsSearchCallback = rimsSearchCallback;
    globalContext.currentRIMSFilters = currentRIMSFilters;
    globalContext.toggleMultiItemAIChatPane = toggleMultiItemAIChatPane;
    globalContext.closeMultiItemAIChatPane = closeMultiItemAIChatPane;




    // props not from state
    globalContext.folderContextMenuRef = folderContextMenuRef;
    globalContext.folderContextMenuIconRefs = folderContextMenuIconRefs;
    globalContext.tagFilterUpdateTrigger = tagFilterUpdateTrigger;

    globalContext.entityType = entityType;








    return (
        <FileManagerAppContext.Provider value={globalContext}>
            <div className="App" onClick={handleOutsideClick} style={{ height: finalWindowHeight }}>
                <div style={{ display: "flex", flexDirection: "row", height: finalWindowHeight }}>
                    {!isSlimVersion && (
                        <>
                            <FileManagerMenu
                                menu={menu}
                                style={{
                                    minWidth: "20%", maxWidth: "20%",
                                    /*marginRight: "20px",*/
                                    /*maxHeight: `calc(100vh - 100px)`,*/
                                    overflowY: "auto",
                                    paddingRight: "10px",
                                    paddingLeft: "10px",
                                    borderLeft: "1px solid #f0f0f0",
                                    borderRight: "1px solid #f0f0f0",
                                }}
                            />
                        </>
                    )}

                    <FileManagerContent style={isSlimVersion ? { flex: 1 } : { paddingLeft: "10px", minWidth: "80%", maxWidth: "80%", }} />
                </div>
            </div>

            <FileDetailsPane />

            <MultiItemAIChatPane globalContext={globalContext} />

            {visibleAddFilePopup && <AddFilePopup />}

            {showAddSelectedReferencesToGroupPopup && <AddSelectedReferencesToGroupPopup />}

            {showDeleteSelectedReferencesPopup && <DeleteSelectedReferencesPopup />}

            {showExportSelectedReferencesPopup && <ExportSelectedReferencesPopup />}

            {showEditGroupPopup && <EditGroupPopup />}

            {showCreateGroupPopup && <CreateGroupPopup /> }


        </FileManagerAppContext.Provider>
    );
};




const EditGroupPopup = () => {

    const AppContext = useContext(FileManagerAppContext);

    const [groupName, setGroupName] = useState("");
    const [groupParentId, setGroupParentId] = useState("");
    const [showErrorEditingGroup, setShowErrorEditingGroup] = useState(false);
    const [isEditingGroup, setIsEditingGroup] = useState(false);
    const [showErrorRemovingGroup, setShowErrorRemovingGroup] = useState(false);
    const [isRemovingGroup, setIsRemovingGroup] = useState(false);
    const [showRemoveConfirmation, setShowRemoveConfirmation] = useState(false);
    const [customErrorMessage, setCustomErrorMessage] = useState(null);


    let group = AppContext.groups.find(group => group.Id == AppContext.isEditingGroupId);


    const clearLoadingsAndErrors = () => {
        setIsEditingGroup(false);
        setShowErrorEditingGroup(false);
        setIsRemovingGroup(false);
        setShowErrorRemovingGroup(false);
        setShowRemoveConfirmation(false);
        setCustomErrorMessage(null);
    }


    useEffect(() => {
        clearLoadingsAndErrors();
        setGroupName(group.Name);
        setGroupParentId(group.ParentId);
        AppContext.setSelectedParentGroupId("" + group.ParentId);

    }, [group])


    /*
     * Edit a custom group
     */

    const editGroup = (id) => {

        let newName = groupName;

        let editGroupURL = "/umbraco/api/ReferenceManager/Group/";

        let parentGroupId = null;

        if (!isNaN(AppContext.selectedParentGroupId))
            parentGroupId = parseInt(AppContext.selectedParentGroupId);

        let data = {
            Id: id,
            Name: newName,
            ParentId: parentGroupId
        }

        const requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data)
        };

        clearErrors();
        setIsEditingGroup(true);


        fetch(editGroupURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    setShowErrorEditingGroup(true);
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                if (data.Id) {
                    // Create a new array with the edited item
                    const newGroups = AppContext.groups.map((item) => item.Id === id ? { ...item, Name: data.Name, ParentId: data.ParentId } : item);

                    // Update the state with the new array
                    AppContext.setGroups(newGroups);
                    AppContext.setShowEditGroupPopup(false);
                }
                else {
                    setShowErrorEditingGroup(true);

                    if (data == -1)
                        setCustomErrorMessage("Can't set the parent folder to a child of its own");
                }
            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setIsEditingGroup(false);
            });






    };



    const clearErrors = () => {

        setShowErrorRemovingGroup(false);
        setShowErrorEditingGroup(false);

    }




    /*
     * Remove a custom group
     */

    const removeGroup = (id) => {

        let group = AppContext.groups.find(g => g.Id == id);

        let removeGroupURL = "/umbraco/api/ReferenceManager/Group/?groupId=" + encodeURIComponent(id);

        const requestOptions = {
            method: "DELETE",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(group)
        };

        clearErrors();
        setIsRemovingGroup(true);
        setCustomErrorMessage(null);


        fetch(removeGroupURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    setShowErrorRemovingGroup(true);
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {

                if (data == true) {
                    const newGroups = AppContext.groups.filter((item) => item.Id !== id);
                    AppContext.setGroups(newGroups);
                    AppContext.setShowEditGroupPopup(false);
                }
                else {
                    setShowErrorRemovingGroup(true);

                    if (data == -1)
                        setCustomErrorMessage("Cannot remove folder that has sub-folders");
                }
            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                setShowErrorRemovingGroup(true);
                console.log("error: " + error);
            })
            .finally(() => {
                setIsRemovingGroup(false);
            });



    }







    return (
        <div className="add-task-popup" style={{width: "500px"}}>
            <div style={{ display: "flex", flexDirection: "row", marginBottom: "5px" }}>


                <div style={{ flex: 1 }}>
                    <h3>Editing folder `{group.Name}`</h3>
                </div>
                <div style={{ textAlign: "right" }}>
                    <button
                        className="close-button"
                        onClick={() => { AppContext.setShowEditGroupPopup(false); }}
                    >
                        <i className="fas fa-times"></i>
                    </button>
                </div>

            </div>

            <div style={{ textAlign: "left", marginTop: "25px", marginBottom: "25px" }}>

                <div>Parent folder:</div>
                <div>
                    {AppContext.drawGroupsDropdown({ignoreIds: [group.Id]})}
                </div>
                <div style={{ marginTop: "15px" }}>
                    Folder name:
                    <br/>
                    <input type="text" style={{ width: "100%" }} value={groupName} onChange={(e) => setGroupName(e.target.value)} />
                </div>

                {(showErrorEditingGroup || showErrorRemovingGroup) &&
                    <div style={{ marginTop: "15px" }}>
                        An error occurred
                        {customErrorMessage != null ? <div>{customErrorMessage}</div> : null}
                    </div>
                }

                <div style={{ marginTop: "15px", display: "flex", flexDirection: "row" }}>
                    <div style={{ flex: 1, justifyContent: "start", display: "flex" }}>
                        {!isEditingGroup ?
                            <button onClick={() => editGroup(group.Id)} className="action-button save-button">Save</button>
                            : <LoadingSpinnerImage />
                        }
                    </div>
                    <div style={{ flex: 1, justifyContent: "end", display: "flex" }}>

                        {showRemoveConfirmation ? <>
                            {!isRemovingGroup ?
                                <button onClick={() => removeGroup(group.Id)} className="action-button delete-button">Yes, delete</button>
                                : <LoadingSpinnerImage />
                            }
                        </> : <>
                            <button onClick={() => setShowRemoveConfirmation(true)} className="action-button delete-button">Delete</button>
                        </>}

                    </div>
                </div>

            </div>

        </div>
    );
}













const CreateGroupPopup = () => {

    const AppContext = useContext(FileManagerAppContext);

    const [groupName, setGroupName] = useState("");
    const [groupParentId, setGroupParentId] = useState(null);
    const [showErrorCreatingGroup, setShowErrorCreatingGroup] = useState(false);
    const [isCreatingGroup, setIsCreatingGroup] = useState(false);


    /*
     * Create a custom group
     */

    const createGroup = () => {

        let newName = groupName;

        let editGroupURL = "/umbraco/api/ReferenceManager/Group/";

        let parentGroupId = null;

        if (AppContext.selectedParentGroupIdFromContextMenu) {
            parentGroupId = parseInt(AppContext.selectedParentGroupIdFromContextMenu);
        }
        else
            if (!isNaN(AppContext.selectedParentGroupId))
                parentGroupId = parseInt(AppContext.selectedParentGroupId);

        let data = {
            Name: newName,
            ParentId: parentGroupId
        }

        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data)
        };

        setShowErrorCreatingGroup(false);
        setIsCreatingGroup(true);


        fetch(editGroupURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    setShowErrorCreatingGroup(true);
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                if (data.Id) {
                    // Update the state with the new array
                    AppContext.setGroups([...AppContext.groups, data]);
                    setIsCreatingGroup(false);
                    AppContext.setShowCreateGroupPopup(false);
                }
                else {
                    setShowErrorCreatingGroup(true);
                }
            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setIsCreatingGroup(false);
            });






    };




    return (
        <div className="add-task-popup" style={{ width: "500px" }}>
            <div style={{ display: "flex", flexDirection: "row", marginBottom: "5px" }}>


                <div style={{ flex: 1 }}>
                    <h3>Add a new folder</h3>
                </div>
                <div style={{ textAlign: "right" }}>
                    <button
                        className="close-button"
                        onClick={() => { AppContext.setShowCreateGroupPopup(false); }}
                    >
                        <i className="fas fa-times"></i>
                    </button>
                </div>

            </div>

            <div style={{ textAlign: "left", marginTop: "25px", marginBottom: "25px" }}>

                <div>Parent folder:</div>
                <div>
                    {AppContext.drawGroupsDropdown()}
                </div>
                <div style={{ marginTop: "15px" }}>
                    Folder name:
                    <br/>
                    <input type="text" style={{ width: "100%" }} value={groupName} onChange={(e) => setGroupName(e.target.value)} />
                </div>

                {showErrorCreatingGroup &&
                    <div style={{ marginTop: "15px" }}>
                        An unexpected error occurred
                    </div>
                }

                <div style={{ marginTop: "15px" }}>
                    {!isCreatingGroup ?
                        <button onClick={() => createGroup()} className="action-button save-button">Save</button>
                        : <LoadingSpinnerImage />
                    }
                </div>

            </div>

        </div>
    );
}











const DeleteSelectedReferencesPopup = () => {

    const AppContext = useContext(FileManagerAppContext);

    let isInTrashMenu = AppContext.selectedMainMenuOption == "trash";


    return (
        <div className="add-task-popup">
            <div style={{ display: "flex", flexDirection: "row", marginBottom: "5px" }}>


                <div style={{ flex: 1 }}>
                    {isInTrashMenu ? 
                        <h3>Permanently delete {AppContext.selectedReferences.length ? AppContext.selectedReferences.length + " ": " " }selected reference(s)</h3>
                    : 
                        <h3>Move {AppContext.selectedReferences.length ? AppContext.selectedReferences.length + " ": " " }selected reference(s) to trash</h3>
                    }
                </div>
                <div style={{ textAlign: "right" }}>
                    <button
                        className="close-button"
                        onClick={() => { AppContext.setShowDeleteSelectedReferencesPopup(false); }}
                    >
                        <i className="fas fa-times"></i>
                    </button>
                </div>

            </div>

            <div style={{ textAlign: "center", marginTop: "25px", marginBottom: "25px" }}>

                {AppContext.selectedReferences.length > 0 && <>

                    <div style={{ marginBottom: "15px" }}>
                        {isInTrashMenu ? 
                                <div>Are you sure you want to permanently delete the following references from your Reference Manager?</div>
                            : 
                                <div>Are you sure you want to move the following references to the trash?</div>
                            }
                    </div>
                    

                    <div className="thin-scrollbar" style={{ maxHeight: "250px", overflowY: "auto" }}>

                        {AppContext.references.filter(r => AppContext.selectedReferences.includes(r.Id)).map((r, index) => (

                            <div key={index} style={{ marginBottom: "10px", padding: "5px", backgroundColor: "#f2f2f2" }}>
                                {r.Title}
                            </div>

                        ))}

                    </div>

                    <br />

                </>}

                

                <div style={{ marginTop: "15px" }}>

                    {AppContext.isDeleting ? <>

                        <LoadingSpinnerImage />

                    </> : <>

                            {AppContext.errorDeleting && <>
                                <div style={{ marginBottom: "15px" }}>
                                    An error occurred. Please try again
                                </div>
                            </>}

                            {AppContext.successDeleting ? <>
                                <div style={{ marginBottom: "15px" }}>
                                    {isInTrashMenu ? 
                                        <div>The references were permanently deleted from the Reference Manager</div>
                                    : 
                                        <div>The references were moved to the trash</div>
                                    }
                                </div>
                            </> : <>

                                <div>
                                        <button className="action-button delete-button" onClick={() => AppContext.deleteReferences()}>{isInTrashMenu ? "Permanently delete references" : "Move references to trash"}</button>
                                </div>

                            </>
                        
                        }

                    </>}

                </div>

            </div>

        </div>
    );

}




const ExportSelectedReferencesPopup = () => {


    const AppContext = useContext(FileManagerAppContext);


    return (
        <div className="add-task-popup">
            <div style={{ display: "flex", flexDirection: "row", marginBottom: "5px" }}>


                <div style={{ flex: 1 }}>
                    <h3>Export {AppContext.selectedReferences.length ? AppContext.selectedReferences.length + " " : " "}selected reference(s)</h3>
                </div>
                <div style={{ textAlign: "right" }}>
                    <button
                        className="close-button"
                        onClick={() => { AppContext.setShowExportSelectedReferencesPopup(false); }}
                    >
                        <i className="fas fa-times"></i>
                    </button>
                </div>

            </div>

            <div style={{ textAlign: "center", marginTop: "25px", marginBottom: "25px" }}>

                {AppContext.selectedReferences.length > 0 && <>

                    <div style={{ marginBottom: "15px" }}>
                        You are about to export the following references:
                    </div>


                    <div className="thin-scrollbar" style={{ maxHeight: "250px", overflowY: "auto" }}>

                        {AppContext.references.filter(r => AppContext.selectedReferences.includes(r.Id)).map((r, index) => (

                            <div key={index} style={{ marginBottom: "10px", padding: "5px", backgroundColor: "#f2f2f2" }}>
                                {r.Title}
                            </div>

                        ))}

                    </div>

                    <br />

                </>}



                <div style={{ marginTop: "15px" }}>

                    {AppContext.isExporting ? <>

                        <LoadingSpinnerImage />

                    </> : <>

                        {AppContext.errorExporting && <>
                            <div style={{ marginBottom: "15px" }}>
                                An error occurred. Please try again
                            </div>
                        </>}

                        {AppContext.successExporting ? <>
                            <div style={{ marginBottom: "15px" }}>
                                The references were exported from the Reference Manager
                            </div>
                        </> : <>

                                    <div style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "center" }}>
                                        <div>
                                            <button className="action-button save-button" onClick={() => AppContext.exportReferences("excel")}>Export to Excel</button>
                                        </div>
                                        <div>
                                            <button className="action-button save-button" onClick={() => AppContext.exportReferences("ris")}>Export to RIS</button>
                                        </div>
                                        <div>
                                            <button className="action-button save-button" onClick={() => AppContext.exportReferences("word")}>Export to Word</button>
                                        </div>
                                    </div>


                        </>

                        }

                    </>}

                </div>

            </div>

        </div>
    );

}























const AddSelectedReferencesToGroupPopup = () => {

    const AppContext = useContext(FileManagerAppContext);

    const [selectedGroupId, setSelectedGroupId] = useState("");
    const [isAdding, setIsAdding] = useState(false);
    const [errorAdding, setErrorAdding] = useState(false);
    const [successAdding, setSuccessAdding] = useState(false);


    const handleChangeOption = (groupId) => {

        setSelectedGroupId(groupId);
    }

    const addReferencesToGroup = () => {

        
        let referencesGroupURL = "/umbraco/api/ReferenceManager/ReferenceGroupMapping/";


        setSuccessAdding(false);

        if (selectedGroupId == "")
            return;

        setIsAdding(true);
        setErrorAdding(false);




        let data = {
            ReferenceIds: AppContext.selectedReferences,
            GroupId: parseInt(selectedGroupId)
        }

        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data)
        };



        fetch(referencesGroupURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    setErrorAdding(true);
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                if (data == true) {
                    setSelectedGroupId("");
                    setSuccessAdding(true);

                    //AppContext.loadGroups();

                    AppContext.addToGroupItemCount(selectedGroupId, AppContext.selectedReferences.length);
                }
                else {
                    setErrorAdding(true);
                }
            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setIsAdding(false);
            });












    }


    return (
        <div className="add-task-popup">
            <div style={{ display: "flex", flexDirection: "row", marginBottom: "5px" }}>


                <div style={{ flex: 1 }}>
                    <h3>Add {AppContext.selectedReferences.length ? AppContext.selectedReferences.length + " " : " "}selected reference(s) to a group</h3>
                </div>
                <div style={{ textAlign: "right" }}>
                    <button
                        className="close-button"
                        onClick={() => { AppContext.setShowAddSelectedReferencesToGroupPopup(false); }}
                    >
                        <i className="fas fa-times"></i>
                    </button>
                </div>

            </div>

            <div style={{ textAlign: "center", marginTop: "25px", marginBottom: "25px" }}>

                <div className="thin-scrollbar" style={{ maxHeight: "250px", overflowY: "auto" }}>

                    {AppContext.references.filter(r => AppContext.selectedReferences.includes(r.Id)).map((r, index) => (

                        <div key={index} style={{ marginBottom: "10px", padding: "5px", backgroundColor: "#f2f2f2" }}>
                            {r.Title}
                        </div>

                    ))}

                </div>

                <br/>

                {/*
                <select value={selectedGroupId} onChange={handleChangeOption}>

                    <option value="">- Add reference(s) to a group -</option>

                    {AppContext.groups.map((group, index) =>
                        <option key={index} value={group.Id}>{group.Name}</option>
                    )}

                </select>
                */}

                {AppContext.drawGroupsDropdown({ value: selectedGroupId, onChangeFunc: handleChangeOption, defaultOptionText: "- Add reference(s) to a group -" })}



                <div style={{ marginTop: "15px" }}>

                    {isAdding ? <>

                        <LoadingSpinnerImage />

                    </> : <>

                        {errorAdding && <>
                            <div style={{ marginBottom: "15px" }}>
                                An error occurred. Please try again
                            </div>
                        </>}

                        {successAdding && <>
                            <div style={{ marginBottom: "15px" }}>
                                The references were added to the group
                            </div>
                        </>}

                        <div>
                            <button className="action-button save-button" onClick={addReferencesToGroup}>Add to group</button>
                        </div>

                    </>}

                </div>

                

                

            </div>

            



        </div>
    );

}






const AddFilePopup = () => {
    const AppContext = useContext(FileManagerAppContext);

    return (

        <div style={{position: "fixed", backgroundColor: "rgba(1, 1, 1, 0.5)", height: "100%", width: "100%", top: 0, left: 0, zIndex: 1000, overflowY: "auto" }}>

            <div className="add-task-popup">
                <div style={{ display: "flex", flexDirection: "row", marginBottom: "5px" }}>
                    <div style={{ flex: 1 }}>
                        <h3>Add Reference(s)</h3>
                    </div>
                    <div style={{ textAlign: "right" }}>
                        <button
                            className="close-button"
                            onClick={() => { AppContext.showAddFilePopup(false); }}
                        >
                            <i className="fas fa-times"></i>
                        </button>
                    </div>
                </div>

                <MultipleFileUpload context={FileManagerAppContext} />

            </div>

        </div>
    );
};











/* 
  This draws the task details side pane
*/
//#pane

const FileDetailsPane = () => {
    const AppContext = useContext(FileManagerAppContext);

    const currentReferenceTitleRef = useRef(null);
    const currentReferenceAuthorsRef = useRef(null);
    const currentReferenceJournalRef = useRef(null);
    const currentReferenceVolumeNumberRef = useRef(null);
    const currentReferenceIssueNumberRef = useRef(null);
    const currentReferencePagesRef = useRef(null);
    const currentReferenceISSNRef = useRef(null);
    const currentReferenceSourceRef = useRef(null);
    const currentReferenceDoiRef = useRef(null);
    const currentReferenceUrlRef = useRef(null);
    const currentReferencePublicationTypeRef = useRef(null);
    const currentReferenceKeywordsRef = useRef(null);
    const currentReferenceLanguageRef = useRef(null);
    const contextMenuButton = useRef(null);
    const contextMenu = useRef(null);

    const [itemDetailsPaneActive, setItemDetailsPaneActive] = useState(AppContext.isPaneOpen);
    const [itemDetailsPaneOpenEffect, setItemDetailsPaneOpenEffect] = useState(false);
    const [autoCallOverviewFunction, setAutoCallOverviewFunction] = useState(false);
    const [componentKey, setComponentKey] = useState(0);
    

    const displayDescription = (text) => {

        if (!text)
            text = "";

        text = text.replace(/</g, '&lt;');
        text = text.replace(/\n/g, '<br/>');
        return text;
    };

    // This doesn't do any work, it's only to be compatible with the pdf viewer code
    const firstEmitter = new EventEmitter(); 

    function isNullOrEmpty(value) {
        return value === null || value === undefined || value === '';
    }


    const callAIChat = () => {

        setAutoCallOverviewFunction(true);
        AppContext.setVisibleReferenceDetailsTab("aichat");
        setComponentKey(prevKey => prevKey + 1); // restart AIChat component

    }




    
    // On parent change of the details pane status "restart" the popup
    useEffect(() => {

        AppContext.setVisibleReferenceDetailsTab("information");

        if (AppContext.isPaneOpen == true) {
            // Immediately activate popup, but wait a bit to trigger the open animation
            setItemDetailsPaneActive(true);
            setTimeout(() => { setItemDetailsPaneOpenEffect(true); }, 100);
        }
        else {
            // Immediately do the hide effect but wait 300 to deactivate the popup
            setItemDetailsPaneOpenEffect(false);
            setTimeout(() => { setItemDetailsPaneActive(false); }, 300);
        }

    }, [AppContext.isPaneOpen]);



    
    const reinitialize = () => {
        AppContext.setVisibleReferenceDetailsTab("information");
        setAutoCallOverviewFunction(false);
    }


    useEffect(() => {

        if (itemDetailsPaneActive)
            reinitialize();

    }, [itemDetailsPaneActive]);





    const openContextualMenu = () => {
        AppContext.setShowItemContextMenu(!AppContext.showItemContextMenu);
    };

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (
                contextMenuButton.current &&
                !contextMenuButton.current.contains(e.target) &&
                contextMenu.current &&
                !contextMenu.current.contains(e.target)
            ) {
                AppContext.setShowItemContextMenu(false);
                AppContext.setIsShowingDeleteConfirmation(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);


    useEffect(() => {

        if(!AppContext.isPaneOpen)
            AppContext.setShowItemContextMenu(false);

    }, [AppContext.isPaneOpen])





    let hasPdfFile = AppContext.currentReference != null && AppContext.currentReference.HasPDF == 1;
    let hasAIChat = hasPdfFile;

    let fullWidthPane = hasPdfFile || hasAIChat;

    return (
        <>

            {itemDetailsPaneActive ? 

                <div
                    style={{ height: "100vh", overflow: "auto" }}
                    className={`${fullWidthPane ? "slide-pane-full-width" : "slide-pane"} ${itemDetailsPaneOpenEffect ? "open" : ""}`}
                >
                    <div className="content">

                        {AppContext.errorLoadingReferenceDetails ? <>

                            <div>An error occurred while loading this reference...</div>

                        </> : <>


                            {/* FIELDS AND TABLES */}

                            <div style={{ flex: "1" }}>

                                {(AppContext.currentReference === null || AppContext.isLoadingReferenceDetails) ? (
                                    <>
                                        <LoadingSpinnerImage />
                                    </>
                                ) : (
                                    <>

                                        <div style={{display: "flex", flexDirection: "row"}}>
                                
                                            {/* PDF PANE */}
                                            {/* PDF PANE */}
                                            {/* PDF PANE */}

                                            {hasPdfFile ? <>
                                                <div id="pdf-viewer" style={{ flex: 30, paddingRight: "10px", borderRight: "2px solid #f0f0f0", height: "96vh" }}>

                                                    <div style={{display: "flex", flexDirection: "row", width: "100%"}}>
                                                        <div style={{flex: 1}}>
                                                            <h3>PDF Viewer</h3>
                                                        </div>
                                                        <div style={{ flex: 1, textAlign: "right", marginRight: "50px"}}>
                                                            <div>
                                                                <button onClick={callAIChat} className="medboard-ai-analyzer-button">AI Overview</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                            
                                                    

                                                    {AppContext.currentReference.HasPDF == 1 ? 
                                                        <MedboardPdf
                                                            updater={firstEmitter}
                                                            savedComments={[]}
                                                            url={`/Umbraco/Api/SurveilanceAppraisal/LoadPdf?surveillanceItemId=${AppContext.currentReference.MedBoardResourceId}`} 
                                                            showHighlightsButton={false}
                                                            showAnnotationsButton={false}
                                                            containerHeight={"80vb"}
                                                            />
                                                        :
                                                        <div style={{ marginTop: "15px" }}>No pdf file found</div>
                                                    }
                                                </div>

                                            </> : null}

                                    

                                    
                                            {/* FIELDS PANE */}
                                            {/* FIELDS PANE */}
                                            {/* FIELDS PANE */}

                                            <div id="fields-content" style={{ flex: 20, flexDirection: "column", paddingLeft: "10px", height: "96vh", overflowY: "auto", position: "relative", display: "flex" }}>

                                                <div id="multiple-contents" style={{ flex: 1, overflow: "auto", paddingRight: "15px", display: "flex", flexDirection: "column" }}>

                                            
                                                    <div style={{ display: "flex", flexDirection: "row", marginBottom: "15px"}}>
                                                        <div style={{flex: 1}}>

                                                            <h3>
                                                                {AppContext.userRole == "Admin" ? <>
                                                                    {AppContext.currentReference.Favorite == 1 ?
                                                                        <i onClick={AppContext.changeFavoriteStatus} className="pointer fas fa-star" style={{ color: "#FFD43B" }}></i>
                                                                        :
                                                                        <i onClick={AppContext.changeFavoriteStatus} className="pointer far fa-star"></i>
                                                                    }
                                                                </> : <>
                                                                    {AppContext.currentReference.Favorite == 1 ?
                                                                        <i className="fas fa-star" style={{ color: "#FFD43B" }}></i>
                                                                        :
                                                                        <i className="far fa-star"></i>
                                                                    }
                                                                </>}

                                                                <span style={{ marginLeft: "4px" }}>{AppContext.currentReference.Title}</span>
                                                            </h3>

                                                        </div>


                                                        <div style={{marginRight: "5px"} }>
                                                            <button ref={contextMenuButton} className="close-button" onClick={openContextualMenu}>
                                                                <i className="fas fa-ellipsis-v"></i>
                                                            </button>
                                                        </div>


                                                        <div>
                                                            <button className="close-button" onClick={AppContext.closePane}>
                                                                <i className="fas fa-times"></i>
                                                            </button>
                                                        </div>
                                                    </div>




                                                    {/* TABS */}
                                                    {/* TABS */}
                                                    {/* TABS */}


                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            width: "100%",
                                                            flexDirection: "row",
                                                            marginBottom: "15px"
                                                        }}>

                                                        <div
                                                            style={{
                                                                cursor: "pointer",
                                                                paddingBottom: "3px",
                                                                paddingLeft: "8px",
                                                                paddingRight: "8px",
                                                                ...(AppContext.visibleReferenceDetailsTab == "information"
                                                                    ? { borderBottom: "2px solid #00abff" }
                                                                    : { borderBottom: "2px solid #f0f0f0" })
                                                            }}
                                                            onClick={() => AppContext.setVisibleReferenceDetailsTab("information")}
                                                        >
                                                            <i className="fas fa-info-circle g-mr-5"></i> Information
                                                        </div>


                                                        <div
                                                            style={{
                                                                cursor: "pointer",
                                                                paddingBottom: "3px",
                                                                paddingLeft: "8px",
                                                                paddingRight: "8px",
                                                                ...(AppContext.visibleReferenceDetailsTab == "groups"
                                                                    ? { borderBottom: "2px solid #00abff" }
                                                                    : { borderBottom: "2px solid #f0f0f0" })
                                                            }}
                                                            onClick={() => AppContext.setVisibleReferenceDetailsTab("groups")}
                                                        >
                                                            <i className="far fa-folder g-mr-5"></i> Folders
                                                        </div>


                                                        <div
                                                            style={{
                                                                cursor: "pointer",
                                                                paddingBottom: "3px",
                                                                paddingLeft: "8px",
                                                                paddingRight: "8px",
                                                                ...(AppContext.visibleReferenceDetailsTab == "entities"
                                                                    ? { borderBottom: "2px solid #00abff" }
                                                                    : { borderBottom: "2px solid #f0f0f0" })
                                                            }}
                                                            onClick={() => AppContext.setVisibleReferenceDetailsTab("entities")}
                                                        >
                                                            <i className="fas fa-project-diagram g-mr-5"></i> Linked To
                                                        </div>

                                    
                                                        <div
                                                            style={{
                                                                cursor: "pointer",
                                                                paddingBottom: "3px",
                                                                paddingLeft: "8px",
                                                                paddingRight: "8px",
                                                                ...(AppContext.visibleReferenceDetailsTab == "relatedreviews"
                                                                    ? { borderBottom: "2px solid #00abff" }
                                                                    : { borderBottom: "2px solid #f0f0f0" })
                                                            }}
                                                            onClick={() => AppContext.setVisibleReferenceDetailsTab("relatedreviews")}
                                                        >
                                                            <i className="fas fa-file-signature g-mr-5"></i> Related Reviews
                                                        </div>


                                                        <div
                                                            style={{
                                                                cursor: "pointer",
                                                                display: "none",
                                                                paddingBottom: "3px",
                                                                paddingLeft: "8px",
                                                                paddingRight: "8px",
                                                                ...(AppContext.visibleReferenceDetailsTab == "comments"
                                                                    ? { borderBottom: "2px solid #00abff" }
                                                                    : { borderBottom: "2px solid #f0f0f0" })
                                                            }}
                                                            onClick={() => AppContext.setVisibleReferenceDetailsTab("comments")}
                                                        >
                                                            <i className="fas fa-comments g-mr-5"></i> Comments
                                                        </div>


                                                        <div
                                                            style={{
                                                                cursor: "pointer",
                                                                paddingBottom: "3px",
                                                                paddingLeft: "8px",
                                                                paddingRight: "8px",
                                                                ...(AppContext.visibleReferenceDetailsTab == "aichat"
                                                                    ? { borderBottom: "2px solid #00abff" }
                                                                    : { borderBottom: "2px solid #f0f0f0" })
                                                            }}
                                                            onClick={() => { setAutoCallOverviewFunction(false); AppContext.setVisibleReferenceDetailsTab("aichat"); } }
                                                        >
                                                            <img src="/assets/images/stars-stroke-rounded-solid.svg" className="ai-icon" style={{ width: "19px", marginTop: "-3px", marginRight: "5px" }} /> AI Tools
                                                        </div>



                                                        <div style={{ flex: 1, borderBottom: "2px solid #f0f0f0" }}></div>

                                                    </div>



                                                    {/* CONTENT */}
                                                    {/* CONTENT */}
                                                    {/* CONTENT */}


                                                    <div style={{ display: "flex", flexDirection: "column", flex: 1, justifyContent: "start", overflow: "auto" }}>



                                                        {/* INFORMATION FORMS FIELDS */}

                                                        {AppContext.visibleReferenceDetailsTab == "information" &&

                                                            <div style={{height: "100%", overflow: "auto"}}>

                                                                {/* Form field: Title */}

                                                                <div className="view-task-field">


                                                                    <div className="view-task-field-line">
                                                                        <div className="view-task-field-title">Title</div>
                                                                        <div className="view-task-field-value">


                                                                            {AppContext.currentReference.Trash == true || AppContext.currentReference.Deleted == true ? <>
                                                                                <span>{AppContext.currentReference.Title}</span>
                                                                            </> : <>


                                                                                {AppContext.isEditingField.title === false ? (
                                                                                    <>
                                                                                        <span
                                                                                            title="Edit" 
                                                                                            className={`pointer editable-field-span ${AppContext.errorCurrentReferenceTitle
                                                                                                ? "form-field-error"
                                                                                                : null
                                                                                                }`}

                                                                                            onClick={(e) => {
                                                                                                AppContext.enableReferenceFormFieldEdit("title", e);
                                                                                                setTimeout(() => {
                                                                                                    // We need this timeout because the ref for the edit field isn't immediately available
                                                                                                    currentReferenceTitleRef.current.selectionStart = 0;
                                                                                                    currentReferenceTitleRef.current.selectionEnd = 0;
                                                                                                }, 10);
                                                                                            }
                                                                                            }
                                                                                        >


                                                                                            {AppContext.currentReference.Title == "" || AppContext.currentReference.Title == null ?
                                                                                                <span style={{ color: "#c0c0c0" }}>Add the title</span>
                                                                                                :
                                                                                                <span>{AppContext.currentReference.Title}</span>
                                                                                            }
                                                                
                                                                                            {AppContext.errorCurrentReferenceTitle && (
                                                                                                <span style={{marginLeft: "20px"}} className="form-field-error-message">
                                                                                                    The field Title is necessary
                                                                                                </span>
                                                                                            )}
                                                                                        </span>
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        <span style={{width: "100%"}}>
                                                                                            <input
                                                                                                ref={currentReferenceTitleRef}
                                                                                                style={{ width: "100%" }}
                                                                                                autoFocus
                                                                                                onBlur={() => {
                                                                                                    AppContext.disableAllReferenceFormFieldsEdit();
                                                                                                    AppContext.validFormField(
                                                                                                        AppContext.currentReference.Title,
                                                                                                        AppContext.setErrorCurrentReferenceTitle
                                                                                                    );
                                                                                                }}
                                                                                                onChange={(e) =>
                                                                                                    AppContext.setCurrentReference({
                                                                                                        ...AppContext.currentReference,
                                                                                                        Title: e.target.value
                                                                                                    })
                                                                                                }
                                                                                                value={AppContext.currentReference.Title}
                                                                                            />
                                                                                        </span>
                                                                                    </>
                                                                                )}

                                                                            </>}






                                                                        </div>
                                                                    </div>



                                                                </div>


                                                                {/* Form field: Abstract */}

                                                                <div className="view-task-field">

                                                                    <div className="view-task-field-line">
                                                                        <div className="view-task-field-title">Abstract</div>
                                                                        <div className="view-task-field-value">


                                                                            {AppContext.currentReference.Trash == true || AppContext.currentReference.Deleted == true ? <>
                                                                                <span>{AppContext.currentReference.Abstract}</span>
                                                                            </> : <>



                                                                                {AppContext.isEditingField.abstract === false ? (
                                                                                    <>
                                                                                        <div
                                                                                            title="Edit" 
                                                                                            className={`editable-field-span thin-scrollbar pointer`}
                                                                                            style={{ width: "100%", maxHeight: "300px", overflowY: "auto" }}
                                                                                            onClick={(e) =>
                                                                                                AppContext.enableReferenceFormFieldEdit("abstract", e)
                                                                                            }
                                                                                        >

                                                                                            {AppContext.currentReference.Abstract == "" || AppContext.currentReference.Abstract == null ?
                                                                                                <span style={{ color: "#c0c0c0" }}>Add the abstract</span>
                                                                                                :
                                                                                                <div dangerouslySetInnerHTML={{ __html: displayDescription(AppContext.currentReference.Abstract) }} />
                                                                                            }
                                                                
                                                                                        </div>

                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        <span style={{ width: "100%" }}>
                                                                                            <textarea
                                                                                                style={{ width: "100%", height: "150px" }}
                                                                                                autoFocus
                                                                                                onBlur={() => {
                                                                                                    AppContext.disableAllReferenceFormFieldsEdit();
                                                                                                }}
                                                                                                onChange={(e) =>
                                                                                                    AppContext.setCurrentReference({
                                                                                                        ...AppContext.currentReference,
                                                                                                        Abstract: e.target.value
                                                                                                    })
                                                                                                }
                                                                                                value={AppContext.currentReference.Abstract}
                                                                                            />
                                                                                        </span>
                                                                                        {/*<Trumbowyg data={""} />*/}
                                                                                    </>
                                                                                )}

                                                                            </>}





                                                                        </div>
                                                                    </div>

                                                                </div>


                                                                {/* Form field: Authors */}

                                                                <div className="view-task-field">

                                                                    <div className="view-task-field-line">

                                                                        <div className="view-task-field-title">Authors</div>
                                                                        <div className="view-task-field-value">

                                                                            {AppContext.currentReference.Trash == true || AppContext.currentReference.Deleted == true ? <>
                                                                                <span>{AppContext.currentReference.Authors}</span>
                                                                            </> : <>

                                                                                {AppContext.isEditingField.authors === false ? (
                                                                                    <>
                                                                                        <span
                                                                                            title="Edit" 
                                                                                            className={`pointer editable-field-span ${AppContext.errorCurrentReferenceAuthors
                                                                                                ? "form-field-error"
                                                                                                : null
                                                                                                }`}
                                                                                            onClick={(e) => {
                                                                                                AppContext.enableReferenceFormFieldEdit("authors", e);
                                                                                                setTimeout(() => {
                                                                                                    // We need this timeout because the ref for the edit field isn't immediately available
                                                                                                    currentReferenceAuthorsRef.current.selectionStart = 0;
                                                                                                    currentReferenceAuthorsRef.current.selectionEnd = 0;
                                                                                                }, 10);
                                                                                            }
                                                                                            }
                                                                                                    >



                                                                                            {AppContext.currentReference.Authors == "" || AppContext.currentReference.Authors == null ?
                                                                                                <span style={{ color: "#c0c0c0" }}>Add the authors</span>
                                                                                                :
                                                                                                <span>{AppContext.currentReference.Authors}</span>
                                                                                            }

                                                                                            {AppContext.errorCurrentReferenceAuthors && (
                                                                                                <span style={{ marginLeft: "20px" }} className="form-field-error-message">
                                                                                                    The field Authors is necessary
                                                                                                </span>
                                                                                            )}



                                                                                        </span>
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        <span style={{width: "100%"}}>
                                                                                            <input
                                                                                                ref={currentReferenceAuthorsRef}
                                                                                                style={{ width: "100%" }}
                                                                                                autoFocus
                                                                                                onBlur={() => {
                                                                                                    AppContext.disableAllReferenceFormFieldsEdit();
                                                                                                    AppContext.validFormField(
                                                                                                        AppContext.currentReference.Authors,
                                                                                                        AppContext.setErrorCurrentReferenceAuthors
                                                                                                    );
                                                                                                }}
                                                                                                onChange={(e) =>
                                                                                                    AppContext.setCurrentReference({
                                                                                                        ...AppContext.currentReference,
                                                                                                        Authors: e.target.value
                                                                                                    })
                                                                                                }
                                                                                                value={AppContext.currentReference.Authors}
                                                                                            />
                                                                                        </span>
                                                                                    </>
                                                                                )}

                                                                            </>}





                                                                        </div>

                                                                    </div>

                                                                </div>


                                                                {/* Form field: Journal */}

                                                                <div className="view-task-field">

                                                                    <div className="view-task-field-line">
                                                                        <div className="view-task-field-title">Journal</div>
                                                                        <div className="view-task-field-value">

                                                                            {AppContext.currentReference.Trash == true || AppContext.currentReference.Deleted == true ? <>
                                                                                <span>{AppContext.currentReference.Journal}</span>
                                                                            </> : <>



                                                                                {AppContext.isEditingField.journal === false ? (
                                                                                    <>
                                                                                        <span
                                                                                            title="Edit" 
                                                                                            className={`pointer editable-field-span ${AppContext.errorCurrentReferenceJournal
                                                                                                ? "form-field-error"
                                                                                                : null
                                                                                                }`}
                                                                                            onClick={(e) => {
                                                                                                AppContext.enableReferenceFormFieldEdit("journal", e);
                                                                                                setTimeout(() => {
                                                                                                    // We need this timeout because the ref for the edit field isn't immediately available
                                                                                                    currentReferenceJournalRef.current.selectionStart = 0;
                                                                                                    currentReferenceJournalRef.current.selectionEnd = 0;
                                                                                                }, 10);
                                                                                            }
                                                                                            }
                                                                                            >

                                                                                                {AppContext.currentReference.Journal == "" || AppContext.currentReference.Journal == null ?
                                                                                                    <span style={{ color: "#c0c0c0" }}>Add the journal</span>
                                                                                                    :
                                                                                                    <span>{AppContext.currentReference.Journal}</span>
                                                                                                }

                                                                                                {AppContext.errorCurrentReferenceJournal && (
                                                                                                    <span style={{ marginLeft: "20px" }} className="form-field-error-message">
                                                                                                        The field Journal is necessary
                                                                                                    </span>
                                                                                                )}
                                                                            
                                                                                        </span>
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        <span style={{width: "100%"}}>
                                                                                            <input
                                                                                                ref={currentReferenceJournalRef}
                                                                                                style={{ width: "100%" }}
                                                                                                autoFocus
                                                                                                onBlur={() => {
                                                                                                    AppContext.disableAllReferenceFormFieldsEdit();
                                                                                                }}
                                                                                                onChange={(e) =>
                                                                                                    AppContext.setCurrentReference({
                                                                                                        ...AppContext.currentReference,
                                                                                                        Journal: e.target.value
                                                                                                    })
                                                                                                }
                                                                                                value={AppContext.currentReference.Journal}
                                                                                            />
                                                                                        </span>
                                                                                    </>
                                                                                )}


                                                                            </>}




                                                                        </div>
                                                                    </div>

                                                                </div>


                                                                        {/* Form field: VolumeNumber */}

                                                                        <div className="view-task-field">

                                                                            <div className="view-task-field-line">
                                                                                <div className="view-task-field-title">Volume</div>
                                                                                <div className="view-task-field-value">

                                                                                    {AppContext.currentReference.Trash == true || AppContext.currentReference.Deleted == true ? <>
                                                                                        <span>{AppContext.currentReference.VolumeNumber}</span>
                                                                                    </> : <>



                                                                                        {AppContext.isEditingField.volume === false ? (
                                                                                            <>
                                                                                                <span
                                                                                                    title="Edit"
                                                                                                        className={`pointer editable-field-span ${AppContext.errorCurrentReferenceVolumeNumber
                                                                                                        ? "form-field-error"
                                                                                                        : null
                                                                                                        }`}
                                                                                                    onClick={(e) => {
                                                                                                        AppContext.enableReferenceFormFieldEdit("volume", e);
                                                                                                        setTimeout(() => {
                                                                                                            // We need this timeout because the ref for the edit field isn't immediately available
                                                                                                            currentReferenceVolumeNumberRef.current.selectionStart = 0;
                                                                                                            currentReferenceVolumeNumberRef.current.selectionEnd = 0;
                                                                                                        }, 10);
                                                                                                    }
                                                                                                    }
                                                                                                >

                                                                                                        {AppContext.currentReference.VolumeNumber == "" || AppContext.currentReference.VolumeNumber == null ?
                                                                                                        <span style={{ color: "#c0c0c0" }}>Add the Volume</span>
                                                                                                        :
                                                                                                            <span>{AppContext.currentReference.VolumeNumber}</span>
                                                                                                    }

                                                                                                </span>
                                                                                            </>
                                                                                        ) : (
                                                                                            <>
                                                                                                <span style={{ width: "100%" }}>
                                                                                                    <input
                                                                                                                ref={currentReferenceVolumeNumberRef}
                                                                                                        style={{ width: "100%" }}
                                                                                                        autoFocus
                                                                                                        onBlur={() => {
                                                                                                            AppContext.disableAllReferenceFormFieldsEdit();
                                                                                                        }}
                                                                                                        onChange={(e) =>
                                                                                                            AppContext.setCurrentReference({
                                                                                                                ...AppContext.currentReference,
                                                                                                                VolumeNumber: e.target.value
                                                                                                            })
                                                                                                        }
                                                                                                                value={AppContext.currentReference.VolumeNumber}
                                                                                                    />
                                                                                                </span>
                                                                                            </>
                                                                                        )}


                                                                                    </>}




                                                                                </div>
                                                                            </div>

                                                                        </div>

                                                                        {/* Form field: IssueNumber */}
                                                                        <div className="view-task-field">
                                                                            <div className="view-task-field-line">
                                                                                <div className="view-task-field-title">Issue Number</div>
                                                                                <div className="view-task-field-value">

                                                                                    {AppContext.currentReference.Trash == true || AppContext.currentReference.Deleted == true ? (
                                                                                        <span>{AppContext.currentReference.IssueNumber}</span>
                                                                                    ) : (

                                                                                        AppContext.isEditingField.issue === false ? (
                                                                                            <span
                                                                                                title="Edit"
                                                                                                className={`pointer editable-field-span ${AppContext.errorCurrentReferenceIssueNumber ? "form-field-error" : null}`}
                                                                                                onClick={(e) => {
                                                                                                    AppContext.enableReferenceFormFieldEdit("issue", e);
                                                                                                    setTimeout(() => {
                                                                                                        currentReferenceIssueNumberRef.current.selectionStart = 0;
                                                                                                        currentReferenceIssueNumberRef.current.selectionEnd = 0;
                                                                                                    }, 10);
                                                                                                }}
                                                                                            >
                                                                                                {AppContext.currentReference.IssueNumber == "" || AppContext.currentReference.IssueNumber == null ? (
                                                                                                    <span style={{ color: "#c0c0c0" }}>Add the issue number</span>
                                                                                                ) : (
                                                                                                    <span>{AppContext.currentReference.IssueNumber}</span>
                                                                                                )}

                                                                                                
                                                                                            </span>
                                                                                        ) : (
                                                                                            <span style={{ width: "100%" }}>
                                                                                                <input
                                                                                                    ref={currentReferenceIssueNumberRef}
                                                                                                    style={{ width: "100%" }}
                                                                                                    autoFocus
                                                                                                    onBlur={() => {
                                                                                                        AppContext.disableAllReferenceFormFieldsEdit();
                                                                                                    }}
                                                                                                    onChange={(e) =>
                                                                                                        AppContext.setCurrentReference({
                                                                                                            ...AppContext.currentReference,
                                                                                                            IssueNumber: e.target.value
                                                                                                        })
                                                                                                    }
                                                                                                    value={AppContext.currentReference.IssueNumber}
                                                                                                />
                                                                                            </span>
                                                                                        )
                                                                                    )}

                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        {/* Form field: Pages */}
                                                                        <div className="view-task-field">
                                                                            <div className="view-task-field-line">
                                                                                <div className="view-task-field-title">Pages</div>
                                                                                <div className="view-task-field-value">

                                                                                    {AppContext.currentReference.Trash == true || AppContext.currentReference.Deleted == true ? (
                                                                                        <span>{AppContext.currentReference.Pages}</span>
                                                                                    ) : (

                                                                                        AppContext.isEditingField.pages === false ? (
                                                                                            <span
                                                                                                title="Edit"
                                                                                                className={`pointer editable-field-span ${AppContext.errorCurrentReferencePages ? "form-field-error" : null}`}
                                                                                                onClick={(e) => {
                                                                                                    AppContext.enableReferenceFormFieldEdit("pages", e);
                                                                                                    setTimeout(() => {
                                                                                                        currentReferencePagesRef.current.selectionStart = 0;
                                                                                                        currentReferencePagesRef.current.selectionEnd = 0;
                                                                                                    }, 10);
                                                                                                }}
                                                                                            >
                                                                                                {AppContext.currentReference.Pages == "" || AppContext.currentReference.Pages == null ? (
                                                                                                    <span style={{ color: "#c0c0c0" }}>Add the pages</span>
                                                                                                ) : (
                                                                                                    <span>{AppContext.currentReference.Pages}</span>
                                                                                                )}

                                                                                                
                                                                                            </span>
                                                                                        ) : (
                                                                                            <span style={{ width: "100%" }}>
                                                                                                <input
                                                                                                    ref={currentReferencePagesRef}
                                                                                                    style={{ width: "100%" }}
                                                                                                    autoFocus
                                                                                                    onBlur={() => {
                                                                                                        AppContext.disableAllReferenceFormFieldsEdit();
                                                                                                    }}
                                                                                                    onChange={(e) =>
                                                                                                        AppContext.setCurrentReference({
                                                                                                            ...AppContext.currentReference,
                                                                                                            Pages: e.target.value
                                                                                                        })
                                                                                                    }
                                                                                                    value={AppContext.currentReference.Pages}
                                                                                                />
                                                                                            </span>
                                                                                        )
                                                                                    )}

                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        {/* Form field: ISSN */}
                                                                        <div className="view-task-field">
                                                                            <div className="view-task-field-line">
                                                                                <div className="view-task-field-title">ISSN</div>
                                                                                <div className="view-task-field-value">

                                                                                    {AppContext.currentReference.Trash == true || AppContext.currentReference.Deleted == true ? (
                                                                                        <span>{AppContext.currentReference.ISSN}</span>
                                                                                    ) : (

                                                                                            AppContext.isEditingField.issn === false ? (
                                                                                            <span
                                                                                                title="Edit"
                                                                                                className={`pointer editable-field-span ${AppContext.errorCurrentReferenceISSN ? "form-field-error" : null}`}
                                                                                                onClick={(e) => {
                                                                                                    AppContext.enableReferenceFormFieldEdit("issn", e);
                                                                                                    setTimeout(() => {
                                                                                                        currentReferenceISSNRef.current.selectionStart = 0;
                                                                                                        currentReferenceISSNRef.current.selectionEnd = 0;
                                                                                                    }, 10);
                                                                                                }}
                                                                                            >
                                                                                                {AppContext.currentReference.ISSN == "" || AppContext.currentReference.ISSN == null ? (
                                                                                                    <span style={{ color: "#c0c0c0" }}>Add the ISSN</span>
                                                                                                ) : (
                                                                                                    <span>{AppContext.currentReference.ISSN}</span>
                                                                                                )}

                                                                                                {AppContext.errorCurrentReferenceISSN && (
                                                                                                    <span style={{ marginLeft: "20px" }} className="form-field-error-message">
                                                                                                        The field ISSN is necessary
                                                                                                    </span>
                                                                                                )}
                                                                                            </span>
                                                                                        ) : (
                                                                                            <span style={{ width: "100%" }}>
                                                                                                <input
                                                                                                    ref={currentReferenceISSNRef}
                                                                                                    style={{ width: "100%" }}
                                                                                                    autoFocus
                                                                                                    onBlur={() => {
                                                                                                        AppContext.disableAllReferenceFormFieldsEdit();
                                                                                                    }}
                                                                                                    onChange={(e) =>
                                                                                                        AppContext.setCurrentReference({
                                                                                                            ...AppContext.currentReference,
                                                                                                            ISSN: e.target.value
                                                                                                        })
                                                                                                    }
                                                                                                    value={AppContext.currentReference.ISSN}
                                                                                                />
                                                                                            </span>
                                                                                        )
                                                                                    )}

                                                                                </div>
                                                                            </div>
                                                                        </div>


                                                                {/* Form field: Source */}

                                                                <div className="view-task-field">

                                                                    <div className="view-task-field-line">
                                                                        <div className="view-task-field-title">Source</div>
                                                                        <div className="view-task-field-value">

                                                                            {AppContext.currentReference.Trash == true || AppContext.currentReference.Deleted == true ? <>
                                                                                <span>{AppContext.currentReference.Source}</span>
                                                                            </> : <>



                                                                                {AppContext.isEditingField.source === false ? (
                                                                                    <>
                                                                                        <span
                                                                                            title="Edit" 
                                                                                            className={`pointer editable-field-span ${AppContext.errorCurrentReferenceSource
                                                                                                ? "form-field-error"
                                                                                                : null
                                                                                                }`}
                                                                                            onClick={(e) => {
                                                                                                AppContext.enableReferenceFormFieldEdit("source", e);
                                                                                                setTimeout(() => {
                                                                                                    // We need this timeout because the ref for the edit field isn't immediately available
                                                                                                    currentReferenceSourceRef.current.selectionStart = 0;
                                                                                                    currentReferenceSourceRef.current.selectionEnd = 0;
                                                                                                }, 10);
                                                                                            }
                                                                                            }
                                                                                                    >




                                                                                                        {AppContext.currentReference.Source == "" || AppContext.currentReference.Source == null ?
                                                                                                            <span style={{ color: "#c0c0c0" }}>Add the source</span>
                                                                                                            :
                                                                                                            <span>{AppContext.currentReference.Source}</span>
                                                                                                        }

                                                                                                        {AppContext.errorCurrentReferenceSource && (
                                                                                                            <span style={{ marginLeft: "20px" }} className="form-field-error-message">
                                                                                                                The field Source is necessary
                                                                                                            </span>
                                                                                                        )}


                                                                            
                                                                                        </span>
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        <span style={{width: "100%"}}>
                                                                                            <input
                                                                                                ref={currentReferenceSourceRef}
                                                                                                style={{ width: "100%" }}
                                                                                                autoFocus
                                                                                                onBlur={() => {
                                                                                                    AppContext.disableAllReferenceFormFieldsEdit();
                                                                                                    AppContext.validFormField(
                                                                                                        AppContext.currentReference.Source,
                                                                                                        AppContext.setErrorCurrentReferenceSource
                                                                                                    );
                                                                                                }}
                                                                                                onChange={(e) =>
                                                                                                    AppContext.setCurrentReference({
                                                                                                        ...AppContext.currentReference,
                                                                                                        Source: e.target.value
                                                                                                    })
                                                                                                }
                                                                                                value={AppContext.currentReference.Source}
                                                                                            />
                                                                                        </span>
                                                                                    </>
                                                                                )}


                                                                            </>}




                                                                        </div>
                                                                    </div>

                                                                </div>


                                                                {/* Form field: Doi */}

                                                                <div className="view-task-field">

                                                                    <div className="view-task-field-line">
                                                                        <div className="view-task-field-title">DOI</div>
                                                                        <div className="view-task-field-value">

                                                                            {AppContext.currentReference.Trash == true || AppContext.currentReference.Deleted == true ? <>
                                                                                <span>{AppContext.currentReference.Doi}</span>
                                                                            </> : <>



                                                                                {AppContext.isEditingField.doi === false ? (
                                                                                    <>
                                                                                        <span
                                                                                            title={`${isNullOrEmpty(AppContext.currentReference.SavedDoi) ? "Edit" : "Cannot edit the DOI after being added"}`}
                                                                                            className={`pointer editable-field-span ${AppContext.errorCurrentReferenceDoi
                                                                                                ? "form-field-error"
                                                                                                : null
                                                                                                }`}
                                                                                            onClick={(e) => {
                                                                                                if (!isNullOrEmpty(AppContext.currentReference.SavedDoi))
                                                                                                    return;

                                                                                                AppContext.enableReferenceFormFieldEdit("doi", e);
                                                                                                setTimeout(() => {
                                                                                                    // We need this timeout because the ref for the edit field isn't immediately available
                                                                                                    currentReferenceDoiRef.current.selectionStart = 0;
                                                                                                    currentReferenceDoiRef.current.selectionEnd = 0;
                                                                                                }, 10);
                                                                                            }
                                                                                            }
                                                                                                    >



                                                                                                        {AppContext.currentReference.Doi == "" || AppContext.currentReference.Doi == null ?
                                                                                                            <span style={{ color: "#c0c0c0" }}>Add the DOI</span>
                                                                                                            :
                                                                                                            <span>{AppContext.currentReference.Doi}</span>
                                                                                                        }

                                                                                                        {AppContext.errorCurrentReferenceDoi && (
                                                                                                            <span style={{ marginLeft: "20px" }} className="form-field-error-message">
                                                                                                                The field DOI is necessary
                                                                                                            </span>
                                                                                                        )}


                                                                            
                                                                                        </span>
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        <span style={{width: "100%"}}>
                                                                                            <input
                                                                                                ref={currentReferenceDoiRef}
                                                                                                style={{ width: "100%" }}
                                                                                                autoFocus
                                                                                                onBlur={() => {
                                                                                                    AppContext.disableAllReferenceFormFieldsEdit();
                                                                                                }}
                                                                                                onChange={(e) =>
                                                                                                    AppContext.setCurrentReference({
                                                                                                        ...AppContext.currentReference,
                                                                                                        Doi: e.target.value
                                                                                                    })
                                                                                                }
                                                                                                value={AppContext.currentReference.Doi}
                                                                                            />
                                                                                        </span>
                                                                                    </>
                                                                                )}


                                                                            </>}



                                                                        </div>
                                                                    </div>

                                                                </div>


                                                                {/* Form field: URL */}

                                                                <div className="view-task-field">

                                                                    <div className="view-task-field-line">
                                                                        <div className="view-task-field-title">URL</div>
                                                                        <div className="view-task-field-value">


                                                                            {AppContext.currentReference.Trash == true || AppContext.currentReference.Deleted == true ? <>
                                                                                <span>{AppContext.currentReference.Url}</span>
                                                                            </> : <>



                                                                                {AppContext.isEditingField.url === false ? (
                                                                                    <>
                                                                                        <span
                                                                                            title="Edit" 
                                                                                            className={`pointer editable-field-span ${AppContext.errorCurrentReferenceUrl
                                                                                                ? "form-field-error"
                                                                                                : null
                                                                                                }`}
                                                                                            onClick={(e) => {
                                                                                                AppContext.enableReferenceFormFieldEdit("url", e);
                                                                                                setTimeout(() => {
                                                                                                    // We need this timeout because the ref for the edit field isn't immediately available
                                                                                                    currentReferenceUrlRef.current.selectionStart = 0;
                                                                                                    currentReferenceUrlRef.current.selectionEnd = 0;
                                                                                                }, 10);
                                                                                            }
                                                                                            }
                                                                                                    >




                                                                                                        {AppContext.currentReference.Url == "" || AppContext.currentReference.Url == null ?
                                                                                                            <span style={{ color: "#c0c0c0" }}>Add the URL</span>
                                                                                                            :
                                                                                                            <div>
                                                                                                                <i className="fas fa-link" style={{marginRight: "10px"}}></i>
                                                                                                                <a target="_blank" href={AppContext.currentReference.Url}>{AppContext.currentReference.Url}</a> 
                                                                                                            </div>
                                                                                                        }

                                                                                                        {AppContext.errorCurrentReferenceUrl && (
                                                                                                            <span style={{ marginLeft: "20px" }} className="form-field-error-message">
                                                                                                                The field URL is necessary
                                                                                                            </span>
                                                                                                        )}
                                                                            
                                                                                        </span>
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        <span style={{width: "100%"}}>
                                                                                            <input
                                                                                                ref={currentReferenceUrlRef}
                                                                                                style={{ width: "100%" }}
                                                                                                autoFocus
                                                                                                onBlur={() => {
                                                                                                    AppContext.disableAllReferenceFormFieldsEdit();
                                                                                                }}
                                                                                                onChange={(e) =>
                                                                                                    AppContext.setCurrentReference({
                                                                                                        ...AppContext.currentReference,
                                                                                                        Url: e.target.value
                                                                                                    })
                                                                                                }
                                                                                                value={AppContext.currentReference.Url}
                                                                                            />
                                                                                        </span>
                                                                                    </>
                                                                                )}


                                                                            </>}


                                                                        </div>
                                                                    </div>

                                                                </div>


                                                                {/* Form field: Year */}

                                                                <div className="view-task-field">


                                                                    <div className="view-task-field-line">
                                                                        <div className="view-task-field-title">Year</div>
                                                                        <div className="view-task-field-value">


                                                                            {AppContext.currentReference.Trash == true || AppContext.currentReference.Deleted == true ? <>
                                                                                <span>{AppContext.currentReference.Year}</span>
                                                                            </> : <>


                                                                                {AppContext.isEditingField.year === false ? (
                                                                                    <>
                                                                                        <span
                                                                                            title="Edit" 
                                                                                            className={`pointer editable-field-span ${AppContext.errorCurrentReferenceYear
                                                                                                ? "form-field-error"
                                                                                                : null
                                                                                                }`}
                                                                                            onClick={(e) => {
                                                                                                AppContext.enableReferenceFormFieldEdit("year", e);
                                                                                            }
                                                                                            }
                                                                                                    >



                                                                                                        {AppContext.currentReference.Year == "" || AppContext.currentReference.Year == null ?
                                                                                                            <span style={{ color: "#c0c0c0" }}>Add the year</span>
                                                                                                            :
                                                                                                            <span>{AppContext.currentReference.Year}</span>
                                                                                                        }

                                                                                                        {AppContext.errorCurrentReferenceYear && (
                                                                                                            <span style={{ marginLeft: "20px" }} className="form-field-error-message">
                                                                                                                The field Year is necessary
                                                                                                            </span>
                                                                                                        )}



                                                                                        </span>
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        <span>
                                                                                            <DatePicker
                                                                                                dateFormat="yyyy"
                                                                                                showYearPicker
                                                                                                placeholderText="Year"
                                                                                                onBlur={() =>
                                                                                                    AppContext.disableAllReferenceFormFieldsEdit()
                                                                                                }
                                                                                                selected={
                                                                                                    new Date(AppContext.currentReference.Year, 0, 1)
                                                                                                }
                                                                                                onChange={(date) => {

                                                                                                    AppContext.setCurrentReference({
                                                                                                        ...AppContext.currentReference,
                                                                                                        Year: date.getFullYear()
                                                                                                    })

                                                                                                    AppContext.disableAllReferenceFormFieldsEdit();
                                                                                                                }}
                                                                                                popperPlacement={datePopperConfig.placement}
                                                                                                popperModifiers={datePopperConfig.modifiers}
                                                                                            />
                                                                                        </span>
                                                                                    </>
                                                                                )}


                                                                            </>}



                                                                        </div>
                                                                    </div>

                                                                </div>


                                                                {/* Form field: File */}

                                                                <div className="view-task-field">

                                                                    <div className="view-task-field-line">
                                                                        <div className="view-task-field-title">File</div>
                                                                        <div className="view-task-field-value">

                                                                                    {AppContext.currentReference.HasPDF == 1 ?
                                                                                        <div style={{display: "flex", flexDirection: "column"}}>

                                                                                            <div style={{display: "flex", flexDirection: "row", marginTop: "15px", width: "100%"}}>
                                                                                                <span style={{ display: "flex", flexDirection: "row", alignItems: "center" }} >
                                                                                                    <a title="Open PDF" target="_blank" href={`/Umbraco/Api/SurveilanceAppraisal/LoadPdf?surveillanceItemId=${AppContext.currentReference.MedBoardResourceId}`} style={{ textDecoration: "none", display: "flex", alignItems: "center" }}>
                                                                                                        <i className="fas fa-file-download g-mr-8"></i> {AppContext.currentReference.FileName}
                                                                                                    </a>
                                                                                                </span>

                                                                                                {AppContext.userRole == "Admin" ? <>

                                                                                                    {!AppContext.showDeleteFileConfirmation &&
                                                                                                        <div style={{ flex: 1, marginLeft: "25px" }}>
                                                                                                            <i style={{ color: "#ff3b3b" }} title="Delete file" onClick={() => AppContext.setShowDeleteFileConfirmation(!AppContext.showDeleteFileConfirmation)} className="pointer fas fa-times-circle"></i>
                                                                                                        </div>
                                                                                                    }

                                                                                                    {AppContext.showDeleteFileConfirmation &&
                                                                                                        <div style={{ flex: 1, marginLeft: "25px", minWidth: "300px", display: "flex", flexDirection: "row", alignItems: "center"}}>
                                                                                                            <span>Are you sure you want to delete this file?</span>
                                                                                                            <div className="pointer" style={{ alignItems: "center", display: "flex", marginLeft: "15px", borderRadius: "10px", padding: "2px 10px", backgroundColor: "#ccc" }} onClick={() => AppContext.setShowDeleteFileConfirmation(false)} >No</div>
                                                                                                            <div className="pointer" style={{ alignItems: "center", display: "flex", marginLeft: "15px", borderRadius: "10px", padding: "2px 10px", backgroundColor: "#ff3b3b", color: "white" }} onClick={AppContext.deleteCurrentReferenceFile} >Yes</div>
                                                                                                        </div>
                                                                                                    }

                                                                                                </> : null}


                                                                                            </div>
                                                                                        </div>
                                                                                        :
                                                                                        <>
                                                                                            {AppContext.userRole == "Admin" ? <>
                                                                                                <MultipleFileUpload context={FileManagerAppContext} showPDFOnly={true} allowMultiple={false} />
                                                                                            </> : null}
                                                                                        </>
                                                                                    }


                                                                        </div>
                                                                    </div>

                                                                </div>


                                                                {/* Form field: Tags */}

                                                                <div className="view-task-field">

                                                                    <div className="view-task-field-line">
                                                                        <div className="view-task-field-title">Tags</div>
                                                                        <div className="view-task-field-value">

                                                                            <div style={{
                                                                                    display: "flex",
                                                                                    flexWrap: "wrap",
                                                                                }}>
                                                                                    <Tags objectType="references" />
                                                                            </div>

                                                                        </div>
                                                                    </div>

                                                                </div>


                                                                {/* Form field: Publication Type */}

                                                                <div className="view-task-field">

                                                                    <div className="view-task-field-line">
                                                                        <div className="view-task-field-title">Publication Type</div>
                                                                        <div className="view-task-field-value">

                                                                            {AppContext.currentReference.Trash == true || AppContext.currentReference.Deleted == true ? <>
                                                                                <span>{AppContext.currentReference.PublicationType}</span>
                                                                            </> : <>



                                                                                {AppContext.isEditingField.publicationtype === false ? (
                                                                                    <>
                                                                                        <span
                                                                                            title="Edit" 
                                                                                            className={`pointer editable-field-span ${AppContext.errorCurrentReferencePublicationType
                                                                                                ? "form-field-error"
                                                                                                : null
                                                                                                }`}
                                                                                            onClick={(e) => {
                                                                                                AppContext.enableReferenceFormFieldEdit("publicationtype", e);
                                                                                                setTimeout(() => {
                                                                                                    // We need this timeout because the ref for the edit field isn't immediately available
                                                                                                    currentReferencePublicationTypeRef.current.selectionStart = 0;
                                                                                                    currentReferencePublicationTypeRef.current.selectionEnd = 0;
                                                                                                }, 10);
                                                                                            }
                                                                                            }
                                                                                            >

                                                                                                {AppContext.currentReference.PublicationType == "" || AppContext.currentReference.PublicationType == null ?
                                                                                                    <span style={{ color: "#c0c0c0" }}>Add the Publication Type</span>
                                                                                                    :
                                                                                                    <span>{AppContext.currentReference.PublicationType}</span>
                                                                                                }

                                                                                                {AppContext.errorCurrentReferencePublicationType && (
                                                                                                    <span style={{ marginLeft: "20px" }} className="form-field-error-message">
                                                                                                        The field Publication Type is necessary
                                                                                                    </span>
                                                                                                )}
                                        
                                                                                        </span>
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        <span style={{width: "100%"}}>
                                                                                            <input
                                                                                                ref={currentReferencePublicationTypeRef}
                                                                                                style={{ width: "100%" }}
                                                                                                autoFocus
                                                                                                onBlur={() => {
                                                                                                    AppContext.disableAllReferenceFormFieldsEdit();
                                                                                                }}
                                                                                                onChange={(e) =>
                                                                                                    AppContext.setCurrentReference({
                                                                                                        ...AppContext.currentReference,
                                                                                                        PublicationType: e.target.value
                                                                                                    })
                                                                                                }
                                                                                                value={AppContext.currentReference.PublicationType}
                                                                                            />
                                                                                        </span>
                                                                                    </>
                                                                                )}


                                                                            </>}




                                                                        </div>
                                                                    </div>

                                                                </div>


                                                                {/* Form field: Publication Date */}

                                                                <div className="view-task-field">

                                                                    <div className="view-task-field-line">
                                                                        <div className="view-task-field-title">Publication Date</div>
                                                                        <div className="view-task-field-value">


                                                                            {AppContext.currentReference.Trash == true || AppContext.currentReference.Deleted == true ? <>
                                                                                <span>{AppContext.currentReference.PublicationDate}</span>
                                                                            </> : <>


                                                                                {AppContext.isEditingField.publicationdate === false ? (
                                                                                    <>
                                                                                        <span
                                                                                            title="Edit"
                                                                                            className={`pointer editable-field-span ${AppContext.errorCurrentReferencePublicationDate
                                                                                                ? "form-field-error"
                                                                                                : null
                                                                                                }`}
                                                                                            onClick={(e) => {
                                                                                                AppContext.enableReferenceFormFieldEdit("publicationdate", e);
                                                                                            }
                                                                                            }
                                                                                        >



                                                                                            {AppContext.currentReference.PublicationDate == "" || AppContext.currentReference.PublicationDate == null ?
                                                                                                <span style={{ color: "#c0c0c0" }}>Add the publication date</span>
                                                                                                :
                                                                                                <span>{AppContext.readableDateUTC(AppContext.currentReference.PublicationDate, true, false)}</span>
                                                                                            }

                                                                                            {AppContext.errorCurrentReferencePublicationDate && (
                                                                                                <span style={{ marginLeft: "20px" }} className="form-field-error-message">
                                                                                                    The field Publication Date is necessary
                                                                                                </span>
                                                                                            )}



                                                                                        </span>
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        <span>
                                                                                            <DatePicker
                                                                                                dateFormat="yyyy-MM-dd"
                                                                                                placeholderText="Publication Date"
                                                                                                onBlur={() =>
                                                                                                    AppContext.disableAllReferenceFormFieldsEdit()
                                                                                                }
                                                                                                selected={
                                                                                                    !isNullOrEmpty(AppContext.currentReference.PublicationDate) ? new Date(AppContext.currentReference.PublicationDate) : ""
                                                                                                }
                                                                        
                                                                                                onChange={(date) => {

                                                                                                    let formattedDate = "";

                                                                                                    if (date != null) {
                                                                                                        const year = date.getFullYear();
                                                                                                        const month = String(date.getMonth() + 1).padStart(2, '0');
                                                                                                        const day = String(date.getDate()).padStart(2, '0');

                                                                                                        formattedDate = `${year}-${month}-${day}`;
                                                                                                    }


                                                                                                    AppContext.setCurrentReference({
                                                                                                        ...AppContext.currentReference,
                                                                                                        PublicationDate: formattedDate
                                                                                                    })

                                                                                                    //AppContext.disableAllReferenceFormFieldsEdit();
                                                                                                                }}
                                                                                                popperPlacement={datePopperConfig.placement}
                                                                                                popperModifiers={datePopperConfig.modifiers}
                                                                                            />
                                                                                        </span>
                                                                                    </>
                                                                                )}


                                                                            </>}



                                                                        </div>
                                                                    </div>

                                                                </div>


                                                                {/* Form field: Keywords */}

                                                                <div className="view-task-field">

                                                                    <div className="view-task-field-line">
                                                                        <div className="view-task-field-title">Keywords</div>
                                                                        <div className="view-task-field-value">

                                                                            {AppContext.currentReference.Trash == true || AppContext.currentReference.Deleted == true ? <>
                                                                                <span>{AppContext.currentReference.Keywords}</span>
                                                                            </> : <>



                                                                                {AppContext.isEditingField.keywords === false ? (
                                                                                    <>
                                                                                        <span
                                                                                            title="Edit"
                                                                                            className={`pointer editable-field-span ${AppContext.errorCurrentReferenceKeywords
                                                                                                ? "form-field-error"
                                                                                                : null
                                                                                                }`}
                                                                                            onClick={(e) => {
                                                                                                AppContext.enableReferenceFormFieldEdit("keywords", e);
                                                                                                setTimeout(() => {
                                                                                                    // We need this timeout because the ref for the edit field isn't immediately available
                                                                                                    currentReferenceKeywordsRef.current.selectionStart = 0;
                                                                                                    currentReferenceKeywordsRef.current.selectionEnd = 0;
                                                                                                }, 10);
                                                                                            }
                                                                                            }
                                                                                        >




                                                                                            {AppContext.currentReference.Keywords == "" || AppContext.currentReference.Keywords == null ?
                                                                                                <span style={{ color: "#c0c0c0" }}>Add the keywords</span>
                                                                                                :
                                                                                                <span>{AppContext.currentReference.Keywords}</span>
                                                                                            }

                                                                                            {AppContext.errorCurrentReferenceKeywords && (
                                                                                                <span style={{ marginLeft: "20px" }} className="form-field-error-message">
                                                                                                    The field Keywords is necessary
                                                                                                </span>
                                                                                            )}



                                                                                        </span>
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        <span style={{width: "100%"}}>
                                                                                            <input
                                                                                                ref={currentReferenceKeywordsRef}
                                                                                                style={{ width: "100%" }}
                                                                                                autoFocus
                                                                                                onBlur={() => {
                                                                                                    AppContext.disableAllReferenceFormFieldsEdit();
                                                                                                }}
                                                                                                onChange={(e) =>
                                                                                                    AppContext.setCurrentReference({
                                                                                                        ...AppContext.currentReference,
                                                                                                        Keywords: e.target.value
                                                                                                    })
                                                                                                }
                                                                                                value={AppContext.currentReference.Keywords}
                                                                                            />
                                                                                        </span>
                                                                                    </>
                                                                                )}


                                                                            </>}




                                                                        </div>
                                                                    </div>

                                                                </div>


                                                                {/* Form field: Language */}

                                                                <div className="view-task-field">

                                                                    <div className="view-task-field-line">
                                                                        <div className="view-task-field-title">Language</div>
                                                                        <div className="view-task-field-value">

                                                                            {AppContext.currentReference.Trash == true || AppContext.currentReference.Deleted == true ? <>
                                                                                <span>{AppContext.currentReference.Language}</span>
                                                                            </> : <>



                                                                                {AppContext.isEditingField.language === false ? (
                                                                                    <>
                                                                                        <span
                                                                                            title="Edit"
                                                                                            className={`pointer editable-field-span ${AppContext.errorCurrentReferenceLanguage
                                                                                                ? "form-field-error"
                                                                                                : null
                                                                                                }`}
                                                                                            onClick={(e) => {
                                                                                                AppContext.enableReferenceFormFieldEdit("language", e);
                                                                                                setTimeout(() => {
                                                                                                    // We need this timeout because the ref for the edit field isn't immediately available
                                                                                                    currentReferenceLanguageRef.current.selectionStart = 0;
                                                                                                    currentReferenceLanguageRef.current.selectionEnd = 0;
                                                                                                }, 10);
                                                                                            }
                                                                                            }
                                                                                        >




                                                                                            {AppContext.currentReference.Language == "" || AppContext.currentReference.Language == null ?
                                                                                                <span style={{ color: "#c0c0c0" }}>Add the language</span>
                                                                                                :
                                                                                                <span>{AppContext.currentReference.Language}</span>
                                                                                            }

                                                                                            {AppContext.errorCurrentReferenceLanguage && (
                                                                                                <span style={{ marginLeft: "20px" }} className="form-field-error-message">
                                                                                                    The field Language is necessary
                                                                                                </span>
                                                                                            )}



                                                                                        </span>
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        <span style={{width: "100%"}}>
                                                                                            <input
                                                                                                ref={currentReferenceLanguageRef}
                                                                                                style={{ width: "100%" }}
                                                                                                autoFocus
                                                                                                onBlur={() => {
                                                                                                    AppContext.disableAllReferenceFormFieldsEdit();
                                                                                                }}
                                                                                                onChange={(e) =>
                                                                                                    AppContext.setCurrentReference({
                                                                                                        ...AppContext.currentReference,
                                                                                                        Language: e.target.value
                                                                                                    })
                                                                                                }
                                                                                                value={AppContext.currentReference.Language}
                                                                                            />
                                                                                        </span>
                                                                                    </>
                                                                                )}


                                                                            </>}




                                                                        </div>
                                                                    </div>

                                                                </div>


                                                                {/* Form field: Created By */}

                                                                <div className="view-task-field">

                                                                    <div className="view-task-field-line">
                                                                        <div className="view-task-field-title">Created By</div>
                                                                        <div className="view-task-field-value">
                                                                            <span style={{ marginRight: "10px" }}><User value={AppContext.currentReference.CreatedBy} /></span>
                                                                            {AppContext.readableDate(AppContext.currentReference.CreatedOn, true, false)}
                                                                        </div>
                                                                    </div>

                                                                </div>


                                                                {/* Form field: Updated By */}

                                                                <div className="view-task-field">

                                                                    <div className="view-task-field-line">
                                                                        <div className="view-task-field-title">Updated By</div>
                                                                        <div className="view-task-field-value">
                                                                            <span style={{ marginRight: "10px" }}><User value={AppContext.currentReference.UpdatedBy} /></span>
                                                                            {AppContext.readableDate(AppContext.currentReference.UpdatedOn, true, false)}
                                                                        </div>
                                                                    </div>

                                                                </div>


                                                                {/* SHOW MORE/LESS */}

                                                                <div className="task-details-see-more-separator">
                                                                    <div className="side">
                                                                        <hr />
                                                                    </div>
                                                                </div>
    

                                                            </div>

                                                        }


                                                        {/* RELATED REVIEWS */}

                                                        {AppContext.visibleReferenceDetailsTab == "relatedreviews" &&

                                                            <div style={{height: "100%", overflow: "auto"}}>

                                                                <FieldTypes.RelatedReviews relatedReviews={AppContext.currentReference.RelatedAppraisals} />

                                                            </div>

                                                        }


                                                        {/* GROUPS */}

                                                        {AppContext.visibleReferenceDetailsTab == "groups" && <>


                                                            <div style={{height: "100%", overflow: "auto"}}>
                                                                <Groups reference={AppContext.currentReference} />
                                                            </div>


                                                        </>}


                                                        {/* ENTITY ASSOCIATIONS */}

                                                        {AppContext.visibleReferenceDetailsTab == "entities" && <>

                                                            <div style={{ height: "100%", overflow: "auto" }}>
                                                                <EntityAssociation context={FileManagerAppContext} />
                                                            </div>

                                                        </>}


                                                        {/* COMMENTS */}

                                                        {AppContext.visibleReferenceDetailsTab == "comments" && 

                                                            <div style={{height: "100%", overflow: "auto"}}>

                                                                {(AppContext.currentReference === null || AppContext.isLoadingFileDetails) ? (
                                                                    <>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <div style={{ marginBottom: "20px" }}>
                                                                            <CommentList fileId={AppContext.currentReference.Id} />
                                                                        </div>
                                                                    </>
                                                                )}

                                                            </div>
                                                        }


                                            
                                                        {/* AI CHAT */}
                                                        {/* ... */}
                                                        {/* this is always drawn but controlled with css display to it doesn't clear chat text on tab change */ }

                                                        <div style={{ marginBottom: "10px", flex: 1, display: AppContext.visibleReferenceDetailsTab == "aichat" ? "block" : "none" }}>

                                                            {hasAIChat ? <>
                                                                <div id="aichat-pane" style={{ flex: 1, padding: "0px 10px", borderRight: "2px solid #f0f0f0", height: "100%" }}>

                                                                            <div style={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }} >

                                                                        <AIChat
                                                                            key={componentKey}
                                                                            entityType="reference-manager"
                                                                            entityId={AppContext.currentReference.Id}
                                                                            embeddedAIComponent={true}
                                                                            autoCallOverviewFunction={autoCallOverviewFunction}
                                                                            enableAIExtractionButton={true}
                                                                            enableAIOverviewButton={true}
                                                                            enableUserChat={true}

                                                                        />

                                                                    </div>

                                                                </div>

                                                            </> : <>
                                                                <div>AI Tools are disabled because no PDF file was found</div>
                                                            </>}

                                                        </div>
                                            
                                                    </div>



                                                </div>



                                                {/* BOTTOM BUTTONS */}

                                                <div id="buttom-bar" style={{ borderTop: "1px solid #f0f0f0" }}>

                                                    {(AppContext.currentReference === null || AppContext.isLoadingFileDetails) ? (
                                                        <>
                                                        </>
                                                    ) : (

                                                        <>
                                                            {/*
                                                            <div>
                                                                <label>
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={AppContext.notifyUser}
                                                                        onChange={() => AppContext.setNotifyUser(!AppContext.notifyUser)} /> Notify assigned user of changes
                                                                </label>
                                                            </div>
                                                            */}

                                                            <div className="action-button-bar">

                                                                {AppContext.userRole == "Admin" ? <>



                                                                                <div className="action-button-bar-left">

                                                                                    <div style={{
                                                                                        display: "flex",
                                                                                        flexDirection: "column",
                                                                                        textAlign: "center"
                                                                                    }}>

                                                                                        <button
                                                                                            className="action-button cancel-button"
                                                                                            onClick={AppContext.closePane}
                                                                                        >
                                                                                            Cancel
                                                                                        </button>

                                                                                    </div>

                                                                                </div>



                                                                <div className="action-button-bar-center">
                                                                    
                                                                </div>

                                                                                <div className="action-button-bar-right">

                                                                                    {!AppContext.isSavingReference && !AppContext.isRecoveringReference ? (
                                                                                        <>
                                                                                            {
                                                                                                AppContext.currentReference.Trash == true ?
                                                                                                    <button
                                                                                                        style={{ minWidth: "160px" }}
                                                                                                        className="action-button save-button"
                                                                                                        onClick={AppContext.recoverCurrentReference}
                                                                                                    >
                                                                                                        Recover from trash
                                                                                                    </button>
                                                                                                    :
                                                                                                    <>
                                                                                                        {AppContext.currentReference.Deleted == true ? <>

                                                                                                        </> :

                                                                                                            <button
                                                                                                                className="action-button save-button"
                                                                                                                onClick={AppContext.saveCurrentReference}
                                                                                                            >
                                                                                                                Save
                                                                                                            </button>
                                                                                                        }
                                                                                                    </>

                                                                                            }
                                                                                        </>
                                                                                    ) : (
                                                                                        <>
                                                                                            <LoadingSpinnerImage />
                                                                                        </>
                                                                                    )}


                                                                                    <span
                                                                                        style={{ width: "300px", textAlign: "center" }}
                                                                                        className={`${AppContext.isShowingSaveMessage
                                                                                            ? "save-message-shown"
                                                                                            : "save-message-hidden"
                                                                                            }`}
                                                                                        onTransitionEnd={() => AppContext.setIsShowingSaveMessage(false)}
                                                                                    >
                                                                                        Save successful!
                                                                                    </span>

                                                                                    <span
                                                                                        style={{ width: "300px", textAlign: "center" }}
                                                                                        className={`${AppContext.isShowingRecoverMessage
                                                                                            ? "save-message-shown"
                                                                                            : "save-message-hidden"
                                                                                            }`}
                                                                                        onTransitionEnd={() => AppContext.setIsShowingRecoverMessage(false)}
                                                                                    >
                                                                                        Recover successful!
                                                                                    </span>


                                                                                </div>



                                                                </> : null}

                                                            </div>
                                                        </>

                                                    )}

                                                </div>



                                            </div>



                                        </div>


                                    </>
                                )}

                            </div>

                    


                        </>}





                    </div>
                </div>

            : null}




            {/* CONTEXT MENU */}

            {AppContext.showItemContextMenu && (
                <div
                    ref={contextMenu}
                    style={{
                        position: "fixed",
                        top: `50px`,
                        right: `70px`,
                        background: "white",
                        border: "1px solid #ccc",
                        padding: "4px",
                        borderRadius: "10px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                        zIndex: 1000,
                        borderRadius: "15px",

                    }}
                >

                    {/* DELETE */}
                    {AppContext.userRole === "Admin" ? (
                        !AppContext.isShowingDeleteConfirmation ? (
                            <div className="context-menu-option" onClick={() => AppContext.setIsShowingDeleteConfirmation(true)}>
                                <i className="far fa-trash-alt g-mr-5"></i>
                                {AppContext.currentReference.Trash ? <span>Delete from trash</span> : <span> Move to trash</span>}
                            </div>
                        ) : (
                            AppContext.isDeletingSingleReference ? (
                                <LoadingSpinnerImage />
                            ) : (
                                <div className="context-menu-option context-delete-option" onClick={() => AppContext.deleteReferences(AppContext.currentReference.Id)}>
                                            <i className="far fa-trash-alt g-mr-5"></i>
                                    {AppContext.currentReference.Trash ? <span>Yes, Delete from trash!</span> : <span>Yes, Move to trash</span>}
                                </div>
                            )
                        )
                    ) : (
                        <div className="context-menu-option disabled">
                                <i className="far fa-trash-alt g-mr-5"></i>  {AppContext.currentReference.Trash ? <span>Delete from trash</span> : <span>Move to trash</span>} (No Permission)
                        </div>
                    )}


                </div>
            )}





        </>

    );
};


var debounceTimerTagSearch;

//#tags

const Tags = ({ objectType }) => {

    const AppContext = useContext(FileManagerAppContext);

    const [showTagsMenu, setShowTagsMenu] = useState(false);
    const [tagSearchText, setTagSearchText] = useState("");
    const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });
    const [isSearchingTags, setIsSearchingTags] = useState(false);
    const [searchResults, setSearchResults] = useState([]);
    const [selectedStyle, setSelectedStyle] = useState(1);
    const [isLoadingTags, setIsLoadingTags] = useState(false);
    const [isCreatingTag, setIsCreatingTag] = useState(false);
    const [isAddingTag, setIsAddingTag] = useState(false);


    const showTagMenuButton = useRef(null);
    const tagMenu = useRef(null);


    const doTagSearchText = ({ search }) => {
        let debouncingTime = 500;

        if (search == "")
            return;

        setIsLoadingTags(true);

        clearTimeout(debounceTimerTagSearch);

        debounceTimerTagSearch = setTimeout(() => {
            searchTags(search);
        }, debouncingTime);
    };


    const searchTags = (search) => {

        let url = "/Umbraco/Surface/tags/GetTags?search=" + encodeURIComponent(search) + "&objectType=references";

        let requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };

        setIsSearchingTags(true);

        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {

                let jsonObject = JSON.parse(data);

                // Update the task in the existing tasks array
                setSearchResults(jsonObject);
            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setIsLoadingTags(false);
                setIsSearchingTags(false);
            });

    }


    const handleButtonClick = () => {
        if (showTagMenuButton.current) {
            const rect = showTagMenuButton.current.getBoundingClientRect();
            setPopupPosition({
                top: rect.bottom + window.scrollY - 150,
                left: rect.left + window.scrollX + 30,
            });
        }
        setShowTagsMenu(!showTagsMenu);
    };


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (showTagMenuButton.current && !showTagMenuButton.current.contains(event.target) &&
                tagMenu.current && !tagMenu.current.contains(event.target)) {
                setShowTagsMenu(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);


    const addTag = ({Id, Text, Style}) => {

        let tagExists = false;

        if (AppContext.currentReference.Tags != null)
            tagExists = AppContext.currentReference.Tags.find((tag) => tag.Id == Id);

        if (!tagExists) {

            let url = "/Umbraco/Surface/tags/AddTagToObject?tagId=" + Id + "&objectType=references&objectId=" + AppContext.currentReference.Id;

            let requestOptions = {
                method: "GET",
                headers: { "Content-Type": "application/json" },
            };

            setIsAddingTag(true);

            fetch(url, requestOptions)
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 401)
                            document.dispatchEvent(new Event("api:unauthorized"));

                        throw new Error("Network response was not ok");
                    }
                    return response.json();
                })
                .then((data) => {

                    let updatedTags = AppContext.currentReference.Tags;

                    if (updatedTags == null)
                        updatedTags = [];

                    updatedTags.push({ Id, Text, Style });
                    AppContext.setCurrentReference({ ...AppContext.currentReference, Tags: updatedTags });

                })
                .catch((error) => {
                    // Handle any errors that occurred during the fetch
                    console.log("error: " + error);
                })
                .finally(() => {
                    setShowTagsMenu(false);
                    setIsAddingTag(false);
                });
        }
        else {
            setShowTagsMenu(false);
        }

    }


    const removeTag = ({Id}) => {

        let url = "/Umbraco/Surface/tags/removeTagFromObject?tagId=" + Id + "&objectType=references&objectId=" + AppContext.currentReference.Id;

        let requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };

        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response;
            })
            .then((data) => {

                if (data.status == 200) {

                    let updatedTags = AppContext.currentReference.Tags.filter((tag) => tag.Id != Id);
                    AppContext.setCurrentReference({ ...AppContext.currentReference, Tags: updatedTags });

                }
                    

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                
            });

    }


    const createTag = () => {

        let url = "/Umbraco/Surface/tags/CreateAndAddToObject?text=" + tagSearchText + "&style=" + selectedStyle + "&objectType=references&objectId=" + AppContext.currentReference.Id;

        let requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };

        setIsCreatingTag(true);

        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {

                let newtag = JSON.parse(data);

                let updatedTags = AppContext.currentReference.Tags;

                if (updatedTags == null)
                    updatedTags = [];

                updatedTags.push(newtag);
                AppContext.setCurrentReference({ ...AppContext.currentReference, Tags: updatedTags });

                setTagSearchText("");

                // If there is a function to update a preexisting TagFilter with the new values run that function
                    if (AppContext.callbackUpdateTriggerTagFilter)
                        AppContext.callbackUpdateTriggerTagFilter();

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setShowTagsMenu(false);
                setIsCreatingTag(false); // If coming from the create tag
            });

    }



    return (<>


        {AppContext.userRole == "Admin" ? <>
            <div ref={showTagMenuButton} className="tag-add-button" onClick={handleButtonClick}><i className="fas fa-plus"></i></div>
        </> : null}



        {showTagsMenu &&
            <div ref={tagMenu} className="tag-menu" style={{
                top: `${popupPosition.top}px`,
                left: `${popupPosition.left}px`,
            }}>

                <div className="g-mb-20">
                    <input id="tag-search-box" placeholder="Search for your tags" value={tagSearchText} onChange={(e) => {
                        if (!isSearchingTags) {
                            let text = e.target.value;
                            setTagSearchText(text);
                            doTagSearchText({ search: text });
                        }
                    }} style={{ width: "100%", borderRadius: "15px", border: "1px solid #333", padding: "2px 10px 2px 10px" }} type="text" />
                </div>

                {isLoadingTags ? 
                    <div id="tag-main-load" style={{ display: "block" }}>
                        <LoadingSpinnerImage />
                    </div>
                :
                    <div id="tag-main-content">
                        <div className="g-mb-10">
                            <div id="tag-search-results-container">

                                {tagSearchText == "" &&
                                    <div>
                                        Search for tags to add to the item
                                    </div>
                                }

                                {isAddingTag ? <LoadingSpinnerImage /> :

                                    searchResults.map((tag, index) =>

                                        <div key={index} className="tag-container">
                                            <div
                                                onClick={() => addTag({ Id: tag.Id, Text: tag.Text, Style: tag.Style })}
                                                className={`tag-object ellipsis tag-color-ball-${tag.Style}`}>{tag.Text}</div>
                                        </div>

                                    )
                                }

                            </div>
                        </div>


                        {!isAddingTag && tagSearchText != "" && !isSearchingTags && searchResults.filter((tag) => tag.Text == tagSearchText).length == 0 &&
                            <div className="g-mb-10">
                                <div id="tag-create-new-container" style={{ display: "block" }}>
                                    <div>
                                        <hr style={{ margin: "10px 0px" }} />
                                        Create tag with name:
                                        <div id="tag-create-new-text">{tagSearchText}</div>
                                    </div>
                                    <div className="tag-color-ball-container">
                                        <div onClick={() => setSelectedStyle(1)} className={`tag-color-ball tag-color-ball-1 ${selectedStyle == 1 ? "selected" : ""}`} data-style-id="1"></div>
                                        <div onClick={() => setSelectedStyle(2)} className={`tag-color-ball tag-color-ball-2 ${selectedStyle == 2 ? "selected" : ""}`} data-style-id="2"></div>
                                        <div onClick={() => setSelectedStyle(3)} className={`tag-color-ball tag-color-ball-3 ${selectedStyle == 3 ? "selected" : ""}`} data-style-id="3"></div>
                                        <div onClick={() => setSelectedStyle(4)} className={`tag-color-ball tag-color-ball-4 ${selectedStyle == 4 ? "selected" : ""}`} data-style-id="4"></div>
                                        <div onClick={() => setSelectedStyle(5)} className={`tag-color-ball tag-color-ball-5 ${selectedStyle == 5 ? "selected" : ""}`} data-style-id="5"></div>
                                        <div onClick={() => setSelectedStyle(6)} className={`tag-color-ball tag-color-ball-6 ${selectedStyle == 6 ? "selected" : ""}`} data-style-id="6"></div>
                                    </div>
                                    <br />
                                    <div className="tag-color-ball-container">
                                        <div onClick={() => setSelectedStyle(7)} className={`tag-color-ball tag-color-ball-7 ${selectedStyle == 7 ? "selected" : ""}`} data-style-id="7"></div>
                                        <div onClick={() => setSelectedStyle(8)} className={`tag-color-ball tag-color-ball-8 ${selectedStyle == 8 ? "selected" : ""}`} data-style-id="8"></div>
                                        <div onClick={() => setSelectedStyle(9)} className={`tag-color-ball tag-color-ball-9 ${selectedStyle == 9 ? "selected" : ""}`} data-style-id="9"></div>
                                        <div onClick={() => setSelectedStyle(10)} className={`tag-color-ball tag-color-ball-10 ${selectedStyle == 10 ? "selected" : ""}`} data-style-id="10"></div>
                                        <div onClick={() => setSelectedStyle(11)} className={`tag-color-ball tag-color-ball-11 ${selectedStyle == 11 ? "selected" : ""}`} data-style-id="11"></div>
                                        <div onClick={() => setSelectedStyle(12)} className={`tag-color-ball tag-color-ball-12 ${selectedStyle == 12 ? "selected" : ""}`} data-style-id="12"></div>
                                    </div>
                                    <br />
                                    {isCreatingTag ?
                                        <div id="new-tag-load-container" style={{ display: "block", textAlign: "center" }} >
                                            <LoadingSpinnerImage />
                                        </div>
                                        :
                                        <div id="tag-create-button-container" style={{ justifyContent: "center", display: "flex" }} >
                                            <input onClick={createTag} id="tag-create-button" className="btn btn-primary" type="button" value="Create tag" />
                                        </div>}
                                    
                                    
                                </div>
                            </div>
                        }
                        
                    </div>
                    
                }

                
            </div>
        }


        {AppContext.currentReference.Tags != null && AppContext.currentReference.Tags.map((tag, index) => (

            <div key={index} className={`tag-object ellipsis tag-color-ball-${tag.Style}`}>{tag.Text}

                {AppContext.userRole == "Admin" ? <>
                    <span style={{
                        color: "#FFF",
                        marginLeft: "3px",
                        fontSize: "0.9rem",
                    }}
                        onClick={() => removeTag({ Id: tag.Id })}
                    ><i className="fas fa-times"></i></span>
                </> : null}

            </div>

            ))
        }

        

    </>);
}



//#tagfilter

const TagFilter = () => {

    const AppContext = useContext(FileManagerAppContext);

    const [tags, setTags] = useState([]);
    const [showTagFilterMenu, setShowTagFilterMenu] = useState(false);
    const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });

    const showTagFilterMenuButton = useRef(null);
    const tagFilterMenu = useRef(null);

    useEffect(() => {

        let url = "/Umbraco/Surface/tags/GetTags?search=&objectType=references";

        let requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };

        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {

                let jsonObject = JSON.parse(data);

                setTags(jsonObject);
            })
            .catch((error) => {
                console.log("error: " + error);
            })
            .finally(() => {
                
            });


    }, [AppContext.tagFilterUpdateTrigger]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (showTagFilterMenuButton.current && !showTagFilterMenuButton.current.contains(event.target) &&
                tagFilterMenu.current && !tagFilterMenu.current.contains(event.target)) {
                setShowTagFilterMenu(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);


    const handleButtonClick = () => {
        if (showTagFilterMenuButton.current) {
            const rect = showTagFilterMenuButton.current.getBoundingClientRect();
            setPopupPosition({
                top: rect.bottom + window.scrollY + 10,
                left: rect.left + window.scrollX - 160,
            });
        }
        setShowTagFilterMenu(!showTagFilterMenu);
    };


    const handleCheckboxChange = (event) => {
        const id = parseInt(event.target.value);

        // Doesn't add more tags to selected if still loading references
        if (AppContext.isLoadingReferences)
            return;

        if (event.target.checked) {
            // Add tag to the array if the checkbox is checked and not yet selected

            if (!AppContext.selectedTags.find((tag) => tag.Id == id)) {
                let tag = tags.find((tag) => tag.Id == id);
                AppContext.setSelectedTags([...AppContext.selectedTags, tag]); // this will trigger refresh on loadReferences (useeffect)
            }

        } else {
            // Remove the tag from the array if the checkbox is unchecked
            AppContext.setSelectedTags(AppContext.selectedTags.filter((tag) => tag.Id !== id)); // this will trigger refresh on loadReferences (useeffect)
        }

    };

    const clearAllTags = () => {

        AppContext.setSelectedTags([]);

    }




    return (
        <>





            <div style={{display: "flex", flexDirection: "row", alignItems: "center", marginRight: "15px"}}>
                <span>
                    <span ref={showTagFilterMenuButton} onClick={handleButtonClick} className="pointer sr-menubar-button ellipsis" style={{
                                fontSize: "13px",
                                fontWeight: "600",
                                padding: "7px 15px 7px 15px",
                            }}>
                        <i className="fas fa-filter g-mr-3" style={{ fontSize: "11px", color: "#585f69" }}></i> Tags
                        {AppContext.selectedTags.length > 0 ? ` (${AppContext.selectedTags.length})` : null}
                    </span>
                </span>
            </div>







            {showTagFilterMenu &&
                <div ref={tagFilterMenu} className="tag-menu" style={{
                    display: "block",
                    top: `${popupPosition.top}px`,
                    left: `${popupPosition.left}px`,
                }}>

                    {tags.length !== 0 &&
                        <div style={{ marginBottom: "10px" }}>
                            Filter by tags:
                        </div> }


                    <div className="thin-scrollbar" style={{
                        maxHeight: "150px",
                        overflow: "auto",
                    }}>

                        {tags.length == 0 ? <>

                            <div style={{textAlign: "center"}}>
                                <span>No tags yet!</span>
                                <br/><br/>
                                <span>Create your tags in the reference details screen</span>
                            </div>

                            </> 
                            :
                            <>
                                {tags.map((tag, index) => (
                                    <div key={index}>
                                        <input name="selectedFilterTags" onChange={handleCheckboxChange} checked={AppContext.selectedTags.find((t) => t.Id == tag.Id) != null} value={tag.Id} type="checkbox" /> {tag.Text}
                                    </div>
                                ))}
                            </>
                        }

                        
                    </div>

                    {AppContext.selectedTags.length > 0 ? 

                        <>
                            <br />
                            <div style={{textAlign: "center"}}>
                                <span onClick={clearAllTags} style={{

                                    padding: "3px 8px",
                                    borderRadius: "25px",
                                    backgroundColor: "#e3e3e3",
                                    color: "#707070",
                                    margin: "2px",
                                    cursor: "pointer",
                                    fontWeight: "500",
                                    border: "1px solid transparent",
                                    fontSize: "0.9rem",

                                }}>Clear all tags</span>
                            </div>

                            <br />

                            <div className="tag-container">
                            {
                                AppContext.selectedTags.map((tag, index) => (
                                    
                                    <div key={index} className={`tag-object ellipsis tag-color-ball-${tag.Style}`}>{tag.Text}</div>

                                    ))
                            }
                            </div>
                        </>
                    : null}

                </div>
            }

            

        </>

    );

}




const Groups = ({ reference }) => {

    const AppContext = useContext(FileManagerAppContext);

    const [referenceGroups, setReferenceGroups] = useState([]);
    const [isLoadingReferenceGroups, setIsLoadingReferenceGroups] = useState(false);
    const [isAddingToGroup, setIsAddingToGroup] = useState(false);
    const [isRemovingFromGroup, setIsRemovingFromGroup] = useState(false);
    const [showErrorAddingToGroup, setShowErrorAddingToGroup] = useState(false);
    const [showErrorRemovingFromGroup, setShowErrorRemovingFromGroup] = useState(false);
    const [selectedGroups, setSelectedGroups] = useState([]);
    const [showRemoveGroups, setShowRemoveGroups] = useState(false);


    useEffect(() => {

        loadReferenceGroups();

    }, []);


    const loadReferenceGroups = () => {

        setIsLoadingReferenceGroups(true);

        let referenceId = reference.Id;

        let referenceGroupsURL = "/umbraco/api/ReferenceManager/Groups/?ReferenceId=" + encodeURIComponent(referenceId);


        let requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };

        

        fetch(referenceGroupsURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                // Update the task in the existing tasks array
                setReferenceGroups(data);
            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setIsLoadingReferenceGroups(false);
            });

    };




    const handleCheckboxChange = (event) => {
        const value = parseInt(event.target.value);

        //console.log("VALUE=" + value);
        //console.log("checked=" + event.target.checked);

        if (event.target.checked) {
            // Add the value to the array if the checkbox is checked
            //console.log("added");
            setSelectedGroups([...selectedGroups, value]);
        } else {
            // Remove the value from the array if the checkbox is unchecked
            //console.log("removed");
            setSelectedGroups(selectedGroups.filter((item) => item !== value));
        }


    };






    const addToGroup = () => {


        let referenceId = reference.Id;

        let referenceGroupURL = "/umbraco/api/ReferenceManager/ReferenceGroupMapping/";

        let selectedGroupId = AppContext.selectedParentGroupId;

        if (selectedGroupId == "" || selectedGroupId == "null" || selectedGroupId == null)
            return;

        setIsAddingToGroup(true);
        setShowErrorAddingToGroup(false);


        let data = {
            ReferenceIds: [referenceId],
            GroupId: parseInt(selectedGroupId)
        }

        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data)
        };
        

        fetch(referenceGroupURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    setShowErrorAddingToGroup(true);
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                if (data == true) {
                    setReferenceGroups([...referenceGroups, AppContext.groups.find((group) => group.Id == selectedGroupId)]);

                    //AppContext.loadGroups();

                    // Update counter on the groups menu
                    AppContext.addToGroupItemCount(selectedGroupId, 1);
                    
                }
            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
                setShowErrorAddingToGroup(true);
            })
            .finally(() => {
                setIsAddingToGroup(false);
            });


    }




    const removeFromSelectedGroups = () => {

        let referenceId = reference.Id;

        let referenceGroupsURL = "/umbraco/api/ReferenceManager/ReferenceGroupMapping/";

        

        let data = {
            ReferenceId: referenceId,
            GroupIds: selectedGroups
        }

        const requestOptions = {
            method: "DELETE",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data)
        };

        setIsRemovingFromGroup(true);
        setShowErrorRemovingFromGroup(false);

        fetch(referenceGroupsURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    setShowErrorRemovingFromGroup(true);
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                if (data == true) {
                    setReferenceGroups(referenceGroups.filter((group) => !selectedGroups.includes(group.Id)));
                    handleDeselectAll();
                    //AppContext.loadGroups();

                    // Update counter on the groups menu
                    selectedGroups.map(group => {
                        AppContext.deleteFromGroupItemCount(group, 1);
                    });
                }
                else {
                    setShowErrorRemovingFromGroup(true);
                }
            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
                setShowErrorRemovingFromGroup(true);
            })
            .finally(() => {
                setIsRemovingFromGroup(false);
            });
    };




    const handleDeselectAll = () => {
        setSelectedGroups([]);
    };




    const handleChangeOption = (event) => {
        setSelectedGroupId(event.target.value);
    };




    return (<>

        {isLoadingReferenceGroups ? <>

            Loading reference folders...

        </> : <>

                {referenceGroups.length != 0 ?
                    <>
                        This reference is in the following folders:
                        <br />
                        <br />
                        <div style={{ display: "flex", flexDirection: "column" }}>

                            {showRemoveGroups ?

                                    referenceGroups.map((group, index) => (

                                        <div key={index} style={{ display: "flex", flexDirection: "row" }}>
                                            <div style={{ width: "20px" }}>
                                                <input name="selectedGroups" onChange={handleCheckboxChange} checked={selectedGroups.includes(group.Id)} value={group.Id} type="checkbox" />
                                            </div>
                                            <div>{group.Name}</div>
                                        </div>

                                    ))

                                :

                                referenceGroups.map((group, index) => (

                                    <div key={index} style={{ display: "flex", flexDirection: "row" }}>
                                        <div>
                                            <ul style={{
                                                padding: "0px 15px",
                                                margin: "0px"}}>
                                                <li>
                                                    {group.Name}
                                                </li>
                                            </ul>
                                        </div>
                                        
                                    </div>

                                ))
                                }

                        </div>

                    </> : <>

                        Add this reference to a folder

                    </>
                }

                <br />


                {AppContext.userRole == "Admin" ? <>

                    <div style={{display: "flex", flexDirection: "column"}}>
                        <div>

                            {AppContext.drawGroupsDropdown()}

                        </div>
                        <div style={{ marginTop: "15px" }}>

                            {(showErrorAddingToGroup || showErrorRemovingFromGroup) && <div>An error occurred. Please try again</div> }

                            {isAddingToGroup ?
                                <LoadingSpinnerImage />
                                :
                                <button onClick={addToGroup} className="action-button save-button">Add to folder</button>
                            }

                            {!showRemoveGroups &&
                                <button onClick={() => setShowRemoveGroups(!showRemoveGroups)} className="action-button save-button">Edit folders</button>
                            }
        
                            {showRemoveGroups && selectedGroups.length > 0 &&

                                <>
                                    {isRemovingFromGroup ? 
                                        <LoadingSpinnerImage />
                                        : 
                                        <button className="action-button delete-button" style={{ marginLeft: "15px" }} onClick={removeFromSelectedGroups}>Remove from selected folders</button>
                                    }

                                </>

                            }
                        </div>
                    </div>

                </> : null}


                

        </>}

        

    </>)
}





const GroupsMenu = () => {

    const AppContext = useContext(FileManagerAppContext);
    const [showGroupMenu, setShowGroupMenu] = useState(null);
    const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });
    const [selectedItemId, setSelectedItemId] = useState(null);


    const expandItem = (id) => {

        let groups = AppContext.groups.map(item => item.Id == id ? { ...item, Expanded: true } : item);
        AppContext.setGroups(groups);
    }

    const collapseItem = (id) => {

        let groups = AppContext.groups.map(item => item.Id == id ? { ...item, Expanded: false } : item);
        AppContext.setGroups(groups);
    }


    const handleIconClick = (event, itemId) => {
        // Prevent the default behavior of the event
        event.preventDefault();

        // Get the position of the clicked icon
        const rect = event.target.getBoundingClientRect();

        // Set the position of the contextual menu
        setMenuPosition({
            top: rect.bottom + window.scrollY,
            left: rect.left + window.scrollX,
        });


        // Set the selected item ID
        setSelectedItemId(itemId);

        // Show the contextual menu
        AppContext.setIsFoldersContextMenuVisible(true);
    };

    const handleMenuClose = () => {
        AppContext.setIsFoldersContextMenuVisible(false);
    };

    const handleAdd = () => {
        AppContext.setSelectedParentGroupId(selectedItemId);
        AppContext.closeGroupRelatedPopups();
        AppContext.setShowCreateGroupPopup(true);

        handleMenuClose();
    };

    const handleEdit = () => {
        AppContext.closeGroupRelatedPopups();
        AppContext.setIsEditingGroupId(selectedItemId);
        AppContext.setShowEditGroupPopup(true);

        handleMenuClose();
    };



    const drawGroupsMenuOptions = (parentId, level) => {


        let groupOptions = AppContext.groups.filter(group => group.ParentId == parentId).sort((a, b) => a.Name.localeCompare(b.Name, undefined, { sensitivity: 'base' })); 


        if (groupOptions.length == 0)
            return;


        let indentation = level == 0 ? "0px" : "15px";

        return (

            groupOptions.map((item, index) => {

                let isEditingOrRemoving = false;

                return (

                        <div key={index} style={{ paddingLeft: indentation }}>

                            <div className={`reference-manager-menu-option-group ${AppContext.selectedMainMenuOption == "group" && AppContext.currentGroupId == item.Id ? "selected-main-menu-option-group" : ""}`} style={{

                            display: "flex",
                            flexDirection: "column",
                            border: isEditingOrRemoving ? "1px solid #eeeeee" : "none",
                            backgroundColor: isEditingOrRemoving ? "#f4f5f7" : "",
                            color: isEditingOrRemoving ? "#555" : "",
                            padding: isEditingOrRemoving ? "9px" : "",
                            borderRadius: isEditingOrRemoving ? "10px" : "",

                        }}
                            onMouseEnter={() => setShowGroupMenu(item.Id)}
                            onMouseLeave={() => setShowGroupMenu(null)}
                        >

                            
                            <div style={{ display: "flex", flexDirection: "row" }}>

                                <div style={{ width: "80%", textAlign: "left" }} >

                                    <div className="pointer" onClick={() => { expandItem(item.Id); AppContext.navigateTo({ menu: "group", groupId: item.Id }); }}>
                                        {(() => {

                                            let hasChildren = AppContext.groups.find(child => child.ParentId == item.Id);

                                            return (<><i className={item.Expanded && hasChildren ? "fas fa-folder-open" : "far fa-folder"} style={{ height: "14px", width: "13px", color: "#a09d9d" }}></i> {item.Name} <span style={{ color: "#a09d9d" }}>({item.Count})</span></>);

                                        })()}
                                        
                                    </div>

                                </div>

                                <div style={{ width: "10%", textAlign: "center" }}>

                                    {showGroupMenu === item.Id && AppContext.userRole == "Admin" ? <>
                                        <span
                                            className="pointer" style={{ padding: "0px 8px" }}

                                            ref={(el) => {
                                                if (el) {
                                                  // Add the element to iconRefs.current if it's not null
                                                  AppContext.folderContextMenuIconRefs.current[item.id] = el;
                                                } else {
                                                  // Remove the element from iconRefs.current if it's null (unmounting)
                                                  delete AppContext.folderContextMenuIconRefs.current[item.id];
                                                }
                                              }}

                                            onClick={(e) => {
                                                handleIconClick(e, item.Id);
                                                
                                        }}>
                                            <i title="Options" className="fas fa-ellipsis-v"></i>
                                        </span>
                                        </> : null}

                                </div>

                                <div style={{ width: "10%", textAlign: "center" }}>

                                    {/* Does it have children? Show expansion arrow */}
                                    {AppContext.groups.find(child => child.ParentId == item.Id) ? <>

                                        {item.Expanded ? <>
                                            <span style={{ cursor: "pointer" }} onClick={() => collapseItem(item.Id)}>
                                                <i className="fas fa-angle-down" style={{ color: "#8e8e8e" }}></i>
                                            </span>
                                        </> : <>
                                            <span style={{ cursor: "pointer" }} onClick={() => expandItem(item.Id)}>
                                                <i className="fas fa-angle-right" style={{ color: "#8e8e8e" }}></i>
                                            </span>
                                        </>}

                                    </> : null}

                                </div>
                                    

                            </div>
                            

                        </div>

                            {item.Expanded ? drawGroupsMenuOptions(item.Id, level+1) : null}

                        </div>


                )
            }
            )

        );

    }


    
    return (<div className="thin-scrollbar" style={{overflow: "auto"}}>
        {drawGroupsMenuOptions(null, 0)}


        {AppContext.isFoldersContextMenuVisible && (
        <div
            ref={AppContext.folderContextMenuRef}
            style={{
                position: 'fixed',
                top: menuPosition.top,
                left: menuPosition.left,
                backgroundColor: 'white',
                border: '1px solid #ccc',
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                zIndex: 1000,
                borderRadius: "5px",
                overflow: "hidden",
              }}
        >
            <div
                className="folder-context-menu-option"
                style={{ display: "flex", flexDirection: "row", padding: '5px 10px', cursor: 'pointer' }}
                onClick={handleAdd}
            >
                <div><i className="fas fa-plus-circle" style={{ color: "#969696", marginRight: "5px" }}></i></div>
                <div>Add sub-folder</div>
            </div>
            <div
                className="folder-context-menu-option"
                style={{ display: "flex", flexDirection: "row", padding: '5px 10px', cursor: 'pointer' }}
                onClick={handleEdit}
                >
                <div><i className="fas fa-pencil-alt" style={{ color: "#969696", marginRight: "5px" }}></i></div>
                <div>Edit folder</div>
            </div>
        </div>
    )}

    </div>)

    


}





const FileManagerMenu = ({ menu, style }) => {
    const AppContext = useContext(FileManagerAppContext);

    return (
        <>
            {AppContext.isLoadingMenu ? (
                <>
                    <div style={{ ...style, textAlign: "center" }}>
                        <LoadingSpinnerImage />
                    </div>
                </>
            ) : (
                <>
                    <div className="thin-scrollbar" style={{ ...style, marginTop: "15px"}}>

                            <div style={{display: "flex", flexDirection: "column", maxHeight: "calc(100vh - 94px)"}}>

                                <div className={`reference-manager-menu-option pointer ${AppContext.selectedMainMenuOption == "all" ? "selected-main-menu-option" : ""}`} onClick={() => AppContext.navigateTo({ menu: "all" })}>
                                    <div style={{display: "flex", flexDirection: "row", width: "100%"}}>
                                        <div style={{ flex: 1 }}>
                                            <i className="g-mr-8 fas fa-book-open"></i> All References
                                        </div>
                                        {AppContext.countsForMainMenuOptions ? 
                                            <div style={{ width: "50px", textAlign: "center" }} >
                                                <span style={{ fontSize: "9pt", borderRadius: "15px", backgroundColor: "rgb(240, 240, 240)", padding: "0px 9px" }} >{AppContext.countsForMainMenuOptions.AllReferencesCount}</span>
                                            </div>
                                            : null
                                        }
                                    </div>
                                </div>
                                <div className={`reference-manager-menu-option pointer ${AppContext.selectedMainMenuOption == "recentlyadded" ? "selected-main-menu-option" : ""}`} onClick={() => AppContext.navigateTo({ menu: "recentlyadded" })}>
                                    <div style={{display: "flex", flexDirection: "row", width: "100%"}}>
                                        <div style={{ flex: 1 }}>
                                            <i className="g-mr-8 far fa-clock"></i> Recently Added
                                        </div>
                                        {AppContext.countsForMainMenuOptions ? 
                                            <div style={{ width: "50px", textAlign: "center" }} >
                                                <span style={{ fontSize: "9pt", borderRadius: "15px", backgroundColor: "rgb(240, 240, 240)", padding: "0px 9px" }} >{AppContext.countsForMainMenuOptions.RecentReferencesCount}</span>
                                            </div>
                                            : null
                                        }
                                    </div>
                                </div>
                                <div className={`reference-manager-menu-option pointer ${AppContext.selectedMainMenuOption == "favorites" ? "selected-main-menu-option" : ""}`} onClick={() => AppContext.navigateTo({ menu: "favorites" })}>
                                    <div style={{display: "flex", flexDirection: "row", width: "100%"}}>
                                        <div style={{ flex: 1 }}>
                                            <i className="g-mr-8 far fa-star"></i> Favorites
                                        </div>
                                        {AppContext.countsForMainMenuOptions ? 
                                            <div style={{ width: "50px", textAlign: "center" }} >
                                                <span style={{ fontSize: "9pt", borderRadius: "15px", backgroundColor: "rgb(240, 240, 240)", padding: "0px 9px" }} >{AppContext.countsForMainMenuOptions.FavoriteReferencesCount}</span>
                                            </div>
                                            : null
                                        }
                                    </div>
                                </div>
                                <div className={`reference-manager-menu-option pointer ${AppContext.selectedMainMenuOption == "trash" ? "selected-main-menu-option" : ""}`} onClick={() => AppContext.navigateTo({ menu: "trash" })}>
                                    <div style={{display: "flex", flexDirection: "row", width: "100%"}}>
                                        <div style={{ flex: 1 }}>
                                            <i className="g-mr-8 far fa-trash-alt"></i> Trash
                                        </div>
                                        {AppContext.countsForMainMenuOptions ? 
                                            <div style={{ width: "50px", textAlign: "center" }} >
                                                <span style={{ fontSize: "9pt", borderRadius: "15px", backgroundColor: "rgb(240, 240, 240)", padding: "0px 9px" }} >{AppContext.countsForMainMenuOptions.TrashReferencesCount}</span>
                                            </div>
                                            : null
                                        }
                                    </div>
                                </div>
                                <div className={`reference-manager-menu-option pointer ${AppContext.selectedMainMenuOption == "duplicates" ? "selected-main-menu-option" : ""}`} onClick={() => AppContext.navigateTo({ menu: "duplicates" })}>
                                    <div style={{display: "flex", flexDirection: "row", width: "100%"}}>
                                        <div style={{ flex: 1 }}>
                                            <i className="g-mr-8 far fa-clone"></i> Duplicates
                                        </div>
                                        {AppContext.countsForMainMenuOptions ? 
                                            <div style={{ width: "50px", textAlign: "center" }} >
                                                <span style={{ fontSize: "9pt", borderRadius: "15px", backgroundColor: "rgb(240, 240, 240)", padding: "0px 9px" }} >{AppContext.countsForMainMenuOptions.DuplicatesReferencesCount}</span>
                                            </div>
                                            : null
                                        }
                                    </div>
                                </div>



                                <div className="reference-manager-menu-header" style={{ marginTop: "30px" }}>
                                    <div style={{ display: "flex", flexDirection: "row"}}>
                                        <div><i className="g-mr-8 fas fa-book"></i> Libraries</div>
                                        <div>

                                            <div className="reference-manager-menu-option-new-group">
                                                {AppContext.userRole == "Admin" ? <>
                                                        <div className="pointer" title="Add a new folder" onClick={() => { AppContext.setSelectedParentGroupId(AppContext.currentGroupId); AppContext.closeGroupRelatedPopups(); AppContext.setShowCreateGroupPopup(true); }}>
                                                            <span alt="Add a new folder" style={{ padding: "0px 2px", borderRadius: "15px", backgroundColor: "#f6fcff" }} >
                                                                <i className="fas fa-plus-circle g-mr-5" style={{ color: "#3da5f7" }}></i>
                                                            </span>
                                                        </div>
                                                    </> : <>
                                                        &nbsp;
                                                    </>}

                                            </div>


                                        </div>
                                    </div>
                                    
                                </div>

                                

                                <GroupsMenu />


                            </div>

                    </div>
                    
                </>
            )}
        </>
    );
};


const FileManagerContent = ({ style }) => {
    const AppContext = useContext(FileManagerAppContext);

    return (
        <>
            <div style={{ display: "flex", flexDirection: "column", ...style }}>
                <Header />

                {AppContext.fileView == "table" && <FileManagerTable />}
                
            </div>
        </>
    );
};

//#header

const Header = () => {
    const AppContext = useContext(FileManagerAppContext);

    const currentCompletionStatusRef = useRef(null);

    const [isOptionsPopupVisible, setIsOptionsPopupVisible] = useState(false);
    const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });
    const optionButtonRef = useRef(null);
    const optionsPopupRef = useRef(null);

    let isInTrashMenu = AppContext.selectedMainMenuOption == "trash";


    const handleOptionButtonClick = () => {
        if (optionButtonRef.current) {
            const rect = optionButtonRef.current.getBoundingClientRect();
            setPopupPosition({
                top: rect.bottom + window.scrollY + 5,
                left: rect.left + window.scrollX,
            });
        }
        setIsOptionsPopupVisible(!isOptionsPopupVisible);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (optionButtonRef.current && !optionButtonRef.current.contains(event.target) &&
                optionsPopupRef.current && !optionsPopupRef.current.contains(event.target))
            {
                setIsOptionsPopupVisible(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);



    const showActionPopup = (type) => {

        setIsOptionsPopupVisible(false);

        AppContext.closeAllPopups();


        if (type == "export")
            AppContext.setShowExportSelectedReferencesPopup(true);

        if(type == "add")
            AppContext.setShowAddSelectedReferencesToGroupPopup(true);

        if (type == "delete") {
            AppContext.setSuccessDeleting(false);
            AppContext.setIsDeleting(false);
            AppContext.setErrorDeleting(false);
            AppContext.setShowDeleteSelectedReferencesPopup(true);
        }

    }


    const handleMultipleItemsAIChatButtonClick = () => {

        AppContext.toggleMultiItemAIChatPane();

    }


    return (

        <div
            style={{
                display: "flex",
                flexDirection: "row",
                marginBottom: "20px"
            }}
        >
            <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                {!AppContext.isSlimVersion && (
                    <>
                        <div style={{ width: "100%" }}>
                            <Breadcrumbs />
                        </div>

                        <div style={{ width: "100%", textAlign: "left", marginBottom: "20px"}}>
                            <h3 style={{ color: "#203864" }}>
                                <EntityTypeIcon entityType={AppContext.currentEntityType} />
                                <span style={{marginLeft: "10px"}}>{AppContext.whereAmI}</span>
                            </h3>
                        </div>

                    </>
                )}

                {/* DISPLAY VIEW */}

                <div
                    style={{
                        display: "none",
                        width: "100%",
                        flexDirection: "row",
                        marginBottom: "15px"
                    }}
                >
                    <div
                        style={{
                            cursor: "pointer",
                            paddingBottom: "3px",
                            paddingRight: "10px",
                            ...(AppContext.fileView == "table"
                                ? { borderBottom: "2px solid #00abff" }
                                : { borderBottom: "2px solid #f0f0f0" })
                        }}
                        onClick={() => AppContext.setFileView("table")}
                    >
                        <i className="fas fa-table"></i> Table View
                    </div>

                    <div style={{ flex: 1, borderBottom: "2px solid #f0f0f0" }}></div>
                </div>

                {/* CONTENT */}

                <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
                    <div
                        style={{
                            display: "flex",
                            flexGrow: 1,
                            alignItems: "center"
                        }}
                    >
                        {/* Search */}

                        <div className="search-input" style={{ width: "300px" }}>
                            <span className="search-icon">
                                <i className="fas fa-search"></i>
                            </span>
                            <input
                                style={{width: "250px"}}
                                placeholder="Search title, authors, source or year"
                                value={AppContext.objectSearchText}
                                onChange={(e) => {
                                    if (!AppContext.isLoadingReferences) {
                                        let text = e.target.value;
                                        AppContext.setObjectSearchText(text);
                                        AppContext.doTextSearchObject({ localSearch: text });
                                    }
                                }}
                            />
                        </div>


                       


                    </div>





                    {AppContext.selectedReferences.length > 0 && (() => {
                        const isOverLimit = AppContext.selectedReferences.length > 10;

                        return (
                            <>
                                <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                    <span style={{ fontWeight: "bold" }}>
                                        {AppContext.selectedReferences.length} selected item(s)
                                    </span>

                                    <div
                                        style={{
                                            display: "flex",
                                            textAlign: "center",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            marginLeft: "5px",
                                            marginRight: "15px",
                                            minWidth: "100px",
                                            position: "relative"
                                        }}
                                    >
                                        <span
                                            title={isOverLimit ? "Max 10 references allowed" : ""}
                                            onClick={isOverLimit ? null : handleMultipleItemsAIChatButtonClick}
                                            style={{ cursor:  "pointer" }}
                                        >
                                            <span
                                                className={`medboard-ai-analyzer-button g-ml-10 ${isOverLimit ? "disabled-opacity" : "pointer"}`}
                                                style={{
                                                    opacity: isOverLimit ? 0.5 : 1,
                                                    filter: isOverLimit ? "grayscale(1)" : "none"
                                                }}
                                            >
                                                <img
                                                    src="/assets/images/stars-stroke-rounded-solid.svg"
                                                    className="ai-icon"
                                                    style={{ width: '19px', marginTop: '-3px', marginRight: '5px' }}
                                                    alt="AI icon"
                                                />
                                                Ask AI
                                            </span>
                                        </span>
                                    </div>

                                    <div
                                        style={{
                                            display: "flex",
                                            textAlign: "center",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            marginLeft: "5px",
                                            marginRight: "15px",
                                            minWidth: "100px",
                                        }}
                                    >
                                        <span ref={optionButtonRef} onClick={handleOptionButtonClick}>
                                            <span className="pointer sr-menubar-button ellipsis" style={{ fontSize: "13px", fontWeight: "600", padding: "5px 15px 7px 15px" }}>
                                                Actions <i className="fas fa-caret-down g-ml-3"></i>
                                            </span>
                                        </span>

                                        {isOptionsPopupVisible && (
                                            <div
                                                ref={optionsPopupRef}
                                                style={{
                                                    position: 'fixed',
                                                    top: `${popupPosition.top}px`,
                                                    left: `${popupPosition.left}px`,
                                                    backgroundColor: 'white',
                                                    border: '1px solid #ccc',
                                                    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                                                    zIndex: 1000,
                                                }}
                                            >
                                                <div className="multiple-selected-menu-option" onClick={() => { showActionPopup("export"); }}>Export</div>

                                                {AppContext.userRole == "Admin" ?
                                                    <div className="multiple-selected-menu-option" onClick={() => { showActionPopup("add"); }}>Add to group</div>
                                                    :
                                                    <div className="multiple-selected-menu-option-disabled" title="No permission. Contact your Admin.">Add to group</div>
                                                }

                                                {AppContext.userRole == "Admin" ?
                                                    <div className="multiple-selected-menu-option" onClick={() => { showActionPopup("delete"); }}>{isInTrashMenu ? "Delete" : "Move to trash"}</div>
                                                    :
                                                    <div className="multiple-selected-menu-option-disabled" title="No permission. Contact your Admin.">{isInTrashMenu ? "Delete" : "Move to trash (No permission)"}</div>
                                                }
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </>
                        );
                    })()}




                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "15px" }} >
                        <RIMSFilter entityTypeId={AppContext.entityTypeId} currentFilters={AppContext.currentRIMSFilters} searchCallback={AppContext.rimsSearchCallback} />
                        <TagFilter />
                    </div>






                    {/* Add Reference */}

                    <div
                        style={{
                            display: "flex",
                            textAlign: "center",
                            justifyContent: "center",
                            alignItems: "center",
                            minWidth: "150px",
                        }}
                    >

                        {AppContext.reachedAllowance ? <>

                            <span>
                                <span className="action-button add-task-button" style={{backgroundColor: "#c0c0c0", cursor: "help"}} title="Allowance limit reached. Contact MedBoard to increase the limit.">
                                    <i className="fas fa-plus-circle g-mr-5"></i> Add Reference
                                </span>
                            </span>

                        </> : <>

                            {AppContext.userRole == "Admin" ? <>
                                <span onClick={() => { AppContext.showAddFilePopup(); }}>
                                    <span className="action-button add-task-button">
                                        <i className="fas fa-plus-circle g-mr-5"></i> Add Reference
                                    </span>
                                </span>
                            </> : <>
                                <span>
                                    <span className="action-button add-task-button" style={{backgroundColor: "#c0c0c0"}} title="No permission. Contact your Admin.">
                                            <i className="fas fa-plus-circle g-mr-5"></i> Add Reference
                                    </span>
                                </span>
                            </>}

                        </>}





                    </div>


                </div>  
            </div>
        </div>


    );
};


const CommentList = ({ fileId }) => {

    const AppContext = useContext(FileManagerAppContext);

    const [addCommentText, setAddCommentText] = useState("");
    const [isLoadingObjects, setIsLoadingObjects] = useState(false);
    const [itemsPerPage, setItemsPerPage] = useState(2);
    const [errorAddCommentText, setErrorAddCommentText] = useState(null);
    const [isAddingComment, setIsAddingComment] = useState(false);
    const [errorAddingComment, setErrorAddingComment] = useState(false);
    const [editedComment, setEditedComment] = useState(null);
    const useDummy = false;


    const validFormField = (field, errorFunc) => {
        if (field == "") {
            errorFunc(true);
            return false;
        }
        errorFunc(false);
        return true;
    };

    const saveComment = () => {
        console.log("comment for fileID " + fileId + ": " + addCommentText);

        let addCommentURL = "/umbraco/api/FileManagerApi/Comment/";

        let newComment = {
            Text: addCommentText,
            FileId: fileId,
        };

        let method = "POST";

        // Is it a comment edit?
        if (editedComment != null) {
            newComment["Id"] = editedComment.Id;
            method = "PUT";
        }

        const requestOptions = {
            method: method,
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(newComment)
        };

        // Validations

        let isValidForm = true;

        setErrorAddCommentText(false);
        setErrorAddingComment(false);


        if (!validFormField(addCommentText, setErrorAddCommentText)) isValidForm = false;


        if (!isValidForm) return false;

        setIsAddingComment(true);

        fetch(addCommentURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                // Update state with the received data
                if (data.Id) {
                    let newCommentList = [data, ...AppContext.comments];
                    AppContext.setComments(newCommentList);
                    setAddCommentText("");
                    setErrorAddingComment(false);
                }
                else {
                    console.log("error: ");
                    console.log(data);
                    setErrorAddingComment(true);
                }
            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
                setErrorAddingComment(true);
            })
            .finally(() => {
                setIsAddingComment(false);
            });


    }


    const deleteComment = (objectCommentId) => {

        console.log("Delete comment " + objectCommentId);



        let deleteCommentURL =
            `/umbraco/api/FileManagerApi/Comment?` +
            `commentId=${encodeURIComponent(objectCommentId)}&`;

        let method = "DELETE";

        const requestOptions = {
            method: method,
            headers: { "Content-Type": "application/json" },
        };


        fetch(deleteCommentURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                if (data) {
                    let newCommentList = AppContext.comments.filter((item) => item.Id != objectCommentId);
                    AppContext.setComments(newCommentList);
                }
            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {

            });


    }


    const editComment = (objectCommentId) => {

        let comment = AppContext.comments.find((item) => item.Id == objectCommentId);

        if (comment) {
            console.log("Edit comment " + objectCommentId);
            console.log(comment);
            setEditedComment(comment);
            setAddCommentText(comment.Text);
        }
        else {
            console.log(`Comment ${objectCommentId} not found`);
        }
    }


    /* SCROLLING BEHAVIOUR */

    const ref = useRef();
    const isVisible = useIsVisible(ref);

    function useIsVisible(ref) {
        const [isIntersecting, setIntersecting] = useState(false);

        useEffect(() => {
            const observer = new IntersectionObserver(([entry]) =>
                setIntersecting(entry.isIntersecting),
            );

            observer.observe(ref.current);
            return () => {
                observer.disconnect();
            };
        }, [ref]);

        console.log("isVisible? ", isIntersecting);

        return isIntersecting;
    }


    useEffect(() => {
        if (isVisible && AppContext.fileHasMoreComments && !isLoadingObjects) {
            loadObjects({ nextPage: true });
        }
    }, [isVisible]);


    const loadObjects = ({
        nextPage = false,
    } = {}) => {

        if (isLoadingObjects) return;

        if (!AppContext.fileHasMoreComments) return;

        setIsLoadingObjects(true);

        let local_objects = AppContext.comments;
        let local_objects_page = AppContext.commentsPage;

        if (nextPage == false) {
            local_objects = [];
            local_objects_page = 0;
            AppContext.setComments(local_objects);
            AppContext.setCommentsPage(local_objects_page);
            AppContext.setFileHasMoreComments(true);
        } else {
            local_objects_page++;
            AppContext.setCommentsPage(local_objects_page);
        }


        let loadObjectsURL =
            `/umbraco/api/FileManagerApi/Comment?` +
            `fileId=${fileId}&` +
            `page=${encodeURIComponent(local_objects_page)}&`;
        ;

        let requestOptions = {};

        if (useDummy) {
            loadObjectsURL = "https://dummyjson.com/products/search?q=dummy_" + fileId + "_page_" + local_objects_page;
            requestOptions = {};
        }

        fetch(loadObjectsURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    AppContext.setFileHasMoreComments(false);
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {

                if (useDummy) {
                    data = [];
                    let returnNrItems = itemsPerPage;
                    if (local_objects.length >= 2) returnNrItems = 0;
                    for (let i = 0; i < returnNrItems; i++) {
                        let rnd = Math.round(Math.random() * 99999);
                        data.push({ Id: rnd, Text: "Hello this is a comment", CreatedBy: 71975, CreatedDate: "2023-11-16 10:56", Edited: Math.round(Math.random()) },);
                    }
                }


                if (data.length > 0) {
                    // Was it a fetch more request? Then append to objects.
                    if (nextPage) {
                        let res = [...local_objects, ...data];
                        AppContext.setComments(res);
                    } else {
                        AppContext.setComments(data);
                    }
                }
                else {
                    AppContext.setFileHasMoreComments(false);
                }


            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                AppContext.setFileHasMoreComments(false);
            })
            .finally(() => {
                setIsLoadingObjects(false);
            });
    };


    return (<>

        {/* Comment form */}

        <div style={{ display: "flex", flexDirection: "column", }}>
            <div style={{ display: "flex", flexDirection: "row", }}>
                <div><User value={AppContext.currentUserId} /> {editedComment != null && editedComment.Edited == 1 ? "(edited)" : null}</div>
                <div style={{ display: "flex", flexDirection: "column", flex: 1, width: "100%", marginLeft: "10px", }}>

                    {editedComment != null ? <>
                        <div style={{ fontSize: "0.8em", color: "#999" }}>Editing comment: "<span style={{ fontStyle: "italic" }}>{AppContext.comments.find((item) => item.Id == editedComment.Id)?.Text.substring(0, 100)}...</span>"</div>
                    </> : null}

                    <textarea className={`addCommentTextBox form-field-text ${errorAddCommentText ? "form-field-error" : ""}`}
                        onChange={(e) => setAddCommentText(e.target.value)}
                        placeholder="Add a comment"
                        defaultValue={addCommentText}
                        value={addCommentText}
                    ></textarea>

                    {errorAddCommentText && (
                        <span className="form-field-error-message">
                            The field Comment is necessary
                        </span>
                    )}

                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", marginTop: "10px", }}>

                        {isAddingComment ? <>

                            <div>
                                <LoadingSpinnerImage />
                            </div>

                        </> : <>

                            <div>
                                <button onClick={saveComment} className="action-button save-button">Save comment</button>
                            </div>

                            {errorAddingComment && <div>
                                An error occurred...
                            </div>}

                        </>}

                    </div>
                </div>
            </div>
        </div>



        <div style={{ marginTop: "20px", marginBottom: "20px" }}></div>

        <div className="thin-scrollbar" style={{ maxHeight: "100vh", overflow: "auto", paddingRight: "10px", }}>

            {/* Comment list */}

            {AppContext.comments.length > 0 && <>

                {AppContext.comments.map((comment) => <Comment key={comment.Id} comment={comment} deleteCommentFunc={deleteComment} editCommentFunc={editComment} />)}

            </>}

            {/* Loading and no-more-results row */}

            {isLoadingObjects ? (
                <div style={{ textAlign: "center" }}>
                    <LoadingSpinnerImage />
                </div>
            ) :
                <>
                    {!AppContext.fileHasMoreComments && (
                        <div className="no-more-results">{AppContext.comments.length > 0 ? "No more comments" : "No comments"}</div>
                    )}
                </>
            }

            <div ref={ref}></div>

        </div>

        <div style={{ minHeight: "20px" }}></div>

    </>);

};





const Comment = ({ comment, deleteCommentFunc, editCommentFunc }) => {

    const AppContext = useContext(TaskManagerAppContext);

    const [isShowingDeleteCommentButton, setIsShowingDeleteCommentButton] = useState(false);
    const [isShowingOptions, setIsShowingOptions] = useState(false);
    const [isDeletingComment, setIsDeletingComment] = useState(false);

    const showOptions = (status) => {
        setIsShowingDeleteCommentButton(false);
        setIsShowingOptions(status);
        setIsDeletingComment(false);
    }

    let userId = comment.CreatedBy;
    let user = AppContext.getUserById(userId);
    let commentText = comment.Text;
    let date = AppContext.formatDate(comment.CreatedDate, true);
    let commentId = comment.Id;

    return (<>

        <div style={{ display: "flex", flexDirection: "row", }}>
            <div><User value={userId} /></div>
            <div style={{ display: "flex", flexDirection: "column", flex: 1, marginLeft: "10px", }}>
                <div style={{ display: "flex", flexDirection: "row", width: "100%", }}>
                    <div style={{ flex: 1, fontWeight: "bold" }}>{user?.Name}</div>
                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                        {/* Date */}
                        <div style={{ color: "#a8a8a8", marginRight: "5px" }}>{date}</div>

                        {userId == AppContext.currentUserId ? <>

                            {/* Options */}
                            <div style={{ display: "flex", flexDirection: "row" }}>

                                {isShowingOptions ? <>

                                    {!isShowingDeleteCommentButton &&
                                        <div>
                                            <button onClick={() => setIsShowingDeleteCommentButton(true)} className="action-button options-button" title="Delete comment"><i className="fas fa-trash-alt"></i></button>
                                        </div>
                                    }

                                    {isShowingDeleteCommentButton &&
                                        <>
                                            {isDeletingComment ? <>
                                                <div>
                                                    <LoadingSpinnerImage />
                                                </div>
                                            </> : <>
                                                <div>
                                                    <button onClick={() => { setIsDeletingComment(true); deleteCommentFunc(commentId); }} className="action-button delete-button" title="Confirm deletion"><i className="fas fa-trash-alt"></i> Yes, delete</button>
                                                </div>
                                            </>}
                                        </>
                                    }

                                    {/*
                                <div>
                                    <button onClick={() => editCommentFunc(commentId)} className="action-button options-button" title="Edit comment"><i className="fas fa-pencil-alt"></i></button>
                                </div>
                                */}
                                    <div>
                                        <button onClick={() => showOptions(false)} className="action-button options-button" title="Cancel">Cancel</button>
                                    </div>
                                </> : <>
                                    {
                                        <div>
                                            <button onClick={() => showOptions(true)} className="action-button options-button" title="Show options"><i className="fas fa-ellipsis-v"></i></button>
                                        </div>
                                    }
                                </>}

                            </div>

                        </> : <>

                            {/* Empty space for when the user is not the owner of the comment to align with the rest of the dates */}
                            <div style={{ width: "40px" }}></div>

                        </>}

                    </div>
                </div>
                <div>{commentText}</div>
            </div>
        </div>

        <div style={{ marginTop: "20px", borderTop: "1px solid #f3f3f3", marginBottom: "20px" }}></div>

    </>);

};


const FileManagerTable = () => {
    const AppContext = useContext(FileManagerAppContext);
    let references = AppContext.references;
    let header = [];

    header.push({ name: "", field: "Id", width: "25px", sortable: true  });
    header.push({ name: "Title", field: "Title", width: "42%", sortable: true  });
    header.push({ name: "Authors", field: "Authors", width: "11%", sortable: true  });
    header.push({ name: "Year", field: "Year", width: "6%", sortable: true  });
    header.push({ name: "Source", field: "Source", width: "17%", sortable: true  });
    header.push({ name: "SRs", field: "RelatedAppraisals", width: "9%", sortable: false, disableUpperCase: true });
    header.push({ name: "File", field: "Filename", width: "6%", sortable: true  });
    header.push({ name: "Created", field: "CreatedOn", width: "9%", sortable: true  });

    let headerHeight = 320;
    let maxHeight = (windowHeight - headerHeight) + "px";

    // Try this
    maxHeight = "100vh";


    // SCROLLING BEHAVIOUR

    const targetRef = useRef(null);

    useEffect(() => {

        // If its the first time is loading references there might be a race condition that replaces the first results. This is to avoid that situation (tentative fix)
        if (AppContext.isFirstLoadingReferences.current == true) {
            AppContext.isFirstLoadingReferences.current = false;
            return;
        }

        // Check if the targetRef is visible
        const observer = new IntersectionObserver(
            ([entry]) => {

                // It's visible?
                if (entry.isIntersecting) {

                    if (AppContext.hasMoreData && !AppContext.isLoadingReferences) {
                        AppContext.loadReferences({ nextPage: true, localTrash: AppContext.currentTrash, localGroupId: AppContext.currentGroupId, localFavorites: AppContext.currentFavorites, localRecent: AppContext.currentRecent, localDuplicates: AppContext.currentDuplicates, });
                    }

                }

            },
            { threshold: 0 } // Adjust the threshold as needed
        );

        if (targetRef.current) {
            observer.observe(targetRef.current);
        }

        return () => {
            if (targetRef.current) {
                observer.unobserve(targetRef.current);
            }
        };
    }, [AppContext.isLoadingReferences]);
    




    const handleMainListSelect = (event) => {
        const value = parseInt(event.target.value);

        if (event.target.checked) {
            // Add the value to the array if the checkbox is checked
            AppContext.setSelectedReferences([...AppContext.selectedReferences, value]);
        } else {
            // Remove the value from the array if the checkbox is unchecked
            AppContext.setSelectedReferences(AppContext.selectedReferences.filter((item) => item !== value));
        }

    };


    

    const handleSelectAllReferences = (event) => {

        if (event.target.checked) {
            // Get and select all references
            AppContext.loadReferences({ nextPage: true, localTrash: AppContext.currentTrash, localGroupId: AppContext.currentGroupId, localFavorites: AppContext.currentFavorites, localRecent: AppContext.currentRecent, localDuplicates: AppContext.currentDuplicates, returnAll: true, selectAll: true});

        } else {
            // Deselect all references
            AppContext.setAllReferencesSelected(false);
            AppContext.setSelectedReferences([]);
        }

    }



    return (
        <div className="thin-scrollbar" style={{
            borderBottom: "1px solid #fdfdfd", maxHeight: maxHeight, overflowX: "auto", paddingBottom: "41px", overflowY: "hidden"
        }}>

            {/* Header row */}

            <div className="datatable-header">
                {header.map((item, index) => {
                    return (

                        index == 0 ?

                            <div key={index}
                                style={{ width: `${item.width}`, cursor: "pointer", }}
                            >
                                <span className="table-column-filter">
                                    {AppContext.showLoadingInsteadOfSelectAllCheckbox ?
                                        <LoadingSpinnerImage small={true} />
                                        :
                                        <input type="checkbox" onChange={handleSelectAllReferences} checked={AppContext.allReferencesSelected} />
                                    }

                                </span>
                            </div>

                            :

                            <div key={index}
                                style={{ width: `${item.width}`, ...(item.sortable ? { cursor: "pointer" } : { cursor: "default" }) }}
                                onClick={() => {
                                    item.sortable ? AppContext.changeObjectListOrderField(item.field) : null
                                    }
                                }
                            >
                                <span
                                    className="table-column-filter"
                                    style={{ ...(item.disableUpperCase ? { textTransform: "none" } : null)}}
                                >
                                    {item.name}
                                    {AppContext.objectListSortByField == item.field ? (
                                        AppContext.objectListSortByType == "ASCENDING" ? (
                                            <i
                                                style={{ marginLeft: "5px" }}
                                                className="fas fa-long-arrow-alt-up"
                                            ></i>
                                        ) : (
                                            <i
                                                style={{ marginLeft: "5px" }}
                                                className="fas fa-long-arrow-alt-down"
                                            ></i>
                                        )
                                    ) : null}
                                </span>
                            </div>

                    )}
                )}
            </div>

            {/* Result rows */}

            <div
                className="datatable-content thin-scrollbar"
                style={{
                    /*maxHeight: `calc(100vh - ${AppContext.windowSpacing})`,*/
                    maxHeight: `100%`,
                    minWidth: "1000px",
                    overflowY: "auto",
                    overflowX: "hidden",
                }}
            >
                <div>
                    {references.map((item, index) => {

                        if (item.ParentTaskId)
                            return;

                        let col = 0;

                        return (
                            <div className="datatable-row" style={{ height: "40px" }} key={index}>
                                <div style={{ width: header[col++].width }}>
                                    <input type="checkbox" name="mainListSelect" checked={AppContext.selectedReferences.includes(item.Id)} value={item.Id} onChange={handleMainListSelect} />
                                </div>
                                <div style={{ width: header[col++].width, cursor: "pointer" }} onClick={(e) => AppContext.loadReferenceDetails(item.Id, e)}>
                                    <div style={{ display: "flex", flexDirection: "row" }} className="ellipsis">
                                        <div title={item.Title} className="ellipsis">
                                            {item.Title}
                                        </div>
                                    </div>
                                </div>
                                <div style={{ width: header[col++].width }}>
                                    <div style={{ display: "flex", flexDirection: "row" }} className="ellipsis">
                                        <div title={item.Authors} className="ellipsis">
                                            {item.Authors}
                                        </div>
                                    </div>
                                </div>
                                <div style={{ width: header[col++].width }}>
                                    {item.Year}
                                </div>
                                <div style={{ width: header[col++].width }}>
                                    <div style={{ display: "flex", flexDirection: "row" }} className="ellipsis">
                                        <div title={item.Source} className="ellipsis">
                                            {item.Source}
                                        </div>
                                    </div>
                                </div>
                                <div style={{ width: header[col++].width }}>
                                    <RelatedReviewsDots relatedReviews={item.RelatedAppraisals} />
                                </div>
                                <div style={{ width: header[col++].width }}>
                                    {item.HasPDF ? <>

                                        {item.FileName != null ? 
                                            <a target="_blank" title={item.FileName} href={`/Umbraco/Api/SurveilanceAppraisal/LoadPdf?surveillanceItemId=${item.MedBoardResourceId}`}><i className="far fa-file-pdf"></i></a>
                                        : 
                                            <i className="far fa-file-pdf"></i>
                                        }

                                        </>
                                    :
                                        null
                                    }
                                </div>
                                <div style={{ width: header[col++].width }}>
                                    <span title={AppContext.readableDate(item.CreatedOn, true, true)}>{AppContext.readableDate(item.CreatedOn, true)}</span>
                                </div>
                            </div>
                        )
                    }
                    )}
                </div>





                {/* Loading and no-more-results row */}

                {AppContext.isLoadingReferences ?
                    <div style={{ textAlign: "center" }}>
                        <LoadingSpinnerImage />
                    </div>
                    :
                    <>
                        {/* If this div is visible it should try to load more files. Either inner div content or minHeight is mandatory for the intersector to work */}
                        <div ref={targetRef} style={{ minHeight: "5px" }}></div>
                    </>
                }

                {!AppContext.hasMoreData ?
                    <>
                        {AppContext.showRefreshLastLoadData ? 
                            <div className="no-more-results" >
                                <span onClick={() => AppContext.loadReferences({ nextPage: true })} style={{ padding: "3px 7px", border: "1px solid #eee", borderRadius: "10px", backgroundColor: "#eff8ff", cursor: "pointer" }}>Reload</span>
                            </div>
                        :
                            <div className="no-more-results">No more files</div>
                        }
                    </>
                : null }




            </div>
        </div>
    );
};


const RelatedReviewsDots = ({ relatedReviews }) => {


    let Pending = relatedReviews.filter(item => item.Status == "Pending").length;
    let NotRelevant = relatedReviews.filter(item => item.Status == "NotRelevant").length;
    let Relevant = relatedReviews.filter(item => item.Status == "Relevant").length;
    let RelevantFullTextNotIncluded = relatedReviews.filter(item => item.Status == "RelevantFullTextNotIncluded").length;
    let RelevantFullTextIncluded = relatedReviews.filter(item => item.Status == "RelevantFullTextIncluded").length;
    

    return (<>

        {RelevantFullTextIncluded > 0 ? <span className="cursor-help related-reviews-dot med-status-relevent-full-text" title="Relevant After Full Review">{RelevantFullTextIncluded}</span> : null}
        {RelevantFullTextNotIncluded > 0 ? <span className="cursor-help related-reviews-dot med-status-ftni" title="Not Relevant After Full Review">{RelevantFullTextNotIncluded}</span> : null}
        {Relevant > 0 ? <span className="cursor-help related-reviews-dot med-status-relevant" title="Relevant After Screening">{Relevant}</span> : null}
        {NotRelevant > 0 ? <span className="cursor-help related-reviews-dot med-status-not-relevant" title="Not Relevant After Screening">{NotRelevant}</span> : null}
        {Pending > 0 ? <span className="cursor-help related-reviews-dot med-status-pending" title="Pending">{Pending}</span> : null}

    </>);


}






const EntityTypeIcon = ({ entityType }) => {

    let AppContext = useContext(FileManagerAppContext);

    let finalClass = "fas fa-book-open";
    let iconFound = "";


    if (AppContext.selectedMainMenuOption == "recentlyadded") finalClass = "far fa-clock";
    if (AppContext.selectedMainMenuOption == "trash") finalClass = "far fa-trash-alt";
    if (AppContext.selectedMainMenuOption == "favorites") finalClass = "far fa-star";
    if (AppContext.selectedMainMenuOption == "duplicates") finalClass = "far fa-clone";
    if (AppContext.selectedMainMenuOption == "group") finalClass = "fas fa-folder-open";

    


    let icons = [
        { entityType: "systematic-review", class: "fas fa-file-signature" },
        { entityType: "systematic-review-group", class: "fas fa-file-signature" },
        { entityType: "product", class: "fas fa-box-open" },
        { entityType: "product-family", class: "fas fa-box-open" },
        { entityType: "product-skus", class: "fas fa-box-open" },
        { entityType: "countryregistration", class: "fas fa-clipboard-list" },
        { entityType: "countryregistration-country", class: "fas fa-clipboard-list" },
        { entityType: "countryregistration-certificate", class: "fas fa-clipboard-list" },
        { entityType: "countryregistration-registration", class: "fas fa-clipboard-list" },
        { entityType: "countryregistration-operator", class: "fas fa-clipboard-list" },
        { entityType: "compliance", class: "fas fa-shield-alt" },
        { entityType: "compliance-qms", class: "fas fa-shield-alt" },
        { entityType: "compliance-technical-documents", class: "fas fa-shield-alt" },
    ];

    iconFound = icons.find((item) => item.entityType == entityType)?.class;

    if (iconFound)
        finalClass = iconFound;





    return (<>
        <i className={`g-mr-8 ${finalClass}`} />
    </>);


}


const Breadcrumbs = () => {
    let AppContext = useContext(FileManagerAppContext);

    return (
        <>
            <div className="breadcrumbs">

            </div>
        </>
    );
};


const User = ({ value, size }) => {
    const AppContext = useContext(FileManagerAppContext);

    let user = AppContext.getUserById(value);

    return (
        <>
            {user ? (
                <div
                    className={
                        "user-initials-circle " +
                        (size == "small" ? "user-initials-circle-small" : "")
                    }
                    style={{ backgroundColor: user?.IsItMe ? "#0176b9" : "#e7e7e7", color: user?.IsItMe ? "white" : "black" }}
                    title={user?.Name}
                >
                    {user?.Initials}
                </div>
            ) : null}
        </>
    );
};











export default FileManagerApp;
